import React from 'react';
import { getAttributes } from '@carbon/icon-helpers';
import PropTypes from 'prop-types';

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

var defaultStyle = {
  willChange: 'transform'
};
var Pictogram = React.forwardRef(function Pictogram(_ref, ref) {
  var className = _ref.className,
      children = _ref.children,
      _ref$style = _ref.style,
      style = _ref$style === void 0 ? {} : _ref$style,
      tabIndex = _ref.tabIndex,
      rest = _objectWithoutProperties(_ref, ["className", "children", "style", "tabIndex"]);

  var _getAttributes = getAttributes(_objectSpread2({}, rest, {
    tabindex: tabIndex
  })),
      tabindex = _getAttributes.tabindex,
      props = _objectWithoutProperties(_getAttributes, ["tabindex"]);

  if (className) {
    props.className = className;
  }

  if (tabindex !== undefined && tabindex !== null) {
    props.tabIndex = tabindex;
  }

  if (ref) {
    props.ref = ref;
  }

  props.style = _objectSpread2({}, defaultStyle, {}, style);
  return React.createElement('svg', props, children);
});
Pictogram.displayName = 'Pictogram';
Pictogram.propTypes = {
  'aria-hidden': PropTypes.string,
  'aria-label': PropTypes.string,
  'aria-labelledby': PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  height: PropTypes.number,
  preserveAspectRatio: PropTypes.string,
  tabIndex: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.number,
  xmlns: PropTypes.string
};
Pictogram.defaultProps = {
  xmlns: 'http://www.w3.org/2000/svg',
  preserveAspectRatio: 'xMidYMid meet'
};

var ActiveServer =
/*#__PURE__*/
React.forwardRef(function ActiveServer(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M11.443 20.635l-1.932-.518M11 24H9m2.443 3.364l-1.932.518m27.046-.518l1.932.518M37 24h2m-2.443-3.365l1.932-.518M32 39H16V9h16v30zM20 13h8m-8 3h8m-8 3h8"
  }), props.children);
});
var Advocate =
/*#__PURE__*/
React.forwardRef(function Advocate(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M9 39c0-6.871 5.229-12.624 11.636-14.143A8.285 8.285 0 0 1 24 9a8.284 8.284 0 1 1 3.364 15.857C33.77 26.376 39 32.129 39 39m-15.001-.999l3.962-3.962a2.357 2.357 0 0 0 .692-1.629 2.358 2.358 0 0 0-.692-1.714 2.356 2.356 0 0 0-1.672-.692 2.36 2.36 0 0 0-1.672.692l-.619.619-.619-.619a2.353 2.353 0 0 0-1.676-.692 2.356 2.356 0 0 0-1.667.692 2.356 2.356 0 0 0-.692 1.682c.003.602.233 1.202.692 1.661l3.963 3.962z"
  }), props.children);
});
var Agriculture =
/*#__PURE__*/
React.forwardRef(function Agriculture(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M21.186 17.796c.659.659.779 1.623.497 2.39-.766.283-1.73.163-2.39-.497-.659-.659-.779-1.623-.497-2.39.767-.282 1.731-.162 2.39.497zm2.133 15.924c-.283.766-.163 1.73.497 2.39.659.659 1.623.779 2.39.497.283-.766.163-1.73-.497-2.39-.66-.66-1.623-.78-2.39-.497zm1.587-4.323c.766.283 1.73.163 2.39-.497.659-.659.779-1.623.497-2.39-.766-.283-1.73-.163-2.39.497-.66.66-.78 1.624-.497 2.39zm-5.173-1.342c-.626.524-1.002 1.42-.759 2.32s1.02 1.484 1.825 1.621c.626-.524 1.002-1.42.759-2.32s-1.02-1.485-1.825-1.621z"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M24.059 16.347h10.497a1.44 1.44 0 0 1 1.443 1.437v0c0 .793-.649 1.443-1.443 1.443H24.059m0 2.885h8.71c.793 0 1.443-.649 1.443-1.443v0c0-.793-.649-1.443-1.443-1.443h-8.71m0-2.879h8.71a1.455 1.455 0 0 0 1.443-1.448v0c0-.793-.649-1.443-1.443-1.443H19.018l2.531-1.69c.664-.466.92-.839.92-1.39 0-.668-.461-1.378-1.374-1.378-.446 0-.826.119-1.327.401l-3.577 2.033c-3.328 1.918-5.193 4.041-5.193 7.666 0 3.699 2.794 5.879 5.708 5.879v.02h14.926c.793 0 1.443-.649 1.443-1.443v0c0-.793-.649-1.443-1.443-1.443H24.06M9 31h6.999a8 8 0 0 0 16 0H39"
  }), props.children);
});
var AirConditioner =
/*#__PURE__*/
React.forwardRef(function AirConditioner(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M14.676 39c0-1.501-1.352-1.501-1.352-3.003 0-1.501 1.352-1.501 1.352-3.003 0-1.499-1.352-1.499-1.352-2.998s1.352-1.499 1.352-2.997m7 .001c0 1.499-1.352 1.499-1.352 2.997 0 1.499 1.352 1.499 1.352 2.998 0 1.501-1.352 1.501-1.352 3.003 0 1.501 1.352 1.501 1.352 3.003m7-12.001c0 1.499-1.352 1.499-1.352 2.997 0 1.499 1.352 1.499 1.352 2.998 0 1.501-1.352 1.501-1.352 3.003 0 1.501 1.352 1.501 1.352 3.003m7-12.001c0 1.499-1.352 1.499-1.352 2.997 0 1.499 1.352 1.499 1.352 2.998 0 1.501-1.352 1.501-1.352 3.003 0 1.501 1.352 1.501 1.352 3.003M39 23V9H9v14a2 2 0 0 0 2 2h26a2 2 0 0 0 2-2zm-27-1h24m-24-3h24m-24-3h24m-4-3h4"
  }), props.children);
});
var Airplane =
/*#__PURE__*/
React.forwardRef(function Airplane(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M22 13.169C22 11.762 22.592 9 24 9s2 2.762 2 4.169v5.342L37 27v4.5l-10.995-6.22L26 33.5l4 3.5v2l-6-2-6 2v-2l4-3.5V13.169zm7 7.754V18m3 5.335V20m-13-2v2.873L11 27v4.5l9-5.195m-4-3.13V20"
  }), props.children);
});
var Alarm =
/*#__PURE__*/
React.forwardRef(function Alarm(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M16.929 16.929A9.968 9.968 0 0 0 14 24a9.968 9.968 0 0 0 2.929 7.071m-3.536-17.678A14.957 14.957 0 0 0 9 24c0 4.142 1.679 7.892 4.393 10.607m7.06-7.06A4.98 4.98 0 0 1 19 24c0-1.385.544-2.641 1.451-3.549m10.62 10.62A9.968 9.968 0 0 0 34 24a9.968 9.968 0 0 0-2.929-7.071m3.536 17.678A14.957 14.957 0 0 0 39 24c0-4.142-1.679-7.892-4.393-10.607m-7.06 7.06A4.98 4.98 0 0 1 29 24a4.994 4.994 0 0 1-1.451 3.549"
  }), props.children);
});
var AlchemyDataNews =
/*#__PURE__*/
React.forwardRef(function AlchemyDataNews(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M39 39H26V23h13v16zm-11-8h9m-9-4h9m-9 8h9M16.921 18.561l-3.953 6.787c1.119.535 2.041.649 3.364.652l2.409-4.251h4.967c.62-1.07.963-1.889 1.07-3.188h-7.857zm-5.642-7.944C10.208 11.346 9.65 12.124 9 13.25l2.487 4.241-2.47 4.258c.64 1.102 1.173 1.858 2.216 2.579l3.982-6.828-3.936-6.883zm13.5 5.821c-.104-1.307-.456-2.112-1.077-3.189H18.73L16.323 9h-.002c-1.305 0-2.224.121-3.332.64l3.923 6.797 7.867.001z"
  }), props.children);
});
var AlchemyLanguageAlphabetAExpanded =
/*#__PURE__*/
React.forwardRef(function AlchemyLanguageAlphabetAExpanded(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M25 18.561c-.107 1.299-.451 2.117-1.07 3.188h-4.967L16.553 26c-1.323-.002-2.245-.117-3.364-.652l3.953-6.787H25zm-13.5-7.944c-1.07.729-1.629 1.507-2.279 2.633l2.487 4.241-2.47 4.258c.64 1.102 1.173 1.858 2.216 2.579l3.982-6.828-3.936-6.883zM25 16.438c-.104-1.307-.456-2.112-1.077-3.189H18.95L16.543 9h-.002c-1.305 0-2.224.121-3.332.64l3.923 6.797 7.868.001z"
  }), React.createElement("circle", {
    cx: "31",
    cy: "31",
    r: "8",
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72"
  }), React.createElement("path", {
    d: "M34.274 35h.781l-3.711-8.859h-.664L26.945 35h.781l.796-1.888h4.961L34.274 35zm-5.448-2.608l2.185-5.183 2.171 5.183h-4.356z"
  }), props.children);
});
var AlchemyLanguage =
/*#__PURE__*/
React.forwardRef(function AlchemyLanguage(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M25 18.561c-.107 1.299-.451 2.117-1.07 3.188h-4.967L16.553 26c-1.323-.002-2.245-.117-3.364-.652l3.953-6.787H25zm-13.5-7.944c-1.07.729-1.629 1.507-2.279 2.633l2.487 4.241-2.47 4.258c.64 1.102 1.173 1.858 2.216 2.579l3.982-6.828-3.936-6.883zM25 16.438c-.104-1.307-.456-2.112-1.077-3.189H18.95L16.543 9h-.002c-1.305 0-2.224.121-3.332.64l3.923 6.797 7.868.001z"
  }), React.createElement("circle", {
    cx: "31",
    cy: "31",
    r: "8",
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "bevel",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M27.336 34.999l3.676-8.719 3.652 8.719"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M28.457 32.752h5.086"
  }), props.children);
});
var AlchemyVision =
/*#__PURE__*/
React.forwardRef(function AlchemyVision(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M24 17.999c-.101 1.223-.424 1.993-1.007 3h-4.675L16.05 25c-1.245-.002-2.113-.11-3.166-.613L16.605 18H24zm-12.706-7.477c-1.007.686-1.533 1.419-2.145 2.478l2.34 3.992L9.164 21c.602 1.037 1.104 1.749 2.086 2.428l3.748-6.426-3.704-6.48zM24 16.001c-.098-1.23-.429-1.988-1.014-3.002h-4.68L16.041 9h-.002c-1.228 0-2.093.114-3.136.602l3.693 6.397 7.404.002zM39 24H24v15h15V24zm-5.5 2a1.5 1.5 0 1 0 .001 3.001A1.5 1.5 0 0 0 33.5 26zM39 36.06l-3.996-4.056-1.957 2.047-5.05-5.05-3.996 3.996"
  }), props.children);
});
var Americas =
/*#__PURE__*/
React.forwardRef(function Americas(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M24.096 9l2.404 4-5.5 6 7 12-8.177 7.411m-3.334-1.424L19 32.5 17 28l3.608-3L18 20h-5.675l-1.667-2.862m25.22-2.299l-3.226 5.62L36 26h2.868M24 9C15.716 9 9 15.716 9 24s6.716 15 15 15 15-6.716 15-15S32.284 9 24 9z"
  }), props.children);
});
var AmsterdamCanal =
/*#__PURE__*/
React.forwardRef(function AmsterdamCanal(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("circle", {
    cx: "14",
    cy: "10.5",
    r: ".5"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "square",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M9 34a5 5 0 0 1 5 5m20 0a5 5 0 0 1 5-5m-20 5a5 5 0 0 1 10 0"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M19 15.062h10V32H19z"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M29 17h10v15H9V19h10"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M12 27h4v5h-4zm2 5v-5m-3-6h2v4h-2zm4 0h2v4h-2zm6 6h2v3h-2zm4 0h2v5h-2zm0-6h2v4h-2zm-4 0h2v4h-2zm10 4h2v5h-2zm2-6h2v2h-2z"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M37 19v2"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M34 13v2"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M31 19v2"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M35 25h2v7h-2zm-6-2h10"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M31 12h6"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M25 17h2v2h-2zm-4 0h2v2h-2z"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M23 15v-1a1 1 0 0 1 2 0v1"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M18 19l-3-5m-2 0l-3 5"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M13 14v-2h2v2"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M13 19v-1a1 1 0 0 1 2 0v1"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M32 12s0 3-2 5m6-5s0 3 2 5m-2-5a2 2 0 1 0-4 0m-4 3v-2h-1v-2h-1.889V8.945h-2.222V11H21v2h-1v2"
  }), props.children);
});
var AmsterdamFarm =
/*#__PURE__*/
React.forwardRef(function AmsterdamFarm(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M28 34v5m9-5v5m-21-5v5m7-2v2m-10-2v2m-3-2v2"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M20 36v2m0-7v2m0-7v2m4 3v2"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M25 37v2m8-2v2m2-2v2"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M9 39h30M9 37h7"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M16 34h21m-14 3a1 1 0 0 1 2 0m8 0a1 1 0 0 1 2 0"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M37 34l-4-6h-3.997"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M18.353 17.355A3.982 3.982 0 0 0 18 19v2h8m-.353-3.646a4.002 4.002 0 0 0-5.293-2.001"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M20 19l4 4m0-4l-4 4"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M17.813 25.25c-.225 2.887-.72 6.565-1.813 8.75"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M26.742 29.744c.29 1.607.695 3.13 1.258 4.256"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M26 21s0 1.852.187 4.25"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M12 11.001l2-2 8.006 8.004-2.002 2.001zM24 19l8.005-8.005 2 2-8.004 8.006zM9.994 29.004L18 20.998 20 23l-8.005 8.005zm12.004-4.002L24 23l8.005 8.005-2.001 2z"
  }), props.children);
});
var AmsterdamWindmill =
/*#__PURE__*/
React.forwardRef(function AmsterdamWindmill(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M15 39h18m-11.015-6v-2m0 7v-2m5-5.063V33m-4.958-7v2M30 34v5m-12-5v5m8.985 0v-2a1 1 0 0 0-2 0v2"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M25.994 23.009l-4.003-4.003m4.003 0l-4.003 4.003m4.003-4.003l8.005-8.005 2 2-8.004 8.006zM11.985 29.012l8.005-8.006 2.001 2.002-8.005 8.005zm12.007-4.003l2.001-2.001L34 31.013l-2.002 2.001zM13.986 11.002l2.002-2.001 8.005 8.005-2.001 2.001zm12 12.007l-4.002-4.003m4.002 0l-4.002 4.003"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M27.988 21.007l-2.002-2.001 8.005-8.005 2.002 2.001m-4.008-.003L33.986 15m-4.001-.001L31.986 17m-4.001-.001L29.986 19"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M27.986 21l-2.001-2.001"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M19.983 21.007l2.001 2.002-8.005 8.005-2.001-2.002m2.01-2.01l2.001 2.002m.009-4.011l2.001 2.001m.008-4.011l2.002 2.001m3.976.026l2.001-2.001 8.005 8.005-2.001 2.001m2.001-2.001l-2.001 2.001m-.008-4.011l-2.001 2.002m-.008-4.011l-2.002 2.001m-.008-4.01l-2.001 2.001m-1.977-9.982l-2.001 2.001-8.005-8.005L15.98 9m8.005 8.005l-2.001 2.001m-.001-4.003l-2.001 2.001m-.001-4.003l-2.001 2.001m0-4.003l-2.002 2.002"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M19.813 25.25c-.225 2.887-.72 6.565-1.813 8.75h12"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M20.353 17.355A3.982 3.982 0 0 0 20 19v2h8m-.353-3.646a4.002 4.002 0 0 0-5.293-2.001"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M28.742 29.744c.29 1.607.695 3.13 1.258 4.256"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M28 21s0 1.852.187 4.25"
  }), props.children);
});
var Analyze =
/*#__PURE__*/
React.forwardRef(function Analyze(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M24 29v10H14l-5-5V19l4.997-.004M24 9c-5.52 0-10 4.48-10 10s4.48 10 10 10c2.76 0 5.26-1.12 7.07-2.93S34 21.76 34 19c0-5.52-4.48-10-10-10zm15 25l-7.933-7.933M14 39v-5H9m8.267-12.274L20 16.996l1.227 3.77 2.77-4.77 2.23 4.77L30 14.496"
  }), props.children);
});
var AnalyzesData =
/*#__PURE__*/
React.forwardRef(function AnalyzesData(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M14.12 33.894L21 27.015M16 13h5.037M24 21.015v-5m12 16.501v-6.501m-8.001 9.5h5M27 21.015h-6v6h6v-6zm-12.805-.999l-5.196 3 3 5.196 5.196-3-3-5.196zm-5.195-9v4l3.464 2 3.464-2v-4l-3.464-2-3.464 2zm16.999 21.035h-4l-2 3.464 2 3.464h4l2-3.464-2-3.464zm9.5-22.035l-3.464 6h6.928l-3.464-6zm-11.499 0a3 3 0 1 0 0 6 3 3 0 0 0 0-6zm11.999 22.5a3 3 0 1 0 0 6 3 3 0 0 0 0-6zm-23.997.033a3 3 0 1 0 0 6 3 3 0 0 0 0-6zM36 22.014a2 2 0 1 0-.001 3.999A2 2 0 0 0 36 22.014z"
  }), props.children);
});
var Apartment =
/*#__PURE__*/
React.forwardRef(function Apartment(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M22 39h-4v-8h4v8zm0-30v12H10v18h28V9H22zm4 6v-2m0 8v-2m-12 8v-2m20-10v-2m0 8v-2m-12 8v-2m8-10v-2m0 8v-2m4 8v-2m0 8v-2m-4-4v-2m0 8v-2m-12-4v-2m-4 8v-2m12-4v-2m0 8v-2"
  }), props.children);
});
var Api =
/*#__PURE__*/
React.forwardRef(function Api(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("font", {
    horizAdvX: "1000"
  }), React.createElement("text", {
    fontFamily: "IBMPlexSans",
    fontSize: "14",
    transform: "translate(14 23.996)"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M39 39H9M39 9H9v23h30V9z"
  }), props.children);
});
var AppDeveloper =
/*#__PURE__*/
React.forwardRef(function AppDeveloper(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M11 14l1.518 1.519L11 17m25.245 6.758l-1.74 1.741L34.499 28"
  }), React.createElement("path", {
    d: "M11.5 10.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0zM13 10a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1zm2 0a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1zm11 4a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1zm2 0a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1zm2 0a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1zM13 32a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1z"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M9 22V9h12v13H9zm12-10H9m4.001 6h3.008M11.5 27h3m-3 2h3m12.989 1H39V13H24v10.998M24 16h15M9.998 31.017h6m.001-5.433a.584.584 0 0 0-.584-.584h-4.832a.584.584 0 0 0-.584.584v7.832c0 .323.262.584.584.584h4.832a.584.584 0 0 0 .584-.584v-7.832zM34.505 23a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5zM26 18h4m3 0h4m-11 2h4m-4 2h4m3-2h4m-6 19l-.002-.522c0-3.3-2.287-6.06-5.36-6.799A4.013 4.013 0 0 0 24 24a4.018 4.018 0 0 0-4.02 4.017c0 1.634.979 3.033 2.379 3.662-3.073.739-5.36 3.499-5.36 6.799L17 39"
  }), props.children);
});
var Apple =
/*#__PURE__*/
React.forwardRef(function Apple(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M32.014 21.016s2.214.926 1 8m-.731 3.282l.37-1.282m-10.637-13c-1.596-.152-3.35-1-5.002-1-4.641 0-6 4.056-6 8 0 8.646 4.001 14 7.989 14 1.674 0 3.561-1 5.013-1h-.004c1.454 0 3.336 1 5.012 1 3.991-.001 7.99-5.393 7.99-14 0-3.926-1.355-8-6-8-2.26 0-4.473.97-6.745.999l-.255.001v-2.745s6.73.468 8-5c0 0-5.21-1.555-8.003 3m-3.498-2.755c-1.656-1.656-4.497-1.499-4.497-1.499s-.157 2.842 1.499 4.497 4.497 1.499 4.497 1.499.157-2.841-1.499-4.497z"
  }), props.children);
});
var Application =
/*#__PURE__*/
React.forwardRef(function Application(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    d: "M37 11.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0zm-2.5-.5a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1zm-2 0a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1z"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M39 38H9V10h30v28zM9 13h30m-22 0v25"
  }), props.children);
});
var Archive =
/*#__PURE__*/
React.forwardRef(function Archive(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M40 18H10v-8h30v8zm-28 0v21a1 1 0 0 0 1 1h24a1 1 0 0 0 1-1V18m-8 5h0c0-1.1-.9-2-2-2h-6c-1.1 0-2 .9-2 2v0c0 1.1.9 2 2 2h6c1.1 0 2-.9 2-2z"
  }), props.children);
});
var AsiaAustralia =
/*#__PURE__*/
React.forwardRef(function AsiaAustralia(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M39.008 24.008c0 8.284-6.716 15-15 15s-15-6.716-15-15 6.716-15 15-15 15 6.716 15 15zM9.309 27.014l1.692-1 1-4 2-1 2 5 5 2 1-3-3-2 2-2h5l3-7-3-4.874m-1.999 20.874h-2l1 2h3l1-4.073-1-.927-2 3zm11.964 2.967l-1.964-1.966-5 1.011-1 1.989-3 3-.994 1.994"
  }), props.children);
});
var AugmentedReality =
/*#__PURE__*/
React.forwardRef(function AugmentedReality(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M23 16l7-4 7 4v8l-7 4-7-4v-8zm0 0l7 4 7-4m-7 4v8m0-16V9H12v30h18V28m-18 4h18"
  }), React.createElement("circle", {
    cx: "21",
    cy: "35.5",
    r: "1"
  }), props.children);
});
var Austin =
/*#__PURE__*/
React.forwardRef(function Austin(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M9 22h30M9 26h30M9 28h30m-23 4a4 4 0 0 1 8 0m0 0a4 4 0 0 1 8 0"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M32 32a4 4 0 0 1 4-4"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M12 28a4 4 0 0 1 4 4"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M22 34h4m-8 4h4m4 0h4m0-4h6m-24 0h6m-4 2h20m-18-4v2m8-2v2m8-2v2M12 22v4m4-4v4m4-4v4m4-4v4m4-4v4m4-4v4m4-4v4"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M28 30a2.01 2.01 0 0 0-.586 1.414 1.97 1.97 0 0 0-.517.07 1.982 1.982 0 0 0-.482.2A1.974 1.974 0 0 0 26 32m3-13a2.01 2.01 0 0 0-.586 1.414 1.97 1.97 0 0 0-.517.07 1.982 1.982 0 0 0-.482.2A1.974 1.974 0 0 0 27 21m-3-7a2.01 2.01 0 0 0-.586 1.414 1.97 1.97 0 0 0-.517.07 1.982 1.982 0 0 0-.482.2A1.974 1.974 0 0 0 22 16m3 1a2.01 2.01 0 0 0-.586 1.414 1.97 1.97 0 0 0-.517.07 1.982 1.982 0 0 0-.482.2A1.974 1.974 0 0 0 23 19m7-10a2.01 2.01 0 0 1 .586 1.414c.174 0 .348.024.517.07.167.045.329.111.482.2.148.085.288.189.415.316m-8 0a2.01 2.01 0 0 1 .586 1.414c.174 0 .348.024.517.07.167.045.329.111.482.2.148.085.288.189.415.316m-7-1a2.01 2.01 0 0 1 .586 1.414c.174 0 .348.024.517.07.167.045.329.111.482.2.148.085.288.189.415.316m-1 2a2.01 2.01 0 0 1 .586 1.414c.174 0 .348.024.517.07.167.045.329.111.482.2.148.085.288.189.415.316"
  }), props.children);
});
var AutomateModularManagement =
/*#__PURE__*/
React.forwardRef(function AutomateModularManagement(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M23.999 27.659c-4.782 2.761-10.897 1.122-13.658-3.66s-1.122-10.897 3.66-13.658 10.897-1.122 13.658 3.66 1.122 10.897-3.66 13.658zm2.501-2.036v-8m-4.942-5.807l6.928 4m-7.5-6.623l-6.928 4m-2.558-.816v8m-1.986 1.807l6.928 4m.572 2.623l6.928-4M16.5 31v4m10-6v6m10 0V19.981L31.337 17"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M16.5 39a2 2 0 1 1 .001-4.001A2 2 0 0 1 16.5 39zm12-2a2 2 0 1 0-4 0 2 2 0 0 0 4 0zm10 0a2 2 0 1 0-4 0 2 2 0 0 0 4 0z"
  }), props.children);
});
var Automobile =
/*#__PURE__*/
React.forwardRef(function Automobile(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M36 34H12a2 2 0 0 1-2-2v-8a2 2 0 0 1 2-2h24a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2zm-25 0v4h3v-4m20 0v4h3v-4m-22-9a2 2 0 1 0-.001 3.999A2 2 0 0 0 15 25zm18 0a2 2 0 1 0-.001 3.999A2 2 0 0 0 33 25zm3-3l-2.786-9.287a1 1 0 0 0-.958-.713H15.744a1 1 0 0 0-.958.713L12 22m2.5-8h19M30 20l-3-3.964m4 2.144l-2-2.68"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M19 26h10m-10 2h10m-19 4h28M11 20v-3m26 3v-3"
  }), props.children);
});
var Bag =
/*#__PURE__*/
React.forwardRef(function Bag(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M37 39H11a2 2 0 0 1-2-2V19h30v18a2 2 0 0 1-2 2zm-7-24a6 6 0 1 0-12 0m0 0v4m12-4v4M9 31h30"
  }), props.children);
});
var Bangalore =
/*#__PURE__*/
React.forwardRef(function Bangalore(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("circle", {
    cx: "14",
    cy: "18",
    r: ".5"
  }), React.createElement("circle", {
    cx: "34",
    cy: "18",
    r: ".5"
  }), React.createElement("circle", {
    cx: "14",
    cy: "30",
    r: ".5"
  }), React.createElement("circle", {
    cx: "34",
    cy: "30",
    r: ".5"
  }), React.createElement("circle", {
    cx: "24",
    cy: "26.5",
    r: ".5"
  }), React.createElement("circle", {
    cx: "24",
    cy: "10",
    r: ".5"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M28 20h-8m5 0v-3a1 1 0 0 0-2 0v3m2-6v-1a1 1 0 0 0-2 0v1"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M12 36h24m-20 2h16m6-4H10"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M18 28v8m-2-8v8m6 0V26l2-2 2 2v10m4-8v8m-2-8v8m-8-8v8m12-8v8m4-10v8m-24-8v8m16-12h-8l-2-2h12z"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M26 26h12l-2-2h-6l4 4H14l4-4h-6l-2 2h12m6-6v-2a4 4 0 0 0-8 0v2m16 4v-2a2 2 0 1 0-4 0v2m-16 0v-2a2 2 0 1 0-4 0v2m8-2v4m8 0v-4"
  }), props.children);
});
var Bee =
/*#__PURE__*/
React.forwardRef(function Bee(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M10.868 23.007a3.624 3.624 0 0 1-1.385-4.974 3.708 3.708 0 0 1 3.547-1.828l8.345.794-6.148 5.493c-.021.02-.043.038-.065.057l-.004.004h0a3.727 3.727 0 0 1-4.29.454zm22.674 12.449c1.792.961 4.036.306 5.009-1.464a3.609 3.609 0 0 0-.298-3.94l-5.086-6.581-1.482 8.055-.016.085-.001.005h0a3.636 3.636 0 0 0 1.874 3.84zM22.048 19.991l-1.144 2.031 8.19 4.497 1.144-2.031-8.19-4.497zm6.49-2.005h0a4.737 4.737 0 0 0-4.937.235l7.34 4.03a4.613 4.613 0 0 0-2.403-4.265zm-9.906 8.07l8.19 4.496 1.144-2.031-8.19-4.496-1.144 2.031zm1.7 6.502h0a4.735 4.735 0 0 0 4.937-.235l-7.34-4.03a4.613 4.613 0 0 0 2.403 4.265zm8.476-18.045a1.614 1.614 0 0 0-.638-2.208 1.656 1.656 0 0 0-2.236.63 1.613 1.613 0 0 0 .638 2.208 1.655 1.655 0 0 0 2.236-.63zm5.448 2.991a1.614 1.614 0 0 0-.638-2.208 1.656 1.656 0 0 0-2.236.63 1.613 1.613 0 0 0 .638 2.208 1.655 1.655 0 0 0 2.236-.63z"
  }), props.children);
});
var BeijingMunicipal =
/*#__PURE__*/
React.forwardRef(function BeijingMunicipal(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M11 26v-3m2 3v-3m11 3v-2m-5 2v-2m10 2v-2m-2 2v-3m-12 3v-3m2 3v-3m4 3v-3m10 3v-3m2 3v-3m2 3v-3m2 3v-3"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M11 18h26v-1c-2 0-5-2-6-4H17c-1 2-4 4-6 4v1zm23 2v-2m-19.958 2v-2"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M26 30h-1m0 2h2m0 0h-2m0 2h3m0 0h-3m0 2h4m0 0h-4m0 2h5m2-8h-4m1 2h4m-3 2h5m-4 2h6m-5 2h7m-17-8h3m-2 2h-2m0 0h4m-2 2h-3m0 0h5m-2 2h-4m0 0h6m0 2h-7m-2-8h4m-1 2h-4m3 2h-5m4 2h-6m5 2H9"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M17 13v-2m14 2v-2m8 17H9m30-2H9"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M9 22v1h30v-1c-2 0-4-1-5-2H14c-1 1-3 2-5 2z"
  }), props.children);
});
var BeijingTower =
/*#__PURE__*/
React.forwardRef(function BeijingTower(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M24 19V9"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M15 39l5.032-20h10L35 39"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M24 9l-8 2-7 28h30l-6-24z"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M22.25 19L19 32h10.032l-3.25-13"
  }), props.children);
});
var BerlinBrandenburg =
/*#__PURE__*/
React.forwardRef(function BerlinBrandenburg(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M9 36h30M9 18h30m-19-2h8m-17-2h26M9 20h30"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M21 22v14m-2-14v14m-2-14v14m-2-14v14m-2-14v14m-2-14v14m26-14v14M13 14v4m22-4v4m0 4v14m-2-14v14m-2-14v14m-2-14v14m-2-14v14"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M9 22h30M20 10a4 4 0 0 1 4 4m4-4a4 4 0 0 0-4 4m4-2a2 2 0 0 0-2 2m-6-2a2 2 0 0 1 2 2"
  }), props.children);
});
var BerlinCathedral =
/*#__PURE__*/
React.forwardRef(function BerlinCathedral(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M18 39V18a6 6 0 1 1 12 0v21m-20-3V18a3 3 0 1 1 6 0v18m16 0V18a3 3 0 1 1 6 0v18"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M10 18h6m16 0h6m-28 6h28m-20-6h12M20 32h8"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M20 39v-7a4 4 0 0 1 8 0v7"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M10 31l3-3 3 3m16 0l3-3 3 3M22 14a2 2 0 1 1 4 0m-4 0v4m4-4v4m-2-9v3"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M12 36v-4h2v4m20 0v-4h2v4m-13 3v-5h2v5"
  }), React.createElement("circle", {
    cx: "24",
    cy: "27",
    r: "1",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M23 24v-3l1-1 1 1v3"
  }), React.createElement("circle", {
    cx: "13",
    cy: "21",
    r: ".5"
  }), React.createElement("circle", {
    cx: "20.5",
    cy: "21",
    r: ".5"
  }), React.createElement("circle", {
    cx: "27.5",
    cy: "21",
    r: ".5"
  }), React.createElement("circle", {
    cx: "35",
    cy: "21",
    r: ".5"
  }), React.createElement("circle", {
    cx: "35",
    cy: "13",
    r: ".5"
  }), React.createElement("circle", {
    cx: "13",
    cy: "13",
    r: ".5"
  }), props.children);
});
var BerlinTower =
/*#__PURE__*/
React.forwardRef(function BerlinTower(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M23 16h2v2h-2z"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M23 12h2"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M23 28h2v2h-2z"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M22 30h4v2h-4z"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M23 32h2v2h-2z"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M22 34h4v2h-4zm0-20h4v2h-4z"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M20 24h8"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M24 9v5m0 22v3m2-3v3m-4-3v3"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M10 18a2 2 0 1 1 4 0m-4 2a1 1 0 0 1 0-2m4 0a1 1 0 0 1 2 0m1 0a1 1 0 0 1 0 2m0-2h-1m1 2h-7m21 8a2 2 0 1 1 4 0m-4 2a1 1 0 0 1 0-2m4 0a1 1 0 0 1 2 0m1 0a1 1 0 0 1 0 2m0-2h-1m1 2h-7"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M26 20.555V18h-4v2.555c-1.191.693-2 1.968-2 3.445a4 4 0 0 0 8 0c0-1.477-.809-2.752-2-3.445z"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M26 20.555c-.59-.344-1.268-.555-2-.555s-1.41.211-2 .555"
  }), props.children);
});
var Bicycle =
/*#__PURE__*/
React.forwardRef(function Bicycle(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M19 29a5 5 0 1 1-10.001-.001A5 5 0 0 1 19 29zm5-2a2 2 0 1 0-.001 3.999A2 2 0 0 0 24 27zm10-3a5 5 0 1 0 .001 10.001A5 5 0 0 0 34 24zm-20 5h8m-3-8.661h10M14 29l5-8.66M34 29l-8.083-14m-10 0L23 27.268m2 0l4-6.928M14 15h4m7.918 0H31"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M31 19a2 2 0 1 0 0-4"
  }), props.children);
});
var Blockchain =
/*#__PURE__*/
React.forwardRef(function Blockchain(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M16 16h-6v-6h6v6zm22-6h-6v6h6v-6zm-11 0h-6v6h6v-6zM16 32h-6v6h6v-6zm22 0h-6v6h6v-6zm-11 0h-6v6h6v-6zM16 21h-6v6h6v-6zm22 0h-6v6h6v-6zm-11 0h-6v6h6v-6zm-11-8h5m-5 11h5m-5 11h5m6-22h5m-5 11h5m-5 11h5m-19-3v-5m11 5v-5m11 5v-5m-22-6v-5m11 5v-5m11 5v-5"
  }), props.children);
});
var Build =
/*#__PURE__*/
React.forwardRef(function Build(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M27.002 23.995a3 3 0 1 1-6 0 3 3 0 0 1 6 0zM23.998 9c-.829 0-1.498.667-1.498 1.495S23.169 12 23.998 12s1.502-.676 1.502-1.505S24.826 9 23.998 9zm-6.996 22a4 4 0 1 0 0 8 4 4 0 0 0 0-8zm12.405-13.505v3l2.598 1.5 2.598-1.5v-3l-2.598-1.5-2.598 1.5zm3.598 11.5L39 32.5v-7l-5.995 3.495zm-21.879-5.121L9 26l2.126 2.117 2.121-2.121-2.121-2.122zm12.879-8.879v6m-4.856 10.627l2.308-3.627m-11.206 2.001c.385.881.852 1.717 1.391 2.5m9.863 6.292c.812.136 1.647.207 2.498.207 4.907 0 9.264-2.356 12.001-6m2.996-10c-.448-6.807-5.467-12.373-11.995-13.699m-4.999 6.95a8.003 8.003 0 0 0-4.934 11.749"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeDasharray: "0.02,2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M9.035 22.997c.447-6.8 5.425-12.363 11.944-13.697m11.023 14.695a8 8 0 0 1-9.998 7.749"
  }), props.children);
});
var Building =
/*#__PURE__*/
React.forwardRef(function Building(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M9 9h30M27 39v-8h-6v8M11 11v28m26-28v28M9 39h30M14 13v2m0 4v2m0 4v2m5-14v2m0 4v2m0 4v2m5-14v2m0 4v2m0 4v2m5-14v2m0 4v2m0 4v2m5-14v2m0 4v2m0 4v2"
  }), props.children);
});
var Bulldozer =
/*#__PURE__*/
React.forwardRef(function Bulldozer(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M20.5 9c0 .992.819 1.258 1.617 1.258h.013c.993 0 1.37.943 1.37 1.742v1.75c0 .992.702 1.25 1.5 1.25m0-2.998v-1.495C25 9.71 24.493 9 23.5 9m-2.995 3v.75c0 .798.502 1.495 1.495 1.495"
  }), React.createElement("path", {
    d: "M13 36a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm3.5-1a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm4.5 0a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm4.5 0a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm4.5 0a1 1 0 1 0 0 2 1 1 0 0 0 0-2z"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M12 33v-2H9V19m4 6v-6m6 0v6m9 0v-9.998L26 15m13 8c-3.382 3.382-3.382 8.618 0 12m-2.095-8.79h-2.794a3.944 3.944 0 0 0 0 5.58h2.792M30 29h3M21 17H9v2h12v-2zm12 19h0c0-1.65-1.35-3-3-3H12c-1.65 0-3 1.35-3 3v0c0 1.65 1.35 3 3 3h18c1.65 0 3-1.35 3-3zm-3-3v-6.308c0-.933-.751-1.692-1.684-1.692H9m8 2h2"
  }), props.children);
});
var Bus =
/*#__PURE__*/
React.forwardRef(function Bus(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M35 35H13a2 2 0 0 1-2-2V11a2 2 0 0 1 2-2h22a2 2 0 0 1 2 2v22a2 2 0 0 1-2 2zm-23 0v4h3v-4m18 0v4h3v-4m-21-7a2 2 0 1 0-.001 3.999A2 2 0 0 0 15 28zm18 0a2 2 0 1 0-.001 3.999A2 2 0 0 0 33 28zm-14 1h10m-10 2h10m1-9.536l-4-6.928m5 4.196l-2-3.464M9 19v-6m30 6v-6m-28-1h26M11 24h26"
  }), props.children);
});
var Cafe =
/*#__PURE__*/
React.forwardRef(function Cafe(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M27 34h-6a4 4 0 0 1-4-4v-8h14v8a4 4 0 0 1-4 4zm4-4h2a2 2 0 0 0 2-2v-2a2 2 0 0 0-2-2h-2m-11-4v-1.283c0-.472.11-.937.321-1.359v0a3.035 3.035 0 0 0 0-2.717v0A3.034 3.034 0 0 1 20 13.283V13m8 7v-1.283c0-.472.11-.937.321-1.359v0a3.035 3.035 0 0 0 0-2.717v0A3.034 3.034 0 0 1 28 13.283V13m-4 6v-1.283c0-.472.11-.937.321-1.359v0a3.035 3.035 0 0 0 0-2.717v0A3.034 3.034 0 0 1 24 12.283V12M14 36h20"
  }), props.children);
});
var CalendarDate =
/*#__PURE__*/
React.forwardRef(function CalendarDate(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("font", {
    horizAdvX: "1000"
  }), React.createElement("text", {
    fontFamily: "IBMPlexSans",
    fontSize: "16",
    transform: "translate(15.432 31.996)"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M38 39H10V12h28v27zM16 15V9m16 6V9"
  }), props.children);
});
var CalendarEvent =
/*#__PURE__*/
React.forwardRef(function CalendarEvent(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M20 12h8m-14 0h-4v27h28V12h-4m-12 8h-8v4h8v-4zm10-6v-4a1 1 0 0 0-1-1h0a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h0a1 1 0 0 0 1-1zm-14 0v-4a1 1 0 0 0-1-1h0a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h0a1 1 0 0 0 1-1zm4 15h-8v4h8v-4zm12-9h-8v4h8v-4zm0 9h-8v4h8v-4z"
  }), props.children);
});
var Calendar =
/*#__PURE__*/
React.forwardRef(function Calendar(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M38 39H10V12h28v27zM16 15V9m8 6V9m8 6V9m-7 10h-2v2h2v-2zm0 7h-2v2h2v-2zm0 7h-2v2h2v-2zm-8-14h-2v2h2v-2zm0 7h-2v2h2v-2zm0 7h-2v2h2v-2zm16-14h-2v2h2v-2zm0 7h-2v2h2v-2zm0 7h-2v2h2v-2z"
  }), props.children);
});
var Camera =
/*#__PURE__*/
React.forwardRef(function Camera(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M39 39H9V13h30v26zM24 13V9H12v4m12 7a7 7 0 1 0 0 14 7 7 0 0 0 0-14zm4-4h8"
  }), props.children);
});
var Capitol =
/*#__PURE__*/
React.forwardRef(function Capitol(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M24 38v-3m-4 3v-3m-7 3v-3m15 3v-3m7 3v-3m-11-2v-3m-4 3v-3m-7 3v-3m15 3v-3m7 3v-3m-11-5v-2m-3 2v-2m-3-2h12m-3 4v-2M9 39h30M16 28h-6v11h6V28zm22 0h-6v11h6V28zm-6-1H16v12h16V27zm-8-15h3v-2h-3v5m6 10v-4a6 6 0 1 0-12 0v4"
  }), props.children);
});
var Care =
/*#__PURE__*/
React.forwardRef(function Care(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    d: "M21.5 12a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0zm2.5-.5a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1zm3 0a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1zm-6 3a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1zm3 0a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1zm3 0a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1zm-6 3a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1zm3 0a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1zm3 0a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1zM11.5 21a.5.5 0 1 0 1 0 .5.5 0 0 0-1 0zm3 0a.5.5 0 1 0 1 0 .5.5 0 0 0-1 0zm0 3a.5.5 0 1 0 1 0 .5.5 0 0 0-1 0zm-3 0a.5.5 0 1 0 1 0 .5.5 0 0 0-1 0zm0 3a.5.5 0 1 0 1 0 .5.5 0 0 0-1 0zm3 0a.5.5 0 1 0 1 0 .5.5 0 0 0-1 0zm18-6a.5.5 0 1 0 1 0 .5.5 0 0 0-1 0zm3 0a.5.5 0 1 0 1 0 .5.5 0 0 0-1 0zm0 3a.5.5 0 1 0 1 0 .5.5 0 0 0-1 0zm-3 0a.5.5 0 1 0 1 0 .5.5 0 0 0-1 0zm0 3a.5.5 0 1 0 1 0 .5.5 0 0 0-1 0zm3 0a.5.5 0 1 0 1 0 .5.5 0 0 0-1 0zM21 29.5a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1zm3 0a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1zm3 0a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1zm0 3a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1zm-3 0a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1zm-3 0a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1zm0 3a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1zm3 0a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1zm3 0a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1z"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M28 39h-8c-1.1 0-2-.9-2-2V11c0-1.1.9-2 2-2h8c1.1 0 2 .9 2 2v26c0 1.1-.9 2-2 2zM18 18h-7c-1.1 0-2 .9-2 2v8c0 1.1.9 2 2 2h7m12 0h7c1.1 0 2-.9 2-2v-8c0-1.1-.9-2-2-2h-7m-9 3h6m-6 3h6m-6 3h6"
  }), props.children);
});
var Cell =
/*#__PURE__*/
React.forwardRef(function Cell(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M39 24c0 8.284-6.716 15-15 15S9 32.284 9 24 15.716 9 24 9s15 6.716 15 15zm-6.498-7.382a1 1 0 1 0 0 2 1 1 0 0 0 0-2zM21.985 23a2 2 0 1 0-.001 3.999A2 2 0 0 0 21.985 23zm0-2c2.337 0 3.686-1 5-1.723M29 22.733c-1.143.862-2.546 1.915-3.331 3.83M21.985 21a4 4 0 1 0 3.686 5.557m-3.537-15.556h0a1.003 1.003 0 0 0 .366 1.366l2.598 1.5c.476.275 1.091.11 1.366-.366v0a1.003 1.003 0 0 0-.366-1.366l-2.598-1.5a1.003 1.003 0 0 0-1.366.366zm-11.096 9.618h0a1.003 1.003 0 0 0 .366 1.366l2.598 1.5c.476.275 1.091.11 1.366-.366h0a1.003 1.003 0 0 0-.366-1.366l-2.598-1.5a1.003 1.003 0 0 0-1.366.366zm20.499 6.382h0a1.003 1.003 0 0 0 .366 1.366l2.598 1.5c.476.275 1.091.11 1.366-.366v0a1.003 1.003 0 0 0-.366-1.366l-2.598-1.5a1.003 1.003 0 0 0-1.366.366zm-17.902 3.117h0a1.003 1.003 0 0 0 .366 1.366l2.598 1.5c.476.275 1.091.11 1.366-.366h0a1.003 1.003 0 0 0-.366-1.366l-2.598-1.5a1.002 1.002 0 0 0-1.366.366zm5.866-15.963h0a1.003 1.003 0 0 0-1.366.366l-1.5 2.598a1.003 1.003 0 0 0 .366 1.366h0c.476.275 1.091.11 1.366-.366l1.5-2.598a1.003 1.003 0 0 0-.366-1.366zm16.5 5.597h0a1.003 1.003 0 0 0-1.366.366l-1.5 2.598a1.003 1.003 0 0 0 .366 1.366h0c.476.275 1.091.11 1.366-.366l1.5-2.598a1.003 1.003 0 0 0-.366-1.366zM29 32.133h0a1.003 1.003 0 0 0-1.366.366l-1.5 2.598a1.003 1.003 0 0 0 .366 1.366h0c.476.275 1.091.11 1.366-.366l1.5-2.598A1.003 1.003 0 0 0 29 32.133zm0-9.4a1.999 1.999 0 0 0-1-3.732c-.371 0-.718.101-1.015.277"
  }), props.children);
});
var ChartBar =
/*#__PURE__*/
React.forwardRef(function ChartBar(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M39 39h-6V9h6v30zm-24-6H9v6h6v-6zm12-12h-6v18h6V21z"
  }), props.children);
});
var ChartBubbleLine =
/*#__PURE__*/
React.forwardRef(function ChartBubbleLine(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M16 26a2 2 0 1 1-.001-3.999A2 2 0 0 1 16 26zm2-2a2 2 0 1 0-3.999-.001A2 2 0 0 0 18 24zM9 9v30h30.04M35 16h4M9 24h5m8.62 6.551l-5.17-5.17m14.76-7.55l-7.19 12.45M26 32a2 2 0 1 0-3.999-.001A2 2 0 0 0 26 32zm9-16a2 2 0 1 0-3.999-.001A2 2 0 0 0 35 16z"
  }), props.children);
});
var ChartLine =
/*#__PURE__*/
React.forwardRef(function ChartLine(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M39 39H9V9m30 7.763l-6.426 11.13L26 16l-5.123 15.588L16 24 9 39"
  }), props.children);
});
var ChartScatterplot =
/*#__PURE__*/
React.forwardRef(function ChartScatterplot(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M24 9v30m15-15H9"
  }), React.createElement("path", {
    d: "M32 11a1 1 0 1 1 0-2 1 1 0 0 1 0 2zm1 27a1 1 0 1 0-2 0 1 1 0 0 0 2 0zm0-19a1 1 0 1 0-2 0 1 1 0 0 0 2 0zm0 12a1 1 0 1 0-2 0 1 1 0 0 0 2 0zm4 0a1 1 0 1 0-2 0 1 1 0 0 0 2 0zm-24 0a1 1 0 1 0-2 0 1 1 0 0 0 2 0zm0-12a1 1 0 1 0-2 0 1 1 0 0 0 2 0zm4 0a1 1 0 1 0-2 0 1 1 0 0 0 2 0zm0-9a1 1 0 1 0-2 0 1 1 0 0 0 2 0z"
  }), props.children);
});
var Cherries =
/*#__PURE__*/
React.forwardRef(function Cherries(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M32 27.999c2.294 1 2.771 3.729 2 5.917m-15.5-7.417c2.5-4.5 4.5-7.5 6.5-14.5m0 0c1 7 2.5 11 4.5 15.599m-5.901 4.451c0 3.45 2.401 6.95 6.95 6.95 4.45 0 7.45-3 7.45-6.95 0-3.451-2-6.05-5.5-6.05-1.205 0-2.326.508-3 1.599-.587-.34-1-.599-2.023-.599-2.476 0-3.877 2.5-3.877 5.05zM20 33.999c.708-.771 1-1.986 1-3 0-1-.289-2.272-1-3M17.5 9C15 9 12 9.999 10 11.999c2 2 5 3 7.5 3 3.5 0 5.5-1 7.5-3C23 9.999 21 9 17.5 9zm6.894 19.598c-.795-2.099-3.618-3.549-5.894-2.099 0 0-.961-1.038-2.5-1.038-3 0-5 2.038-5 6.038 0 4.501 2.5 7.5 7 7.5 3 0 5-1.499 6-4"
  }), props.children);
});
var ChipCircuit =
/*#__PURE__*/
React.forwardRef(function ChipCircuit(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".851",
    d: "M35 35H13V13h22v22zm-6-16H19v10h10V19zm3-8V9m-4 2V9m-4 2V9m-8 2V9m4 2V9m12 30v-2m-4 2v-2m-4 2v-2m-8 2v-2m4 2v-2m-9-21H9m2 4H9m2 4H9m2 8H9m2-4H9m30-12h-2m2 4h-2m2 4h-2m2 8h-2m2-4h-2"
  }), props.children);
});
var ChipCredit =
/*#__PURE__*/
React.forwardRef(function ChipCredit(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M37 36H11c-1.1 0-2-.9-2-2V14c0-1.1.9-2 2-2h26c1.1 0 2 .9 2 2v20c0 1.1-.9 2-2 2zm-19 0V12M9 24h9m-9 6h9M9 18h9m12 12h9m-9 6V18h9m-9 6h9"
  }), props.children);
});
var ChipDebit =
/*#__PURE__*/
React.forwardRef(function ChipDebit(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".851",
    d: "M36 38H12a2 2 0 0 1-2-2V12a2 2 0 0 1 2-2h24a2 2 0 0 1 2 2v24a2 2 0 0 1-2 2zm-7-19H19v10h10V19zm9-4h-5l-4 4m0 5h9m-14-5v-9m0 28v-9m-5-10l-4-4h-5m0 9h9m-9 9h5l4-4m10 0l4 4h5"
  }), props.children);
});
var CloudAnalytics =
/*#__PURE__*/
React.forwardRef(function CloudAnalytics(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M26 28v-5m4 5v-8m-8 8v-8m-4 8v-3m-6-10.008v13M24 9C15.716 9 9 15.716 9 24s6.716 15 15 15 15-6.716 15-15S32.284 9 24 9zM10.199 29.888l11.258 6.5m.742 2.508l11.258-6.5M36 20.008v13m1.801-14.896l-11.258-6.5m-12 3.992l11.258-6.5M24 9C15.716 9 9 15.716 9 24s6.716 15 15 15 15-6.716 15-15S32.284 9 24 9z"
  }), props.children);
});
var CloudAssets =
/*#__PURE__*/
React.forwardRef(function CloudAssets(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M12 14.992v13M24 9C15.716 9 9 15.716 9 24s6.716 15 15 15 15-6.716 15-15S32.284 9 24 9zM10.199 29.888l11.258 6.5m.742 2.508l11.258-6.5m2.543.612v-13m1.801-1.896l-11.258-6.5m-12 3.992l11.258-6.5M26 19h-7v7h7v-7zm-4 7v3h7v-7h-3"
  }), props.children);
});
var CloudBuilderProfessionalServices =
/*#__PURE__*/
React.forwardRef(function CloudBuilderProfessionalServices(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M16.937 28.317a2.005 2.005 0 0 1 .732-2.732l5.66-3.268a4.002 4.002 0 0 1 6.856-2.803l-3.355 1.937c-.476.275-.641.89-.366 1.366v0c.275.476.89.641 1.366.366l3.355-1.937a4.002 4.002 0 0 1-5.856 4.535l-5.66 3.268c-.953.55-2.182.22-2.732-.732h0zM12 14.992v13M24 9C15.716 9 9 15.716 9 24s6.716 15 15 15 15-6.716 15-15S32.284 9 24 9zM10.199 29.888l11.258 6.5m.742 2.508l11.258-6.5M36 20.008v13m1.801-14.896l-11.258-6.5m-12 3.992l11.258-6.5M24 9C15.716 9 9 15.716 9 24s6.716 15 15 15 15-6.716 15-15S32.284 9 24 9z"
  }), props.children);
});
var CloudComputing =
/*#__PURE__*/
React.forwardRef(function CloudComputing(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M12 14.992v13M39 24c0 8.284-6.716 15-15 15S9 32.284 9 24 15.716 9 24 9s15 6.716 15 15zm-28.801 5.888l11.258 6.5m.742 2.508l11.258-6.5M36 20.008v13m1.801-14.896l-11.258-6.5m-12 3.992l11.258-6.5M39 24c0 8.284-6.716 15-15 15S9 32.284 9 24 15.716 9 24 9s15 6.716 15 15z"
  }), props.children);
});
var CloudDataServices =
/*#__PURE__*/
React.forwardRef(function CloudDataServices(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M18 21.5a1.5 1.5 0 1 1-3.001-.001A1.5 1.5 0 0 1 18 21.5zM16.5 28v-3m5 3a1.5 1.5 0 1 0-.001-3.001A1.5 1.5 0 0 0 21.5 28zm0-8v3m5-3a1.5 1.5 0 1 0 .001 3.001A1.5 1.5 0 0 0 26.5 20zm0 8v-3m5 3a1.5 1.5 0 1 0-.001-3.001A1.5 1.5 0 0 0 31.5 28zm0-8v3M12 14.992v13M24 9C15.716 9 9 15.716 9 24s6.716 15 15 15 15-6.716 15-15S32.284 9 24 9zM10.199 29.888l11.258 6.5m.742 2.508l11.258-6.5M36 20.008v13m1.801-14.896l-11.258-6.5m-12 3.992l11.258-6.5M24 9C15.716 9 9 15.716 9 24s6.716 15 15 15 15-6.716 15-15S32.284 9 24 9z"
  }), props.children);
});
var CloudDownload =
/*#__PURE__*/
React.forwardRef(function CloudDownload(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M15.471 28.721C11.816 28.223 9 25.047 9 21.255a7.493 7.493 0 0 1 10.336-6.931A7.487 7.487 0 0 1 26.118 10c4.005 0 7.267 3.145 7.473 7.099A5.81 5.81 0 0 1 39 22.912a5.8 5.8 0 0 1-5.811 5.817c-.044 0-.086-.006-.13-.006"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M30 32l-6 6-6-6m6-11v17"
  }), props.children);
});
var CloudEcosystem =
/*#__PURE__*/
React.forwardRef(function CloudEcosystem(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M12 14.992v13M39 24c0 8.284-6.716 15-15 15S9 32.284 9 24 15.716 9 24 9s15 6.716 15 15zM21.457 36.388l-11.258-6.5m12 9.008l11.258-6.5m2.543.612v-13m-9.457-8.396l11.258 6.5m-23.258-2.508l11.258-6.5M39 24c0 8.284-6.716 15-15 15S9 32.284 9 24 15.716 9 24 9s15 6.716 15 15zm-18 7h0a4.513 4.513 0 0 1-4.5-4.5v0c0-2.475 2.025-4.5 4.5-4.5h0c2.475 0 4.5 2.025 4.5 4.5v0c0 2.475-2.025 4.5-4.5 4.5zm7.5-9.5h0c0-2.475-2.025-4.5-4.5-4.5h0a4.513 4.513 0 0 0-4.5 4.5v0c0 2.475 2.025 4.5 4.5 4.5h0c2.475 0 4.5-2.025 4.5-4.5zm3 5h0c0-2.475-2.025-4.5-4.5-4.5h0a4.513 4.513 0 0 0-4.5 4.5v0c0 2.475 2.025 4.5 4.5 4.5h0c2.475 0 4.5-2.025 4.5-4.5z"
  }), props.children);
});
var CloudGuidelines =
/*#__PURE__*/
React.forwardRef(function CloudGuidelines(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M28.648 18.196l-6.5 11.258-2.797 1.849.199-3.349 6.5-11.258 2.598 1.5zM12 14.992v13M39 24c0 8.284-6.716 15-15 15S9 32.284 9 24 15.716 9 24 9s15 6.716 15 15zM21.457 36.388l-11.258-6.5m23.258 2.508l-11.258 6.5M36 20.008v13m-9.457-21.396l11.258 6.5m-23.258-2.508l11.258-6.5M39 24c0 8.284-6.716 15-15 15S9 32.284 9 24 15.716 9 24 9s15 6.716 15 15z"
  }), props.children);
});
var CloudManagedServices =
/*#__PURE__*/
React.forwardRef(function CloudManagedServices(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M22.5 25.5H18v-3h4.5V18h3v4.5H30v3h-4.5V30h-3v-4.5zM12 14.992v13M24 9C15.716 9 9 15.716 9 24s6.716 15 15 15 15-6.716 15-15S32.284 9 24 9zM10.199 29.888l11.258 6.5m.742 2.508l11.258-6.5M36 20.008v13m1.801-14.896l-11.258-6.5m-12 3.992l11.258-6.5M24 9C15.716 9 9 15.716 9 24s6.716 15 15 15 15-6.716 15-15S32.284 9 24 9z"
  }), props.children);
});
var CloudOracle =
/*#__PURE__*/
React.forwardRef(function CloudOracle(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M23 16.295v6M36 31h0c0-1.65-1.35-3-3-3h-4c-1.65 0-3 1.35-3 3v0c0 1.65 1.35 3 3 3h4c1.65 0 3-1.35 3-3zm3-8H23v16h16V23zM17 9a8 8 0 1 0 0 16 8 8 0 0 0 0-16zm2.389 2.451l5.196 3m-6-5.294l-5.196 3M11 11.705v6m3.611 4.844l-5.196-3m11.196 2.294l-5.196 3"
  }), props.children);
});
var CloudPartners =
/*#__PURE__*/
React.forwardRef(function CloudPartners(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M15.161 30.353a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5zm7.071 7.915a2.501 2.501 0 1 0 3.536-3.538 2.501 2.501 0 0 0-3.536 3.538zm10.607-2.915a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5zm5.429-9.571a2.501 2.501 0 1 0-3.538-3.536 2.501 2.501 0 0 0 3.538 3.536zm-27.02-6.972v-6.749M18 9c-4.971 0-9 4.029-9 9s4.029 9 9 9 9-4.029 9-9-4.029-9-9-9zM9.481 20.878l5.844 3.374m6.752-.81l-5.844 3.374m8.519-9.626v6.749m1.767-8.817l-5.844-3.374m-.908-2.565l-5.844 3.374M32.5 17.5a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5z"
  }), props.children);
});
var CloudPlanning =
/*#__PURE__*/
React.forwardRef(function CloudPlanning(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M29.5 29h-11v-9h11v9zm-8-10v2m5-2v2"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M12 14.992v13M39 24c0 8.284-6.716 15-15 15S9 32.284 9 24 15.716 9 24 9s15 6.716 15 15zm-28.801 5.888l11.258 6.5m.742 2.508l11.258-6.5M36 20.008v13m1.801-14.896l-11.258-6.5m-12 3.992l11.258-6.5M39 24c0 8.284-6.716 15-15 15S9 32.284 9 24 15.716 9 24 9s15 6.716 15 15z"
  }), props.children);
});
var CloudSap =
/*#__PURE__*/
React.forwardRef(function CloudSap(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M27 23.998h11L24 37.981H10v-14m14-6.686v6M26 18a8 8 0 1 1-16 0 8 8 0 0 1 16 0zm-.415-2.549l-5.196-3m-.804-2.294l-5.196 3M12 12.705v6m3.611 4.844l-5.196-3m11.196 2.294l-5.196 3"
  }), props.children);
});
var CloudServicesPricing =
/*#__PURE__*/
React.forwardRef(function CloudServicesPricing(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M30 24.5v1.7m0 8.3v2m6.437-12.437a8.75 8.75 0 1 0-12.374 12.374 8.75 8.75 0 0 0 12.374-12.374zm-12.5-12.5a8.75 8.75 0 1 0-12.374 12.374 8.75 8.75 0 0 0 12.374-12.374zm-12.309 6.065v-6m2.955 11.363l-5.196-3m11.318 3.122l-5.196 3m8.363-8.241v6m-2.955-11.363l5.196 3m-11.318-3.122l5.196-3M17.75 15.25v5m2.5-2.5h-5M33 26.5h-4a2 2 0 1 0 0 4h2a2 2 0 1 1 0 4h-4"
  }), props.children);
});
var CloudServices =
/*#__PURE__*/
React.forwardRef(function CloudServices(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M39 34.385C39 36.934 36.999 39 34.384 39H15.922C12.099 39 9 35.901 9 32.077S12.099 25 15.923 25c.402 0 .796.036 1.179.102C18.683 22.287 21 20 25.154 20c5.346 0 9.231 4.902 9.231 10C36.999 30 39 31.836 39 34.385zM12 15H9v3h3v-3zm20 0h-3v3h3v-3zM20 9h-3v3h3V9zm.5 27h-3v3h3v-3zm0-7h-3v3h3v-3zm5.5 0h-3v3h3v-3zm6.5 7h-3v3h3v-3zM39 9h-3v3h3V9zm0 12h-3v3h3v-3z"
  }), props.children);
});
var CloudStorage =
/*#__PURE__*/
React.forwardRef(function CloudStorage(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M32 14a3 3 0 0 1-3 3H18.5a1.5 1.5 0 0 1 0-3c.018 0 .034.004.051.005A2.5 2.5 0 0 1 21 11c.397 0 .768.101 1.101.266A2.994 2.994 0 0 1 25 9c1.385 0 2.539.944 2.884 2.22.346-.139.721-.22 1.116-.22a3 3 0 0 1 3 3zM10 34.4v4.4c0 .11.09.2.2.2h5.6a.2.2 0 0 0 .2-.2V35a.2.2 0 0 0-.2-.2h-3.3a.201.201 0 0 1-.16-.08l-.28-.44a.201.201 0 0 0-.16-.08h-1.7a.2.2 0 0 0-.2.2zm11 0v4.4c0 .11.09.2.2.2h5.6a.2.2 0 0 0 .2-.2V35a.2.2 0 0 0-.2-.2h-3.3a.201.201 0 0 1-.16-.08l-.28-.44a.201.201 0 0 0-.16-.08h-1.7a.2.2 0 0 0-.2.2zm11 0v4.4c0 .11.09.2.2.2h5.6a.2.2 0 0 0 .2-.2V35a.2.2 0 0 0-.2-.2h-3.3a.201.201 0 0 1-.16-.08l-.28-.44a.201.201 0 0 0-.16-.08h-1.7a.2.2 0 0 0-.2.2zM32 21H17v4h15v-4zm-13 2h6m3.083 0H30m2-6H17v4h15v-4zm-13 2h6m3.083 0H30m6 17h.917M25 36h.917M14 36h.917M25.5 28.5a1.5 1.5 0 1 0-3.001.001A1.5 1.5 0 0 0 25.5 28.5zM24 30v3m0-6v-2m-11 8v-4.5h9.5m3 0H35V33"
  }), props.children);
});
var CloudStrategy =
/*#__PURE__*/
React.forwardRef(function CloudStrategy(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M15.46 28.722C11.805 28.223 9 25.047 9 21.255c0-4.138 3.343-7.493 7.482-7.493 1.007 0 1.966.202 2.843.562A7.485 7.485 0 0 1 26.107 10c4.005 0 7.267 3.145 7.473 7.099A5.82 5.82 0 0 1 39 22.912a5.81 5.81 0 0 1-5.822 5.817c-.044 0-.086-.006-.13-.006"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M19 40.229v-19m10 19v-19m-10 2h10m-10 5h10m-10 5h10m-10 5h10"
  }), props.children);
});
var CloudTutorials =
/*#__PURE__*/
React.forwardRef(function CloudTutorials(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M25.961 28.08l-2.121-2.121-1.414 1.414-2.477-7.423 7.426 2.473-1.414 1.414 2.121 2.121-2.121 2.122zM12 14.992v13M24 9C15.716 9 9 15.716 9 24s6.716 15 15 15 15-6.716 15-15S32.284 9 24 9zm-2.543 27.388l-11.258-6.5m23.258 2.508l-11.258 6.5M36 20.008v13m-9.457-21.396l11.258 6.5m-12-9.008l-11.258 6.5M24 9C15.716 9 9 15.716 9 24s6.716 15 15 15 15-6.716 15-15S32.284 9 24 9z"
  }), props.children);
});
var CloudUpload =
/*#__PURE__*/
React.forwardRef(function CloudUpload(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M15.46 29.722C11.805 29.223 9 26.047 9 22.255c0-4.138 3.343-7.493 7.482-7.493 1.007 0 1.966.202 2.843.562A7.485 7.485 0 0 1 26.107 11c4.005 0 7.267 3.145 7.473 7.099A5.82 5.82 0 0 1 39 23.912a5.81 5.81 0 0 1-5.822 5.817c-.044 0-.086-.006-.13-.006"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M18 26l6-6 6 6m-6 11V20"
  }), props.children);
});
var CloudVmware =
/*#__PURE__*/
React.forwardRef(function CloudVmware(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M39 39h-8l8-8v8zm-8-8l-8 8h8v-8zm8-8l-8 8h8v-8zm0-8l-8 8h8v-8zm-8 8l-8 8h8v-8zm-8 8l-8 8h8v-8zM10.999 17.725v-6M17 9a8 8 0 1 0 0 16 8 8 0 0 0 0-16zm-2.373 13.559l-5.196-3m11.197 2.275l-5.196 3m7.569-8.559v6m-3.628-10.834l5.196 3m-11.197-2.275l5.196-3"
  }), props.children);
});
var CloudyDewy =
/*#__PURE__*/
React.forwardRef(function CloudyDewy(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M22.999 17.5l2.598 3.501h0a3.001 3.001 0 1 1-5.196 0h0l2.598-3.501zm-.597 16.501h0a3 3 0 1 0 5.195 0h0L24.999 30.5l-2.597 3.501zm9-8h0a3 3 0 1 0 5.195 0h0L33.999 22.5l-2.597 3.501zM39 20.074a5.574 5.574 0 0 0-5.574-5.574c-.627 0-1.458.108-2.02.299C30.24 11.804 27.335 9.5 23.927 9.5c-4.177 0-7.606 3.537-7.992 7.613a4.632 4.632 0 0 0-2.303-.613C11.058 16.5 9 18.586 9 21.158c0 2.573 2.058 4.309 4.631 4.342H17"
  }), props.children);
});
var CloudyHazy =
/*#__PURE__*/
React.forwardRef(function CloudyHazy(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M17 28h15m-10-4h14m-14 8h14m-16 4h12M9 32h7m-2.369-4C11.058 27.967 9 26.231 9 23.658 9 21.086 11.058 19 13.631 19c.839 0 1.624.225 2.303.613C16.32 15.537 19.75 12 23.927 12c3.408 0 6.313 2.304 7.479 5.299.563-.191 1.393-.299 2.02-.299A5.574 5.574 0 0 1 39 22.574"
  }), props.children);
});
var CloudyHumid =
/*#__PURE__*/
React.forwardRef(function CloudyHumid(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M38.5 31.5c-.951 0-1.357-.474-2.031-1s-1.049-1-2-1-1.326.474-2 1-1.017 1-1.969 1-1.357-.474-2.031-1-1.049-1-2-1c-.951 0-1.326.474-2 1s-1.017 1-1.969 1-1.357-.474-2.031-1-1.049-1-2-1c-.951 0-1.326.474-2 1s-1.017 1-1.969 1-1.357-.474-2.031-1-1.049-1-2-1m0 6c.951 0 1.326.474 2 1s1.08 1 2.031 1 1.294-.474 1.969-1 1.049-1 2-1c.951 0 1.326.474 2 1s1.08 1 2.031 1 1.294-.474 1.969-1 1.049-1 2-1c.951 0 1.326.474 2 1s1.08 1 2.031 1 1.294-.474 1.969-1 1.049-1 2-1 1.326.474 2 1 1.08 1 2.031 1m1-16.426c0 3.078-2.495 5.393-5.574 5.426H14.131c-2.573-.033-4.631-1.769-4.631-4.342 0-2.573 2.058-4.658 4.631-4.658.839 0 1.624.225 2.303.613.386-4.076 3.815-7.613 7.992-7.613 3.408 0 6.313 2.304 7.479 5.299.563-.191 1.393-.299 2.02-.299a5.574 5.574 0 0 1 5.575 5.574z"
  }), props.children);
});
var CloudyPartial =
/*#__PURE__*/
React.forwardRef(function CloudyPartial(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M12.421 21.671a5.25 5.25 0 0 1 5.25-5.25c.657 0 1.171.029 1.75.25m-1.75-2.126V13m-3.563 2.5l-.773-1.338M11.5 18.108l-1.338-.773M21.233 15.5l.773-1.338m-11.461 7.509H9m24.758-.155c-.59 0-1.155.102-1.684.282A7.533 7.533 0 0 0 25.039 17a7.536 7.536 0 0 0-7.517 6.813 4.354 4.354 0 0 0-2.166-.576c-2.42 0-4.356 1.962-4.356 4.381C11 30.038 12.936 32 15.356 32h18.402a5.242 5.242 0 0 0 0-10.484z"
  }), props.children);
});
var CloudyWindy =
/*#__PURE__*/
React.forwardRef(function CloudyWindy(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M30 25.5a3 3 0 1 1 3 3H18m14 7a3 3 0 1 0 3-3H13m4-7h-3.369C11.058 25.467 9 23.731 9 21.158c0-2.573 2.058-4.658 4.631-4.658.839 0 1.624.225 2.303.613.386-4.076 3.816-7.613 7.993-7.613 3.408 0 6.313 2.304 7.479 5.299.563-.191 1.393-.299 2.02-.299A5.574 5.574 0 0 1 39 20.074"
  }), props.children);
});
var Cloudy =
/*#__PURE__*/
React.forwardRef(function Cloudy(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M39 29.758A5.241 5.241 0 0 1 33.759 35H15.357C12.937 35 11 33.038 11 30.618s1.937-4.381 4.357-4.381c.789 0 1.527.211 2.166.576A7.535 7.535 0 0 1 25.04 20a7.531 7.531 0 0 1 7.034 4.797 5.214 5.214 0 0 1 1.684-.282A5.242 5.242 0 0 1 39 29.758zm-2-7a5.241 5.241 0 0 0-5.241-5.242c-.59 0-1.155.102-1.684.282A7.532 7.532 0 0 0 23.04 13a7.536 7.536 0 0 0-7.517 6.813 4.354 4.354 0 0 0-2.166-.576c-2.42 0-4.357 1.962-4.357 4.381 0 .879.255 1.696.696 2.382"
  }), props.children);
});
var CoatHanger =
/*#__PURE__*/
React.forwardRef(function CoatHanger(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M38 33.019h0A1.981 1.981 0 0 1 36.019 35H11.981A1.981 1.981 0 0 1 10 33.019v0c0-.64.309-1.24.829-1.612L24 22l13.171 9.408c.52.371.829.972.829 1.611zM21 16a3 3 0 1 1 3 3v3"
  }), props.children);
});
var CognosAnalytics =
/*#__PURE__*/
React.forwardRef(function CognosAnalytics(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M35 12a2 2 0 1 1-3.999.001A2 2 0 0 1 35 12zm-19 4a2 2 0 1 0-.001 3.999A2 2 0 0 0 16 16zm8 6a2 2 0 1 0-.001 3.999A2 2 0 0 0 24 22zm-8 6a2 2 0 1 0-.001 3.999A2 2 0 0 0 16 28zm17 6a2 2 0 1 0-.001 3.999A2 2 0 0 0 33 34zM20 12h9m-9 6h9m-18 6h9m0 6h9m-9 6h9"
  }), props.children);
});
var College =
/*#__PURE__*/
React.forwardRef(function College(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M15 23v8m24 5H9v3h30v-3zM24 9L9 21h30L24 9zm13 24H11v3h26v-3zM18 21h-6v12h6V21zm15 2v8m3-10h-6v12h6V21zm-12-7.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5z"
  }), props.children);
});
var ConceptExpansion =
/*#__PURE__*/
React.forwardRef(function ConceptExpansion(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M18.999 23.998h10.005M14 19a5 5 0 1 0 .001 10.001A5 5 0 0 0 14 19zm25 3H29v4h10v-4zm0 13H29v4h10v-4zm0-26H29v4h10V9zm-10 1.998L24 11v26h5"
  }), props.children);
});
var ConceptInsights =
/*#__PURE__*/
React.forwardRef(function ConceptInsights(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M32.297 19.3l-2.714-4.75m2.686 14.145l-2.709 4.742M29 24.002H15.033M34 19.003a5 5 0 1 0 .001 10.001A5 5 0 0 0 34 19.003zM28.003 9a3 3 0 1 0 0 6 3 3 0 0 0 0-6zM12 21.001a3 3 0 1 0 0 6 3 3 0 0 0 0-6zM12 33a3 3 0 1 0 0 6 3 3 0 0 0 0-6zm16.003 0a3 3 0 1 0 0 6 3 3 0 0 0 0-6zm-13.385 1.531l14.792-8.54"
  }), props.children);
});
var Connect =
/*#__PURE__*/
React.forwardRef(function Connect(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M16 16H9V9h7v7zm23 4.5h-7v7h7v-7zM27.5 32h-7v7h7v-7zM22 9v7l6-3.536L22 9zm2 11.5a3.5 3.5 0 1 0 0 7 3.5 3.5 0 0 0 0-7zM35.5 9a3.5 3.5 0 1 0 0 7 3.5 3.5 0 0 0 0-7zm-23 23a3.5 3.5 0 1 0 0 7 3.5 3.5 0 0 0 0-7zm23-16v4.493M27.5 24H32m-8 3.5V32m-8-19.5h6m-7.025 20.525l6.551-6.551M27.493 36.5H31.5a4 4 0 0 0 4-4v-5.007M12.5 16v4a4 4 0 0 0 4 4h4"
  }), props.children);
});
var ConsoleWireless =
/*#__PURE__*/
React.forwardRef(function ConsoleWireless(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M13.202 13.195A15.946 15.946 0 0 1 24 9c4.163 0 7.955 1.592 10.801 4.198m-2.832 2.832a11.956 11.956 0 0 0-7.97-3.03 11.956 11.956 0 0 0-7.966 3.026m13.1 2.84A7.965 7.965 0 0 0 24 17a7.97 7.97 0 0 0-5.13 1.863"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M37.321 38.373a3.976 3.976 0 0 1-2.153.627h-.338a4.006 4.006 0 0 1-2.834-1.17L29 34.997H19l-3.029 2.843A3.999 3.999 0 0 1 13.153 39h-.321a3.976 3.976 0 0 1-2.153-.627c-1.477-.946-2.02-2.853-1.465-4.517l3.162-9.487A1.998 1.998 0 0 1 14.272 23h19.455a2 2 0 0 1 1.897 1.369l3.163 9.487c.555 1.663.012 3.571-1.466 4.517zM13.998 29.5h6m-3-2.998v6"
  }), React.createElement("path", {
    d: "M32 27.002a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm-1 3.999a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm-2.5-2.499a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm5 0a1 1 0 1 0 0 2 1 1 0 0 0 0-2z"
  }), props.children);
});
var Console =
/*#__PURE__*/
React.forwardRef(function Console(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M37.321 38.371a3.977 3.977 0 0 1-2.153.629h-.338a4.003 4.003 0 0 1-2.834-1.172L29 34.996H19l-3.029 2.843A4 4 0 0 1 13.153 39h-.321a3.977 3.977 0 0 1-2.153-.629c-1.477-.946-2.02-2.853-1.465-4.517l3.162-9.487A1.997 1.997 0 0 1 14.272 23h19.455a2 2 0 0 1 1.897 1.367l3.163 9.487c.555 1.664.012 3.572-1.466 4.517zM14 29.5h6m-3-3v6"
  }), React.createElement("path", {
    d: "M32 27a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm-1 4a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm-2.5-2.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm5 0a1 1 0 1 0 0 2 1 1 0 0 0 0-2z"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M24 23V13a4 4 0 1 1 4 4H15"
  }), props.children);
});
var Construct =
/*#__PURE__*/
React.forwardRef(function Construct(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M38 14h-4v-4h4v4zm0 2h-4v4h4v-4zm-6-6h-4v4h4v-4zm0 6h-4v4h4v-4zm-6 0h-4v4h4v-4zm-12 0h-4v4h4v-4zm12 6h-4v4h4v-4zm0 12h-4v4h4v-4zm-12 0h-4v4h4v-4zm6-12h-4v4h4v-4zm0-12h-4v4h4v-4zm0 18h-4v4h4v-4zm18-6h-4v4h4v-4zm0 6h-4v4h4v-4zm0 6h-4v4h4v-4zm-6-6h-4v4h4v-4zm0 6h-4v4h4v-4z"
  }), props.children);
});
var Conversation =
/*#__PURE__*/
React.forwardRef(function Conversation(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    d: "M19.5 25.998a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm3-1a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm-8 0a1 1 0 1 0 0 2 1 1 0 0 0 0-2zM31 14a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm4 0a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm-8 0a1 1 0 1 0 0 2 1 1 0 0 0 0-2z"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M19 39l-4-5.999h-4c-1.1 0-2-.9-2-2V21c0-1.1.9-2 2-2h15c1.1 0 2 .9 2 2v10.001c0 1.1-.9 2-2 2h-7M32 25l2-4h3c1.1 0 2-.9 2-2v-8c0-1.1-.9-2-2-2H25c-1.1 0-2 .9-2 2v7.999M31 21h-3.009"
  }), props.children);
});
var CopenhagenPlanetarium =
/*#__PURE__*/
React.forwardRef(function CopenhagenPlanetarium(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "square",
    strokeMiterlimit: "10",
    strokeWidth: ".696",
    d: "M34 26h2m-18 2h-2l-2 2h-2"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: "10",
    strokeWidth: ".696",
    d: "M22 30h-2l-2 2h-2l-2 2h-2"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "square",
    strokeMiterlimit: "10",
    strokeWidth: ".696",
    d: "M14 26h-2"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: "10",
    strokeWidth: ".696",
    d: "M22 34h-2l-2 2h-2l-2 2h-2V18m14 16h2l2 2h2l2 2h2V18"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: "10",
    strokeWidth: ".696",
    d: "M26 30h2l2 2h2l2 2h2"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "square",
    strokeMiterlimit: "10",
    strokeWidth: ".696",
    d: "M30 28h2l2 2h2"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M12 18l12 8 12-8"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M13.068 14.712c.601-.886 1.428-1.69 2.446-2.369m-2.446 2.369C12.388 15.716 12 16.827 12 18c0 4.418 5.373 8 12 8s12-3.582 12-8c0-1.173-.388-2.284-1.068-3.288m0 0c-.601-.886-1.428-1.69-2.446-2.369m-.001 0c-1.018-.679-2.224-1.23-3.554-1.631m-9.862 0C20.574 10.259 22.24 10 24 10s3.426.259 4.931.712m-9.862 0c-1.33.401-2.535.952-3.554 1.631"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M34.932 14.712L24 22l-10.932-7.288"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M32.485 12.343L24 18l-8.485-5.657"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M19.069 10.712L24 14l4.931-3.288"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".696",
    d: "M24 10v28"
  }), props.children);
});
var CopenhagenSnekkja =
/*#__PURE__*/
React.forwardRef(function CopenhagenSnekkja(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M16 11a6 6 0 1 1 0 12h10a6 6 0 1 0 0-12H16z"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M24 9v2m0 12v4"
  }), React.createElement("circle", {
    cx: "18",
    cy: "30",
    r: "1",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72"
  }), React.createElement("circle", {
    cx: "18",
    cy: "30",
    r: "3",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72"
  }), React.createElement("circle", {
    cx: "24",
    cy: "30",
    r: "1",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72"
  }), React.createElement("circle", {
    cx: "30",
    cy: "30",
    r: "1",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M37 26v-2l2 2"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M11 26v6a4 4 0 0 0 4 4h18a4 4 0 0 0 4-4v-6a4 4 0 0 1-4 4m-22-4a4 4 0 0 0 4 4"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M27.879 32.121L21 39m6.879-6.879c.543.543 1.293.879 2.121.879s1.578-.336 2.121-.879c.543-.543.879-1.293.879-2.121s-.336-1.578-.879-2.121S30.828 27 30 27s-1.578.336-2.121.879C27.336 28.422 27 29.172 27 30s.336 1.578.879 2.121zm-6 0L15 39m6.879-6.879c.543.543 1.293.879 2.121.879s1.578-.336 2.121-.879c.543-.543.879-1.293.879-2.121s-.336-1.578-.879-2.121S24.828 27 24 27s-1.578.336-2.121.879C21.336 28.422 21 29.172 21 30s.336 1.578.879 2.121z"
  }), props.children);
});
var CreditCard =
/*#__PURE__*/
React.forwardRef(function CreditCard(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M37 34H11c-1.1 0-2-.9-2-2V16c0-1.1.9-2 2-2h26c1.1 0 2 .9 2 2v16c0 1.1-.9 2-2 2zM9 18h30M9 21h30"
  }), props.children);
});
var Crop =
/*#__PURE__*/
React.forwardRef(function Crop(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M36 15V9m-3 3h6M12 39v-6m-3 3h6m15-24H14c-1.1 0-2 .9-2 2v16m6 6h16c1.1 0 2-.9 2-2V18"
  }), props.children);
});
var CustomerService =
/*#__PURE__*/
React.forwardRef(function CustomerService(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M19.149 25H14v-6c0-5.523 4.477-10 10-10s10 4.477 10 10v6h-5.149m10.15 14C39 31 33.77 27.376 27.364 25.857a8.286 8.286 0 0 0 4.924-7.57v-.4.001a12.956 12.956 0 0 1-7.287-3.507h0a12.963 12.963 0 0 1-9.289 3.616h0v.29a8.283 8.283 0 0 0 4.924 7.57C14.23 27.376 9 31 9 39m15-17a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm1 1c3 0 7.288-1.477 7.288-5.113"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M17.159 27.151L24 38l6.841-10.849M30 36h6"
  }), props.children);
});
var DataBackup =
/*#__PURE__*/
React.forwardRef(function DataBackup(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M14 12h20v6H14zm1 3h6.5"
  }), React.createElement("circle", {
    cx: "31.5",
    cy: "15",
    r: ".5"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M14 21h20v6H14zm1 3h6.5"
  }), React.createElement("circle", {
    cx: "31.5",
    cy: "24",
    r: ".5"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M14 30h20v6H14zm1 3h6.5"
  }), React.createElement("circle", {
    cx: "31.5",
    cy: "33",
    r: ".5"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M34 15h4v9h-4m-20 9h-4v-9h4"
  }), props.children);
});
var DataInsights =
/*#__PURE__*/
React.forwardRef(function DataInsights(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M23 39h-6v-6h6v6zm8-14h-6v6h6v-6zM12 9a3 3 0 1 0 0 6 3 3 0 0 0 0-6zm0 24a3 3 0 1 0 0 6 3 3 0 0 0 0-6zm16 0a3 3 0 1 0 0 6 3 3 0 0 0 0-6zm8 0a3 3 0 1 0 0 6 3 3 0 0 0 0-6zm-16-8a3 3 0 1 0 0 6 3 3 0 0 0 0-6zm16 0l-3.464 6h6.928L36 25zm-24 0v-7m-2.828 4.171L12 25l2.828-2.828"
  }), props.children);
});
var DataProcessing =
/*#__PURE__*/
React.forwardRef(function DataProcessing(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M10 10h14v5H10zm2 2h6m-8 5h14v5H10zm2 2h6"
  }), React.createElement("circle", {
    cx: "21.5",
    cy: "12",
    r: ".5"
  }), React.createElement("circle", {
    cx: "21.5",
    cy: "19",
    r: ".5"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M24 26h14v5H24zm2 2h6m-8 5h14v5H24zm2 2h6"
  }), React.createElement("circle", {
    cx: "35.5",
    cy: "28",
    r: ".5"
  }), React.createElement("circle", {
    cx: "35.5",
    cy: "35",
    r: ".5"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M26 16h10v8m-14 8H12v-8"
  }), props.children);
});
var DataStorage =
/*#__PURE__*/
React.forwardRef(function DataStorage(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".671",
    d: "M39 34v5H9v-5m0-8v5h30v-5M9 18v5h30v-5M9 10v5h30v-5"
  }), props.children);
});
var Delete =
/*#__PURE__*/
React.forwardRef(function Delete(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M29.811 24l7.99 7.99a4.121 4.121 0 0 1 0 5.811h0a4.121 4.121 0 0 1-5.811 0L24 29.811l-7.99 7.99a4.121 4.121 0 0 1-5.811 0h0a4.121 4.121 0 0 1 0-5.811l7.99-7.99-.005-.005-7.985-7.985a4.121 4.121 0 0 1 0-5.811h0a4.121 4.121 0 0 1 5.811 0l7.99 7.99 7.99-7.99a4.121 4.121 0 0 1 5.811 0h0a4.121 4.121 0 0 1 0 5.811L29.811 24h0z"
  }), props.children);
});
var DeliverInsights =
/*#__PURE__*/
React.forwardRef(function DeliverInsights(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M15.927 29.991H8.999l3.464-6 3.464 6zm8.066 9l3.114-3.114c.354-.354.536-.816.544-1.28a1.851 1.851 0 0 0-.544-1.347c-.363-.363-.838-.544-1.314-.544s-.951.181-1.314.544l-.486.486-.486-.486a1.851 1.851 0 0 0-1.317-.544 1.852 1.852 0 0 0-1.31.544 1.853 1.853 0 0 0-.544 1.322c.002.473.183.945.544 1.306l3.113 3.113zm-8-26.01h-6v6h6v-6zm16.042 1.01v4l3.464 2 3.464-2v-4l-3.464-2-3.464 2zm3.958 11.005a3 3 0 1 0 0 6 3 3 0 0 0 0-6zm-12-16.015a3 3 0 1 0 0 6 3 3 0 0 0 0-6zM34 39c0-4.625-3.145-8.506-7.409-9.649a5.501 5.501 0 1 0-5.182 0C17.156 30.425 14 34.375 14 39"
  }), props.children);
});
var DeliveryTruck =
/*#__PURE__*/
React.forwardRef(function DeliveryTruck(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M12 33h-1a2 2 0 0 1-2-2v-7h12m16-9H23m14 3H25m12 3H27m10 3h-8m8 9h2V12H21v21h10M18 17v7m-3 6a3 3 0 1 0 0 6 3 3 0 0 0 0-6zm19 0a3 3 0 1 0 0 6 3 3 0 0 0 0-6zM9 24l4.041-7H21v16h-3m-1-7h2"
  }), props.children);
});
var DesignAndDevelopment_01 =
/*#__PURE__*/
React.forwardRef(function DesignAndDevelopment_01(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M39 30H9V9h30v21zM9 33h30M9 12h30M9 36h30M9 39h30"
  }), React.createElement("path", {
    d: "M37 10.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0zm-2.5-.5a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1zm-2 0a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1z"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M12 16h6m-6 3h6m-6 3h6"
  }), props.children);
});
var DesignAndDevelopment_02 =
/*#__PURE__*/
React.forwardRef(function DesignAndDevelopment_02(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    d: "M37 10.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0zm-2.5-.5a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1zm-2 0a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1z"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M12 16h10m-10 3h10m-10 3h6m21 8H9V9h30v21zM9 33h30M9 12h30M9 36h30M9 39h30m-7-24a4 4 0 1 0 0 8 4 4 0 0 0 0-8zm0 4l3.457-2.013M32 19l-3.457-2.013M32 19l-2.007 3.461"
  }), props.children);
});
var Desktop =
/*#__PURE__*/
React.forwardRef(function Desktop(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M37 32H11c-1.1 0-2-.9-2-2V13c0-1.1.9-2 2-2h26c1.1 0 2 .9 2 2v17c0 1.1-.9 2-2 2zm-20 5h14m-7-5v5M9 27h30"
  }), props.children);
});
var Devops =
/*#__PURE__*/
React.forwardRef(function Devops(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M26 9l2 3.464-2 3.464h-4l-2-3.464L22 9h4zm-4 6.928l-3 5.196m-8.99-2.892l2 3.464h4l2-3.464-2-3.464h-4l-2 3.464zm9 8.66l-3-5.196m-4 11.536h4l2-3.464-2-3.464h-4l-2 3.464 2 3.464zm12-3.464h-6M26 39l2-3.464-2-3.464h-4l-2 3.464L22 39h4zm0-6.928l3-5.196m8.99 2.892l-2-3.464h-4l-2 3.464 2 3.464h4l2-3.464zm-9-8.66l3 5.196m4-11.536h-4l-2 3.464 2 3.464h4l2-3.464-2-3.464zm-6 3.464h-6"
  }), props.children);
});
var Dialogue =
/*#__PURE__*/
React.forwardRef(function Dialogue(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M24 31H13c-2.2 0-4-1.8-4-4V13c0-2.2 1.8-4 4-4h22c2.2 0 4 1.8 4 4v14c0 2.2-1.8 4-4 4h-7l-4 8"
  }), React.createElement("path", {
    d: "M26 20a2 2 0 1 1-3.999.001A2 2 0 0 1 26 20zm6-2a2 2 0 1 0-.001 3.999A2 2 0 0 0 32 18zm-16 0a2 2 0 1 0-.001 3.999A2 2 0 0 0 16 18z"
  }), props.children);
});
var Digital =
/*#__PURE__*/
React.forwardRef(function Digital(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M14 11.5a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0zm-2.5 10v-4m0 8.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5zm0 12.5v-4M28 9a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5zm0 12.5v-4m0 8.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5zm0 12.5v-4m8.5 4.5a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5zm0-12.5v4m0-8.5a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5zm0-12.5v4M20 39a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5zm0-12.5v4m0-8.5a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5zm0-12.5v4"
  }), props.children);
});
var Dining =
/*#__PURE__*/
React.forwardRef(function Dining(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M23 9v10a2 2 0 0 1-2 2h-1v18h-3V21h-1a2 2 0 0 1-2-2V9m17 30V24h2V12a3 3 0 0 0-3-3h-2v30h3zM17 9v8m3-8v8"
  }), props.children);
});
var Dna =
/*#__PURE__*/
React.forwardRef(function Dna(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M16.997 10.055c0 6.94 14.005 7.078 14.005 14.019 0 3.019-2.207 4.587-5.252 6.122m.001-14.033c2.83-1.512 5.252-3.222 5.252-6.108m-8.754 21.884c-2.83 1.512-5.252 3.222-5.252 6.108m5.252-20.114c-3.045 1.535-5.252 3.103-5.252 6.122 0 6.94 14.005 7.078 14.005 14.019M17 24h14m-12.85-3h11.7m-12.437-9h13.173M17.5 36h13M18 27h12M16.997 10.055V9m14.006 1.055V9M16.997 38.047V39m14.006-.926V39"
  }), props.children);
});
var DoNot =
/*#__PURE__*/
React.forwardRef(function DoNot(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M39 24c0 8.284-6.716 15-15 15S9 32.284 9 24 15.716 9 24 9s15 6.716 15 15zm-12.15 0l3.562-3.562a2.02 2.02 0 0 0 0-2.85h0a2.02 2.02 0 0 0-2.85 0L24 21.15h0l-3.562-3.562a2.02 2.02 0 0 0-2.85 0h0a2.02 2.02 0 0 0 0 2.85L21.15 24h0l-3.562 3.562a2.02 2.02 0 0 0 0 2.85h0a2.02 2.02 0 0 0 2.85 0L24 26.85h0l3.562 3.562a2.02 2.02 0 0 0 2.85 0h0a2.02 2.02 0 0 0 0-2.85L26.85 24h0z"
  }), props.children);
});
var Docker =
/*#__PURE__*/
React.forwardRef(function Docker(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("circle", {
    cx: "20",
    cy: "30",
    r: ".75"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M36.109 21.51A3.433 3.433 0 0 1 39 23.202a3.435 3.435 0 0 1-2.97 1.696h-.532C35.142 28.96 28.104 35 19.306 35 13.614 35 9 30.509 9 24.899v-.898l24.7.003a3.366 3.366 0 0 1-1.112-2.498c0-1.272.71-2.378 1.76-2.959a3.38 3.38 0 0 1 1.761 2.959v.004M11.965 32c2.398 0 4.545-.271 5.98-.698M30 20h-4v4h4v-4zm-4 0h-4v4h4v-4zm-4 0h-4v4h4v-4zm4-4h-4v4h4v-4zm0-4h-4v4h4v-4zm-4 4h-4v4h4v-4zm-4 4h-4v4h4v-4z"
  }), props.children);
});
var Doctor =
/*#__PURE__*/
React.forwardRef(function Doctor(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M26.823 14h4.787m-15.221 0h4.78M39 39c0-6.871-5.23-12.624-11.637-14.143a8.286 8.286 0 0 0 4.924-7.57 8.288 8.288 0 0 0-16.575 0 8.283 8.283 0 0 0 4.924 7.57C14.229 26.376 9 32.129 9 39m16-4h8m-4-4.003v8M24 12a3 3 0 1 0 0 6 3 3 0 0 0 0-6z"
  }), props.children);
});
var DocumentConversion =
/*#__PURE__*/
React.forwardRef(function DocumentConversion(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M21 24.002h6m0-13.001H15.004v6m-.004 14v6h12m-6-20H9v14h12v-14zM39 9H27v4h12V9zm0 13.001H27v4h12v-4zM39 35H27v4h12v-4zM11.004 21.001h8m-8 2.999h8m-8 3.001h8"
  }), props.children);
});
var DoorHandle =
/*#__PURE__*/
React.forwardRef(function DoorHandle(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("circle", {
    cx: "20",
    cy: "31",
    r: "1"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M20 31v2.958M20 15a5 5 0 1 0 .001 10.001A5 5 0 0 0 20 15zm11 10v14H9V9h22v6m-6.21 3.501H37.5c.83 0 1.5.67 1.5 1.5 0 .82-.67 1.5-1.5 1.5H24.77"
  }), props.children);
});
var DownloadAlt =
/*#__PURE__*/
React.forwardRef(function DownloadAlt(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M31 20h8v19H9V20h8"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M30 27l-6 6-6-6m6-18v24"
  }), props.children);
});
var Download =
/*#__PURE__*/
React.forwardRef(function Download(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M39 31v8H9v-8"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M30 25l-6 6-6-6m6-16v22"
  }), props.children);
});
var DubaiPalmIslands =
/*#__PURE__*/
React.forwardRef(function DubaiPalmIslands(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M24 12v27"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M20 34a4 4 0 0 1 8 0m-4-14a4 4 0 0 1 4-4m-8 0a4 4 0 0 1 4 4"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M31.481 36.971a14.863 14.863 0 0 0 3.105-2.38 15.052 15.052 0 0 0 2.392-3.098 14.895 14.895 0 0 0 1.5-3.614c.339-1.27.522-2.573.522-3.879s-.183-2.609-.522-3.879a14.888 14.888 0 0 0-1.5-3.614c-.642-1.111-1.421-2.164-2.372-3.114s-2.003-1.73-3.114-2.372A15.077 15.077 0 0 0 24 9c-1.306 0-2.609.183-3.879.522a14.888 14.888 0 0 0-3.614 1.5c-1.111.642-2.164 1.421-3.114 2.372s-1.73 2.003-2.372 3.114A15.077 15.077 0 0 0 9 24c0 1.306.183 2.609.522 3.879a14.888 14.888 0 0 0 1.5 3.614 15.026 15.026 0 0 0 2.392 3.098 14.95 14.95 0 0 0 3.105 2.38M12 26a6 6 0 1 1 12 0m0 0a6 6 0 1 1 12 0m-20 4a4 4 0 0 1 8 0m0 0a4 4 0 0 1 8 0"
  }), props.children);
});
var DubaiSkyscraper =
/*#__PURE__*/
React.forwardRef(function DubaiSkyscraper(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M20 16v23"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M20 9v7"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M18 39V16h2"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M22 32v-8h-4"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M16 39v-7h6v7"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M39 16a7 7 0 0 1-7-7"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M9 34h7m6 0h17"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M39 18v8m-14.722-8.5l6.928-4M30.5 23.722l4-6.928M30 9h-8"
  }), props.children);
});
var DublinBrewery =
/*#__PURE__*/
React.forwardRef(function DublinBrewery(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M9 32h30M9 36h3v-2h24v2h3"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M22 32v-6m2 6v-6m2 6v-6m2-4v2m-8 0v-2m2 2v-2m2 2v-2m2 2v-2m-14-8h2"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M12 32V9h2v23m20 0V9h2v23"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M12 16h2m-2 4h2m20-6h2m-2 2h2m-2 4h2m-2 2h2m-2 6h2m-2-2h2m-24-4h2m-2 6h2m-2-2h2"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M22 39v-3h4v3m-8 0v-3h2v3m8 0v-3h2v3m2 0v-3h2v3m-20 0v-3h2v3m4-19v-4h8v4M16 32V20h16v12"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M20 32v-6h8v6"
  }), props.children);
});
var DublinCastle =
/*#__PURE__*/
React.forwardRef(function DublinCastle(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M35 33h0c0-.55.45-1 1-1h0c.55 0 1 .45 1 1h0m0 0v4h-2v-4m-24 0h0c0-.55.45-1 1-1h0c.55 0 1 .45 1 1h0m0 0v4h-2v-4"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M15 15h18m-10 0v-2m-2 2v-2m-2 2v-2m-2 2v-2m14 2v-2"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M33 39V15l2-2V9h-2v2h-2V9h-2v2h-2V9h-2v2h-2V9h-2v2h-2V9h-2v2h-2V9h-2v4l2 2v24"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M29 15v-2m-2 2v-2m-2 2v-2m-2 2v-2m-2 20v-2m-2 2v-2m-2 2v-2m14 2v-2m-2 2v-2m-2 2v-2m-2 2v-2m-2 2v-2"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M21 24v-4h6v4m-4 0v-4m2 4v-4m-8 15h2v2h-2zm4 0h2v2h-2zm4 0h2v2h-2zm4 0h2v2h-2z"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M20 24h8"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M15 33h18"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M9 39h30"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M15 28H9m30 0h-6"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "square",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M15 30H9m30 0h-6"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M13 28v-2m-2 2v-2m-2 2v-2m30 2v-2m-2 2v-2m-2 2v-2"
  }), props.children);
});
var DuplicateFile =
/*#__PURE__*/
React.forwardRef(function DuplicateFile(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M28 39H9V17h19v22z"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: ".72",
    d: "M20 17v-2m0-4V9h2"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeDasharray: "3.5294,2.6471",
    strokeLinejoin: "round",
    strokeWidth: ".72",
    d: "M24.647 9h11.029"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: ".72",
    d: "M37 9h2v2"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeDasharray: "4.2353,3.1765",
    strokeLinejoin: "round",
    strokeWidth: ".72",
    d: "M39 14.177v13.235"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: ".72",
    d: "M39 29v2h-2"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeDasharray: "2.8,2.1",
    strokeLinejoin: "round",
    strokeWidth: ".72",
    d: "M34.9 31h-3.85"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: ".72",
    d: "M30 31h-2"
  }), props.children);
});
var Education =
/*#__PURE__*/
React.forwardRef(function Education(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M17.57 17.99a7.17 7.17 0 0 0 3.52 9.75C15.53 29.06 11 34.04 11 40m19.43-22.01a7.176 7.176 0 0 1-3.51 9.75C32.47 29.06 37 34.04 37 40m-20.8-9.97L19.65 36 24 33.49 28.35 36l3.45-5.97m-1.37-12.04v-1.94c-1.49-.82-3.33-2.05-6.4-2.05-3.08 0-4.97 1.23-6.46 2.05v1.94m12.86 0L35 15.35 24 9l-11 6.35 4.57 2.64s12.853-.007 12.86 0zM13 24v-8.65"
  }), props.children);
});
var ElectricCharge =
/*#__PURE__*/
React.forwardRef(function ElectricCharge(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M17 18.804L14 24h4l-3 5.196"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M23 39H9V11a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v28zm16-22v-5h-8v5a4 4 0 0 0 4 4h0a4 4 0 0 0 4-4zm-8-3h8m-6-5v3m4-3v3m-14 2a4 4 0 0 1 4 4v11a4 4 0 0 0 8 0v-8"
  }), props.children);
});
var Electric =
/*#__PURE__*/
React.forwardRef(function Electric(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M15 27a6 6 0 0 1-6-6v-8h12v8a6 6 0 0 1-6 6zm-3-14V9m6 4V9m-9 8h12"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M15 27v6a6 6 0 1 0 12 0V23a6 6 0 1 1 12 0v10"
  }), props.children);
});
var Elevator =
/*#__PURE__*/
React.forwardRef(function Elevator(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M9 9v30M39 9v30M23 13l-3-3-3 3m8-3l3 3 3-3"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M25.5 20.5a1.5 1.5 0 1 1-3.001-.001 1.5 1.5 0 0 1 3.001.001zM34 16H14v23h20V16zm-8.61 20.991v-5.352h0l.346-.141a2 2 0 0 0 1.246-1.851l.002-2.261c.001-1.616-1.208-3.065-2.822-3.15a2.983 2.983 0 0 0-3.145 2.979l-.002 2.428a2 2 0 0 0 1.25 1.855l.31.126.036.018v5.35"
  }), props.children);
});
var Embed =
/*#__PURE__*/
React.forwardRef(function Embed(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M31 26h-9v-9m2-6H11a2 2 0 0 0-2 2v24a2 2 0 0 0 2 2h24a2 2 0 0 0 2-2V24m2-15L22 26"
  }), props.children);
});
var Engine =
/*#__PURE__*/
React.forwardRef(function Engine(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M19 12h12M16 27h16M9 17.909v12.184m0-6.092h3M25 12v3m2 21l-2-3H12V15h24v6h3v15H27zm-3-17a2 2 0 1 0-.001 3.999A2 2 0 0 0 24 19zm6 0a2 2 0 1 0-.001 3.999A2 2 0 0 0 30 19zm-12 0a2 2 0 1 0-.001 3.999A2 2 0 0 0 18 19z"
  }), props.children);
});
var EnterpriseDesignThinkingAlt =
/*#__PURE__*/
React.forwardRef(function EnterpriseDesignThinkingAlt(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M9 9h30M9 13h15M9 39h30m-15-4h15M26 21.999l2.375-2.375c2.189-2.189 6.374-2.206 8.803.197 2.429 2.404 2.429 5.949 0 8.353-2.429 2.403-6.616 2.388-8.764.239h0l-8.794-8.794c-2.176-2.176-6.369-2.199-8.798.205-2.429 2.404-2.429 5.97 0 8.373 2.43 2.403 6.612 2.366 8.796.182l2.381-2.381M22 30v-4h-4"
  }), props.children);
});
var EnterpriseDesignThinking =
/*#__PURE__*/
React.forwardRef(function EnterpriseDesignThinking(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M21.142 26.829a4.074 4.074 0 0 1-5.718 0 3.97 3.97 0 0 1 0-5.657 4.074 4.074 0 0 1 5.718 0l5.718 5.657a4.073 4.073 0 0 0 5.717 0 3.97 3.97 0 0 0 0-5.657 4.073 4.073 0 0 0-5.717 0l-5.718 5.657zM9 9h30M9 39h30M9 13h15m0 4h15M24 35h15M9 31h12"
  }), React.createElement("path", {
    d: "M39 13a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0zm-2.5-.5a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1zm-25 15a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1zm12 3a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1zm-14 4a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1zm29-4a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1zm-29-3a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1zm0-11a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1zm29 3a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1z"
  }), props.children);
});
var Envelope =
/*#__PURE__*/
React.forwardRef(function Envelope(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M39 35H9V13h30v22zM9 13l15 14 15-14M9 35l12-11m6 0l12 11"
  }), props.children);
});
var ErlenmeyerFlask =
/*#__PURE__*/
React.forwardRef(function ErlenmeyerFlask(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M21 12h3m-3 3h3m-3 3h3"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M21 21l-8.788 15.106c-.664 1.329.302 2.894 1.789 2.894h19.997c1.487 0 2.454-1.565 1.789-2.894L27 21V9h-6v12zM19 9h10M16.928 28h14.144"
  }), props.children);
});
var EscalatorDown =
/*#__PURE__*/
React.forwardRef(function EscalatorDown(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: "10",
    strokeWidth: ".717",
    d: "M32 12a2 2 0 1 1 .001 3.999A2 2 0 0 1 32 12zM11 37h6v-6m0 6l-8-8m26-3v-5a3 3 0 1 0-6 0"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M33.44 28.998L18.028 13.586A2 2 0 0 0 16.614 13H13a4 4 0 0 0-4 4v.004a3.997 3.997 0 0 0 3.997 3.997h1.532l15.414 15.413a2 2 0 0 0 1.414.586h3.647A3.996 3.996 0 0 0 39 33.004V33a4.001 4.001 0 0 0-4.001-4.001H33.44"
  }), props.children);
});
var EscalatorUp =
/*#__PURE__*/
React.forwardRef(function EscalatorUp(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M14.56 28.998l15.412-15.412A2 2 0 0 1 31.386 13H35a4 4 0 0 1 4 4v.004a3.997 3.997 0 0 1-3.997 3.997h-1.532L18.057 36.414a2 2 0 0 1-1.414.586H13a4 4 0 0 1-4-4v0a4.001 4.001 0 0 1 4.001-4.001h1.559"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M18 14a2 2 0 1 1-3.999.001A2 2 0 0 1 18 14zm21 21v-6h-6m6 0l-8 8M18.992 21.012C18.992 19.355 17.657 18 16 18s-3 1.343-3 3v5"
  }), props.children);
});
var EuropeAfrica =
/*#__PURE__*/
React.forwardRef(function EuropeAfrica(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M39 24c0 8.284-6.716 15-15 15S9 32.284 9 24 15.716 9 24 9s15 6.716 15 15zM19.239 9.771L19.5 11 15 14.5l.585 2.5h1.591c.43 0 .831-.068 1.069-.426v0A1.282 1.282 0 0 1 19.314 16h6.49l2.696 5-.946 2h-3.937L22 20h-6l-2.027 6.626L16 31.001l5.999.999v5.501L25.034 39m13.965-15.194c-.193.076-3.148.806-4.433 1.134L31.5 21l-1.737 2.5 2.435 3.5h2.803v7.202"
  }), props.children);
});
var ExpandHorz =
/*#__PURE__*/
React.forwardRef(function ExpandHorz(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: ".72",
    d: "M39 9v.01"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeDasharray: "0.0198,1.9802",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: ".72",
    d: "M39 10.99V38"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: ".72",
    d: "M39 38.99V39"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M9 9v30m3-15h24m-3 3l3-3-3-3"
  }), props.children);
});
var ExpandUser =
/*#__PURE__*/
React.forwardRef(function ExpandUser(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M25.5 39v-7c1.109-.4 2-1.268 2-2.4v-4.016C27.5 23.605 25.979 22 24 22s-3.5 1.614-3.5 3.593v4.016c0 1.132.891 1.99 2 2.391v7"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M24 14V9m2.121 2.121L24 9l-2.121 2.121M15.34 19l-4.33-2.5m2.897-.776l-2.897.776.776 2.898M15.34 29l-4.33 2.5m.776-2.898L11.01 31.5l2.898.776M32.66 29l4.33 2.5m-2.897.776l2.897-.776-.776-2.898M32.66 19l4.33-2.5m-.776 2.898l.776-2.898-2.898-.776M24 16a2 2 0 1 0-.001 3.999A2 2 0 0 0 24 16z"
  }), props.children);
});
var ExpandVert =
/*#__PURE__*/
React.forwardRef(function ExpandVert(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: ".72",
    d: "M9 9h.01"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeDasharray: "0.0198,1.9802",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: ".72",
    d: "M10.99 9H38"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: ".72",
    d: "M38.99 9H39"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M9 39h30m-15-3V12m3 3l-3-3-3 3"
  }), props.children);
});
var ExportAlt =
/*#__PURE__*/
React.forwardRef(function ExportAlt(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M31 20h8v19H9V20h8"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M18 15l6-6 6 6m-6-6v24"
  }), props.children);
});
var Export =
/*#__PURE__*/
React.forwardRef(function Export(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M18 16l6-6 6 6m-6 16V10"
  }), props.children);
});
var Eye =
/*#__PURE__*/
React.forwardRef(function Eye(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M31 24a7 7 0 1 1-14 0 7 7 0 0 1 14 0zm-7-3.5a3.5 3.5 0 1 0 0 7 3.5 3.5 0 0 0 0-7zM10 24s3.71 9 14 9 14-9 14-9-3.71-9-14-9-14 9-14 9z"
  }), props.children);
});
var FaceDissatisfied =
/*#__PURE__*/
React.forwardRef(function FaceDissatisfied(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    d: "M18.75 21a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0zM30 20.25a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5z"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M18 31s2-3 6-3 6 3 6 3M24 9C15.716 9 9 15.716 9 24s6.716 15 15 15 15-6.716 15-15S32.284 9 24 9z"
  }), props.children);
});
var FaceNeutral =
/*#__PURE__*/
React.forwardRef(function FaceNeutral(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    d: "M18.75 21a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0zM30 20.25a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5z"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M18 29h12M24 9C15.716 9 9 15.716 9 24s6.716 15 15 15 15-6.716 15-15S32.284 9 24 9z"
  }), props.children);
});
var FaceSatisfied =
/*#__PURE__*/
React.forwardRef(function FaceSatisfied(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    d: "M18.75 21a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0zM30 20.25a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5z"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M30 28s-2 3-6 3-6-3-6-3m6-19C15.716 9 9 15.716 9 24s6.716 15 15 15 15-6.716 15-15S32.284 9 24 9z"
  }), props.children);
});
var FaceVeryDissatisfied =
/*#__PURE__*/
React.forwardRef(function FaceVeryDissatisfied(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    d: "M18.75 21a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0zM30 20.25a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5z"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M18 32a6 6 0 1 1 12 0M24 9C15.716 9 9 15.716 9 24s6.716 15 15 15 15-6.716 15-15S32.284 9 24 9z"
  }), props.children);
});
var FaceVerySatisfied =
/*#__PURE__*/
React.forwardRef(function FaceVerySatisfied(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    d: "M18.75 21a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0zM30 20.25a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5z"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M30 26a6 6 0 1 1-12 0m6-17C15.716 9 9 15.716 9 24s6.716 15 15 15 15-6.716 15-15S32.284 9 24 9z"
  }), props.children);
});
var Factory =
/*#__PURE__*/
React.forwardRef(function Factory(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M34 39V21l-6.5 4v-4l-7 4v-4L14 25m0-4h-4m24 9h1.736c.691 0 1.261.553 1.261 1.244V39M34 28h1.834c1.29 0 3.169.718 3.163 3.193V39M12.07 12.917c0-1.054-.593-1.958-1.536-1.958h0C9.479 10.958 9 10.311 9 9m2.5 0c1.5 0 2.497 1 2.497 2.5M30 30v-2m-4 2v-2m-4 2v-2m-4 2v-2m3.997 11v-6h4v6"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M39 39H10h0V14h4v25"
  }), props.children);
});
var Farm =
/*#__PURE__*/
React.forwardRef(function Farm(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M9 32h8.186c8.157 0 12.992 2.77 16.814 7m0-4c-3.821-4.229-8.656-7-16.814-7H9m25 3c-3.821-4.229-8.656-7-16.814-7H9"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M12 17v7m6-6v6m-6-11a2 2 0 1 0-.001 3.999A2 2 0 0 0 12 13zm6 1a2 2 0 1 0-.001 3.999A2 2 0 0 0 18 14zm14-1a3 3 0 1 0 0 6 3 3 0 0 0 0-6zm0-4v2m-4.95.05l1.414 1.414M25 16h2m.05 4.949l1.414-1.414M32 23v-2m4.949-.051l-1.414-1.414M39 16h-2m-.051-4.95l-1.414 1.414"
  }), props.children);
});
var Faucet =
/*#__PURE__*/
React.forwardRef(function Faucet(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M39 39V9m-12 9v-4m12 4H22.661C15.147 18 9 24.487 9 32h7c0-4.254 3.135-8.002 7.389-8.002H39M11.113 36.925c-.323.762.041 1.64.811 1.959a1.49 1.49 0 0 0 1.959-.811 1.47 1.47 0 0 0 .001-1.148l-1.385-3.344-1.386 3.344zm21.45-26.923h-3.689A2.377 2.377 0 0 0 26.937 9c-.8 0-1.505.397-1.938 1.002h-3.562c-.828 0-1.437.672-1.437 1.5s.608 1.5 1.437 1.5h3.751c.436.473 1.055.773 1.749.773s1.313-.301 1.749-.773h3.877c.828 0 1.437-.672 1.437-1.5s-.608-1.5-1.437-1.5z"
  }), props.children);
});
var Feedback =
/*#__PURE__*/
React.forwardRef(function Feedback(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M36.652 27C35.298 32.733 30.147 37 24 37c-7.18 0-13-5.82-13-13m2 2l-2-2-2 2m28-2c0-7.18-5.817-13-12.997-13-6.147 0-11.298 4.267-12.652 10M35 22l2 2 2-2m-15 7.505l5.455-5.455c.621-.621.938-1.43.953-2.243a3.244 3.244 0 0 0-.953-2.36 3.242 3.242 0 0 0-2.301-.953c-.833 0-1.666.318-2.301.953L24 20.3l-.852-.852a3.243 3.243 0 0 0-2.307-.953 3.245 3.245 0 0 0-2.295.953 3.244 3.244 0 0 0-.953 2.316c.004.828.321 1.655.953 2.287L24 29.505z"
  }), props.children);
});
var FileBackup =
/*#__PURE__*/
React.forwardRef(function FileBackup(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M24 39H9V17h15v22zm.015-4h7.5V13h-15v3.985m15 14.015H39V9H24v4"
  }), props.children);
});
var FileTransfer =
/*#__PURE__*/
React.forwardRef(function FileTransfer(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M39 9v12H9V9m30 30v-6l-9-9H9v15m21-15v9h9"
  }), props.children);
});
var FinancialConsultant =
/*#__PURE__*/
React.forwardRef(function FinancialConsultant(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M32 28.5V30m0 4v1.5m2-5.5h-3a1 1 0 1 0 0 2h2a1 1 0 0 1 0 2h-3m2-9a6.958 6.958 0 0 0-3.889 1.182 6.89 6.89 0 0 0-2.333 2.621A6.91 6.91 0 0 0 25 32a7 7 0 1 0 7-7zm-4.24 1.4c-1.17-1.18-2.61-2.1-4.21-2.66 2.51-1.3 4.24-3.89 4.24-6.91C27.79 12.5 24.32 9 20 9c-4.33 0-7.87 3.5-7.87 7.83 0 3.02 1.73 5.61 4.24 6.92C12.1 25.25 9 29.28 9 34.05V40"
  }), props.children);
});
var FinancialGain =
/*#__PURE__*/
React.forwardRef(function FinancialGain(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M30 25v2m0 6v2m3-8h-4.501a1.5 1.5 0 0 0 0 3H31.5a1.5 1.5 0 0 1 0 3H27M25 9l-.001 13.52a8.94 8.94 0 0 1 5-1.52L30 9h-5zm-3.001 16.89L22 17h-5v13h4m-7-7H9v7h5v-7zm16-2c-1.85 0-3.57.56-5 1.52a8.857 8.857 0 0 0-3 3.37c-.64 1.23-1 2.63-1 4.11a9 9 0 1 0 9-9z"
  }), props.children);
});
var FinancialNews =
/*#__PURE__*/
React.forwardRef(function FinancialNews(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M24 31H13c-2.2 0-4-1.8-4-4V13c0-2.2 1.8-4 4-4h22c2.2 0 4 1.8 4 4v14c0 2.2-1.8 4-4 4h-7l-4 8m0-25v2m0 8v2m4-10h-6.001a2 2 0 0 0 0 4H26a2 2 0 0 1 0 4h-6"
  }), props.children);
});
var FireAlarm =
/*#__PURE__*/
React.forwardRef(function FireAlarm(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M32 24a8 8 0 1 1-16 0 8 8 0 0 1 16 0zm-8-1.101a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm-9.9-8.798A13.956 13.956 0 0 0 10 24c0 3.866 1.567 7.366 4.101 9.9m2.121-17.678A10.962 10.962 0 0 0 13 24c0 3.038 1.231 5.788 3.222 7.778M33.9 33.899A13.956 13.956 0 0 0 38 24c0-3.866-1.567-7.366-4.101-9.9m-2.121 17.678A10.962 10.962 0 0 0 35 24c0-3.038-1.231-5.788-3.222-7.778"
  }), props.children);
});
var FireExtinguisher =
/*#__PURE__*/
React.forwardRef(function FireExtinguisher(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M22 17.416v-4.051c0-.201.164-.365.365-.365h3.27c.201 0 .365.164.365.365v4.051M25 13V9.365A.366.366 0 0 0 24.635 9h-1.27a.366.366 0 0 0-.365.365V13m6 9a5 5 0 0 0-5-5h0a5 5 0 0 0-5 5v17h10V22zm-6-11h-4l-6 6m16-7v2l6 1V9l-6 1zm0 1h-4m-6 21h10m-10-8h10"
  }), props.children);
});
var Firewall =
/*#__PURE__*/
React.forwardRef(function Firewall(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M11.828 13.172L9 16l2.828 2.828m24.344 16L39 32l-2.828-2.828M9 16h7.616M25 16h14m0 16H25m-8.384 0H9"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M19 9h12v30H19z"
  }), props.children);
});
var FlowChartDetail =
/*#__PURE__*/
React.forwardRef(function FlowChartDetail(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M39 19.999h-8m8 3h-8.414m8.414-9h-9.779m9.779 3h-8.414M20 9C13.925 9 9 13.925 9 20s4.925 11 11 11 11-4.925 11-11S26.075 9 20 9zm18.984 30L27.769 27.784M14 20h5m7.32-8.999H24v6h6.58m-21.16 6H14v-6H9.42m21.16 6H24v6h2.32M24 14h-5v12h5"
  }), props.children);
});
var FlowChart =
/*#__PURE__*/
React.forwardRef(function FlowChart(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M13 37a2 2 0 1 1-3.999.001A2 2 0 0 1 13 37zm6-2a2 2 0 1 0-.001 3.999A2 2 0 0 0 19 35zm10 0a2 2 0 1 0-.001 3.999A2 2 0 0 0 29 35zm8 0a2 2 0 1 0-.001 3.999A2 2 0 0 0 37 35zM24 13v3.999m-9 9v5m17.993-5v5M33 22v-5H15v5m4 13v-4h-8v4m26 0v-4h-8v4M39 9H9v4h30V9zM21 22H9v4h12v-4zm18 0H27v4h12v-4z"
  }), props.children);
});
var Fog =
/*#__PURE__*/
React.forwardRef(function Fog(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M10 18h4m20 0h4m-12 0h4m-12 0h4m-8 4h4m12 0h4m-12 0h4m-12-8h4m12 0h4m-12 0h4M10 26h4m20 0h4m-12 0h4m-12 0h4m-12 8h4m20 0h4m-12 0h4m-12 0h4m-8-4h4m12 0h4m-12 0h4"
  }), props.children);
});
var Folder =
/*#__PURE__*/
React.forwardRef(function Folder(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M10 11h8.5a1 1 0 0 1 .8.4l1.4 2.2a1 1 0 0 0 .8.4H38a1 1 0 0 1 1 1v19.002a1 1 0 0 1-1 1L10 35a1 1 0 0 1-1-1V12a1 1 0 0 1 1-1z"
  }), props.children);
});
var Forklift =
/*#__PURE__*/
React.forwardRef(function Forklift(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M26.411 21.799l-1.5-2.598"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M17 31.764V16h3m2 18h9M9 35h5V21m11 7v6m8.749-9.021V13H24l-4 14.967M21.331 23l4.33-2.5M19 31a3 3 0 1 0 0 6 3 3 0 0 0 0-6zm14.999 0a3 3 0 1 0 0 6 3 3 0 0 0 0-6zm3 3h2v-9H27l-2 3h-5v3.171"
  }), props.children);
});
var FreeTrial =
/*#__PURE__*/
React.forwardRef(function FreeTrial(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M22.982 19.721l-.114.209a2.134 2.134 0 0 1-2.903.773 2.101 2.101 0 0 1-.78-2.881l4.203-7.26M31 21a2 2 0 1 0 4 0v-6m-8 6a2 2 0 1 0 4 0v-6"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M27 15v12a2 2 0 1 1-4 0V12.04C23 10.361 24.372 9 26.064 9h9.873C37.628 9 39 10.361 39 12.04V21a2 2 0 1 1-4 0m-18.5 6.17h-5L9 31.5l2.5 4.33h5L19 31.5z"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M14.75 30.201l3.5-6.062M10 38.428l1.5-2.598"
  }), props.children);
});
var Fuel =
/*#__PURE__*/
React.forwardRef(function Fuel(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M34 39H14c-1.1 0-2-.9-2-2V14c0-1.1.9-2 2-2h20c1.1 0 2 .9 2 2v23c0 1.1-.9 2-2 2zM24 9H14v3h10V9zm7 23L17 18m9 5l5-5M17 32l5-5"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M29 10h4"
  }), props.children);
});
var Gear =
/*#__PURE__*/
React.forwardRef(function Gear(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M35.128 26.957l-1.176 2.812 2.746 2.746-4.183 4.182-2.738-2.738-2.82 1.157V39h-5.915v-3.872l-2.812-1.176-2.746 2.746-4.182-4.182 2.738-2.738-1.157-2.82H9v-5.915h3.872l1.176-2.812-2.746-2.746 4.182-4.182 2.738 2.738 2.82-1.157V9h5.915v3.872l2.812 1.176 2.746-2.746 4.183 4.182-2.738 2.738 1.157 2.82H39v5.915h-3.872zM24 17a7 7 0 1 0 0 14 7 7 0 0 0 0-14z"
  }), props.children);
});
var GlobalBusinessServices =
/*#__PURE__*/
React.forwardRef(function GlobalBusinessServices(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M10.441 28.323l1.668-3.329h1.886l1.886-5.653 2.829 2.825 3.281-3.276M16.5 16.5a7.5 7.5 0 1 0 0 15 7.5 7.5 0 0 0 0-15zm1.072 14.924A11.977 11.977 0 0 0 27 36c6.627 0 12-5.373 12-12s-5.373-12-12-12a11.977 11.977 0 0 0-9.428 4.576M27 36V12m-3 12h15m-18-6h16.394M21 30h16.394m-15.741-.551C22.646 33.338 24.667 36 27 36c3.314 0 6-5.373 6-12s-2.686-12-6-12c-2.333 0-4.354 2.662-5.347 6.55"
  }), props.children);
});
var GlobalFinanceEuro =
/*#__PURE__*/
React.forwardRef(function GlobalFinanceEuro(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M27.154 25.368h3.691M27.154 22L29 24.233 30.846 22M29 27v-2.767M24 39c8.284 0 15-6.716 15-15 0-8.284-6.716-15-15-15-8.284 0-15 6.716-15 15 0 8.284 6.716 15 15 15zm0-30v30m0-15H9m30 0h-5m-18-8h-4.5M16 32h-4.5m2.858-8c0 8.284 4.317 15 9.642 15s9.642-6.716 9.642-15S29.325 9 24 9s-9.642 6.716-9.642 15zM36.5 16H24m12.5 16H24m-4-17.5V16m0 4v1.5m2-5.5h-3a1 1 0 1 0 0 2h2a1 1 0 0 1 0 2h-3m0 9.5h3m1-2.5h-2a2 2 0 0 0-2 2v1a2 2 0 0 0 2 2h2"
  }), props.children);
});
var GlobalFinanceSterling =
/*#__PURE__*/
React.forwardRef(function GlobalFinanceSterling(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M27.154 25.368h3.691M27.154 22L29 24.233 30.846 22M29 27v-2.767M24 39c8.284 0 15-6.716 15-15 0-8.284-6.716-15-15-15-8.284 0-15 6.716-15 15 0 8.284 6.716 15 15 15zm0-30v30m0-15H9m30 0h-5m-18-8h-4.5M16 32h-4.5m2.858-8c0 8.284 4.317 15 9.642 15s9.642-6.716 9.642-15S29.325 9 24 9s-9.642 6.716-9.642 15zM36.5 16H24m12.5 16H24m-6.5-2.51h4.167m.417-1.663c-.417-.416-1.06-.827-1.667-.827-.998 0-1.807.62-1.807 1.724 0 .837.736.778.736 1.609 0 .749-.579 1.181-1.429 1.667h4.167M20 14.5V16m0 4v1.5m2-5.5h-3a1 1 0 1 0 0 2h2a1 1 0 0 1 0 2h-3"
  }), props.children);
});
var GlobalNetwork =
/*#__PURE__*/
React.forwardRef(function GlobalNetwork(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M24 31a7 7 0 1 1 0-14 7 7 0 0 1 0 14zm-2.161-.34l3.553-3.352a.571.571 0 0 0 .103-.702l-2.687-4.667a.573.573 0 0 1 .105-.704l1.858-1.737a.572.572 0 0 0 .105-.704l-1.035-1.792m-3.343 13.06l1.236-2.137a.572.572 0 0 0 0-.573l-.671-1.163a.571.571 0 0 1 .104-.703l1.016-.955a.573.573 0 0 0 .104-.703l-.758-1.313a.572.572 0 0 0-.496-.286h-1.845a.573.573 0 0 1-.495-.285l-.796-1.371m11.535-.939l-1.439 2.507a.574.574 0 0 0 0 .57l1.117 1.942a.57.57 0 0 0 .496.287h1.314M28.43 35.7c3.34-1.27 6-3.93 7.26-7.27m-23.38 0c1.26 3.34 3.92 6 7.26 7.27m16.12-16.13a12.552 12.552 0 0 0-7.26-7.26m-8.86 0a12.552 12.552 0 0 0-7.26 7.26M24 34a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5zm0-25a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5zM11.5 21.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5zm25 0a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5z"
  }), props.children);
});
var GlobalTechnologyServices =
/*#__PURE__*/
React.forwardRef(function GlobalTechnologyServices(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M10.066 20.144a4.002 4.002 0 0 1 0 7.712m12.868-7.713a4.003 4.003 0 0 0 0 7.714M16.5 28v-8m0-3.5a7.5 7.5 0 1 0 0 15 7.5 7.5 0 0 0 0-15zm1.072 14.924A11.977 11.977 0 0 0 27 36c6.627 0 12-5.373 12-12s-5.373-12-12-12a11.977 11.977 0 0 0-9.428 4.576M27 36V12m-3 12h15m-18-6h16.394M21 30h16.394m-15.741-.551C22.646 33.338 24.667 36 27 36c3.314 0 6-5.373 6-12s-2.686-12-6-12c-2.333 0-4.354 2.662-5.347 6.55"
  }), props.children);
});
var GlobeLocations =
/*#__PURE__*/
React.forwardRef(function GlobeLocations(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M34.5 23.861c0 6.627-5.373 12-12 12s-12-5.373-12-12 5.373-12 12-12 12 5.373 12 12zM14.999 36.854a14.93 14.93 0 0 0 7.501 2.007c8.284 0 15-6.716 15-15 0-5.552-3.016-10.399-7.499-12.993m-1.5 2.599L31 9.139M14 38.584l2.499-4.328"
  }), React.createElement("path", {
    d: "M17.75 16a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0zM16 20.25a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5zm14.5 0a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5zm0 3a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5zm-8-1a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5zm4 7a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5z"
  }), props.children);
});
var Globe =
/*#__PURE__*/
React.forwardRef(function Globe(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M26.484 9c5.223 1.687 9.016 6.886 9.016 12.67 0 7.18-5.836 13-13.016 13-3.08 0-5.911-1.071-8.138-2.862M22.5 11C16.701 11 12 15.701 12 21.5S16.701 32 22.5 32 33 27.299 33 21.5 28.299 11 22.5 11zm0 23.67V39m-6.016 0h12"
  }), props.children);
});
var Group =
/*#__PURE__*/
React.forwardRef(function Group(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M16 39v-7.492a8 8 0 0 1 6.149-7.782 4.56 4.56 0 1 1 3.702 0A8 8 0 0 1 32 31.508V39m6-6v-7.492a8 8 0 0 0-6.149-7.782A4.559 4.559 0 0 0 30 9a4.56 4.56 0 0 0-4.183 6.376m-3.633 0a4.561 4.561 0 1 0-8.744-1.816 4.56 4.56 0 0 0 2.709 4.166A8 8 0 0 0 10 25.508V33"
  }), props.children);
});
var HailHeavy =
/*#__PURE__*/
React.forwardRef(function HailHeavy(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    d: "M15 33.98a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm2.5 1.52a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm10 0a1 1 0 1 0 0 2 1 1 0 0 0 0-2zM24 32.98a1 1 0 1 0 0 2 1 1 0 0 0 0-2z"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M15.25 31.598L16.75 29m2 5.196l3-5.196m3.5 2.598L26.75 29m2 5.196l3-5.196m1.676-14c-.627 0-1.458.108-2.02.299C30.24 12.304 27.335 10 23.927 10c-4.177 0-7.606 3.537-7.992 7.613A4.639 4.639 0 0 0 13.631 17C11.058 17 9 19.086 9 21.658c0 2.573 2.058 4.309 4.631 4.342h19.795C36.504 25.967 39 23.652 39 20.574S36.504 15 33.426 15z"
  }), props.children);
});
var HailMixed =
/*#__PURE__*/
React.forwardRef(function HailMixed(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    d: "M23.495 30a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm-7.5 2.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm2.5 3.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm12.5-7a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm-6.5 3.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm2.5 3.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2z"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M19.995 34.366l1-1.732m-3.5-1.768l1-1.732m-5 8.732l1-1.732m14-1.768l1-1.732m-3.5-1.768l1-1.732m-5 8.732l1-1.732M39 20.574c0 3.078-2.495 5.393-5.574 5.426H13.631C11.058 25.967 9 24.231 9 21.658 9 19.086 11.058 17 13.631 17c.839 0 1.624.225 2.303.613C16.32 13.537 19.75 10 23.927 10c3.408 0 6.313 2.304 7.479 5.299.563-.191 1.393-.299 2.02-.299A5.574 5.574 0 0 1 39 20.574z"
  }), props.children);
});
var Hail =
/*#__PURE__*/
React.forwardRef(function Hail(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    d: "M18 31a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm2 4a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm7 0a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm-3-5a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm7 0a1 1 0 1 0 0 2 1 1 0 0 0 0-2z"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M39 21.574c0 3.078-2.495 5.393-5.574 5.426H13.631C11.058 26.967 9 25.231 9 22.658 9 20.086 11.058 18 13.631 18c.839 0 1.624.225 2.303.613C16.32 14.537 19.75 11 23.927 11c3.408 0 6.313 2.304 7.479 5.299.563-.191 1.393-.299 2.02-.299A5.574 5.574 0 0 1 39 21.574z"
  }), props.children);
});
var HandicapActive =
/*#__PURE__*/
React.forwardRef(function HandicapActive(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M27 11a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5zm8 23l-3 2-3.712-6.478a1.002 1.002 0 0 0-.866-.503l-6.069-.012c-1.498-.003-2.461-1.591-1.771-2.921l3.421-6.595C23.495 18.651 24.051 18 25 18c.98 0 1.353.417 1.643 1.109L28.071 24h5M17 22l2-4h6m1 13a7 7 0 1 1-7-7"
  }), props.children);
});
var Handicap =
/*#__PURE__*/
React.forwardRef(function Handicap(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M23 11a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5zm13 23l-3 2-3.712-6.478a1 1 0 0 0-.868-.503H23a3 3 0 0 1-3-3V20c0-1.262.944-2 2-2 .941 0 1.454.521 1.901 1.285L26.02 23H31m-4 8a7 7 0 1 1-9-6.71"
  }), props.children);
});
var HardDriveNetwork =
/*#__PURE__*/
React.forwardRef(function HardDriveNetwork(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    d: "M27.999 14a1 1 0 1 1 0-2 1 1 0 0 1 0 2zM29 24.001a1 1 0 1 0-2 0 1 1 0 0 0 2 0zm.001 11.001a1 1 0 1 0-2 0 1 1 0 0 0 2 0z"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M32 17H9V9h23v8zm0 3H9v8h23v-8zm0 11H9v8h23v-8zm2-7h5m-5 11h5V13h-5"
  }), props.children);
});
var HardDrive =
/*#__PURE__*/
React.forwardRef(function HardDrive(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    d: "M34 14a1 1 0 1 1 0-2 1 1 0 0 1 0 2zm1 10a1 1 0 1 0-2 0 1 1 0 0 0 2 0zm0 11a1 1 0 1 0-2 0 1 1 0 0 0 2 0z"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M39 17H9V9h30v8zm0 3H9v8h30v-8zm0 11H9v8h30v-8z"
  }), props.children);
});
var HardIceCream =
/*#__PURE__*/
React.forwardRef(function HardIceCream(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M29 24l-5 15-5-15m.249-5.785c-1.9 0-2.851 1.446-2.851 2.893 0 1.928 1.425 2.893 3.326 2.893h9.027a2.868 2.868 0 0 0 2.851-2.893c0-1.446-.95-2.893-2.851-2.893H24.95m4.941.153a6.535 6.535 0 1 0-11.768.029"
  }), props.children);
});
var Hazy =
/*#__PURE__*/
React.forwardRef(function Hazy(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M9 27h30m-28 4h5m15.985-8h5M20 31h10m-19-8h8M9 19h7m4 16h5m-1-11a5 5 0 1 0-5-5"
  }), props.children);
});
var Headphones =
/*#__PURE__*/
React.forwardRef(function Headphones(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M9 33v-9c0-8.284 6.716-15 15-15s15 6.716 15 15v9m-24 4v-8a2 2 0 0 0-2-2h0a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h0a2 2 0 0 0 2-2zm22 0v-8a2 2 0 0 0-2-2h0a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h0a2 2 0 0 0 2-2z"
  }), props.children);
});
var HeartHealth =
/*#__PURE__*/
React.forwardRef(function HeartHealth(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M9 40c0-6.871 5.229-12.624 11.636-14.143A8.285 8.285 0 0 1 24 10a8.284 8.284 0 1 1 3.364 15.857C33.77 27.376 39 33.129 39 40m-15.001-.999l3.962-3.962a2.357 2.357 0 0 0 .692-1.629 2.358 2.358 0 0 0-.692-1.714 2.356 2.356 0 0 0-1.672-.692 2.36 2.36 0 0 0-1.672.692l-.619.619-.619-.619a2.353 2.353 0 0 0-1.676-.692 2.356 2.356 0 0 0-1.667.692 2.356 2.356 0 0 0-.692 1.682c.003.602.233 1.202.692 1.661l3.963 3.962z"
  }), props.children);
});
var Heart =
/*#__PURE__*/
React.forwardRef(function Heart(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M11.263 24.118a7.581 7.581 0 0 1-2.231-5.374c0-1.954.741-3.909 2.231-5.4a7.59 7.59 0 0 1 5.384-2.231 7.594 7.594 0 0 1 5.39 2.231l1.995 1.995 1.995-1.995a7.595 7.595 0 0 1 5.395-2.231 7.6 7.6 0 0 1 5.38 2.231 7.593 7.593 0 0 1 2.231 5.387c0 1.95-.744 3.899-2.231 5.387l-12.77 12.769-12.769-12.769z"
  }), props.children);
});
var HeatMap =
/*#__PURE__*/
React.forwardRef(function HeatMap(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M38 38h-4v-4h4v4zM12 26h-2v2h2v-2zm26-13h-2v2h2v-2zm-4 9h-2v2h2v-2zM29 9h-2v2h2V9zm-5 18h-2v2h2v-2zM14 16h-2v2h2v-2zm8 4h-2v2h2v-2zm-2-9h-4v4h4v-4zm12 18h-4v4h4v-4zm-5-5h-3v3h3v-3zm-4 12h-3v3h3v-3zm16-10h-3v3h3v-3zm-27-8H9v3h3v-3zm24-3h-3v3h3v-3zm-21 6h-3v3h3v-3zm13-7h-6v6h6v-6zM18 28h-6v6h6v-6z"
  }), props.children);
});
var HighFive =
/*#__PURE__*/
React.forwardRef(function HighFive(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M9.5 34v-8.619a6.002 6.002 0 0 1 4.612-5.837A3.419 3.419 0 0 1 15.5 13a3.42 3.42 0 0 1 1.388 6.544c3.701-1.268 4.944-2.725 6.206-4.061 1.262-1.336 2.008-.849 2.405-.483.442.406 1 1.263-.313 2.625a893.165 893.165 0 0 1-4.687 4.784V34m8.001 0V22.409s-2.39-2.423-3.93-4.003M39.5 34v-8.619a6.002 6.002 0 0 0-4.612-5.837A3.419 3.419 0 0 0 33.5 13a3.42 3.42 0 0 0-1.388 6.544c-3.701-1.268-5.119-2.956-6.381-4.291"
  }), props.children);
});
var HomeFront =
/*#__PURE__*/
React.forwardRef(function HomeFront(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M9 24L24 9h0l15 15M27 39V27h-6v12M11 27v12m26-12v12M9 39h30m-2-17v-5m-16 7.003L27 24"
  }), props.children);
});
var HomeGarage =
/*#__PURE__*/
React.forwardRef(function HomeGarage(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M9 24L24 9h0l15 15m-2-2v-5m-5 22V27H16v12m-5-12v12m26-12v12M9 39h30M16 24.003L32 24m-16 7.003L31.999 31M16 35.003L31.999 35"
  }), props.children);
});
var HomeProfile =
/*#__PURE__*/
React.forwardRef(function HomeProfile(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M21 39v-8h6v8M11 26v13m26-13v13M9 39h30M11.412 14L9 23h30l-2.412-9H11.412zM18 29v-3m16 3v-3m-20 3v-3m0-12V9m16 20v-3"
  }), props.children);
});
var Hospital =
/*#__PURE__*/
React.forwardRef(function Hospital(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M33 12.5h4m-2-2v4M24 32h-5.5v7H24v-7zM39 9h-8v7H9v23h30V9zM13 21v-2m5.5 2v-2m5.5 2v-2m5.5 2v-2m5.5 2v-2m-22 6v-2m5.5 2v-2m5.5 2v-2m5.5 2v-2m5.5 2v-2m-22 6v-2m5.5 2v-2m5.5 2v-2m5.5 2v-2m5.5 2v-2m-22 6v-2m16.5 2v-2m5.5 2v-2"
  }), props.children);
});
var Humid =
/*#__PURE__*/
React.forwardRef(function Humid(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M8.9 16c.739 0 1.351-.54 1.875-1 .524-.46 1.136-1 1.875-1s1.351.54 1.875 1c.524.46 1.136 1 1.875 1 .739 0 1.351-.54 1.875-1 .524-.46 1.136-1 1.875-1 .739 0 1.351.54 1.875 1 .524.46 1.136 1 1.875 1 .739 0 1.351-.54 1.875-1 .524-.46 1.136-1 1.875-1 .739 0 1.351.54 1.875 1 .524.46 1.136 1 1.875 1s1.351-.54 1.875-1 1.136-1 1.875-1c.739 0 1.326.54 1.85 1s1.164 1 1.903 1m0 6c-.739 0-1.379-.54-1.903-1s-1.111-1-1.85-1c-.739 0-1.351.54-1.875 1s-1.136 1-1.875 1-1.351-.54-1.875-1c-.524-.46-1.136-1-1.875-1-.739 0-1.351.54-1.875 1-.524.46-1.136 1-1.875 1-.739 0-1.351-.54-1.875-1-.524-.46-1.136-1-1.875-1-.739 0-1.351.54-1.875 1-.524.46-1.136 1-1.875 1-.739 0-1.351-.54-1.875-1-.524-.46-1.136-1-1.875-1s-1.351.54-1.875 1c-.524.46-1.136 1-1.875 1m30.003 6c-.739 0-1.379-.54-1.903-1s-1.111-1-1.85-1c-.739 0-1.351.54-1.875 1s-1.136 1-1.875 1-1.351-.54-1.875-1c-.524-.46-1.136-1-1.875-1-.739 0-1.351.54-1.875 1-.524.46-1.136 1-1.875 1-.739 0-1.351-.54-1.875-1-.524-.46-1.136-1-1.875-1-.739 0-1.351.54-1.875 1-.524.46-1.136 1-1.875 1-.739 0-1.351-.54-1.875-1-.524-.46-1.136-1-1.875-1s-1.351.54-1.875 1c-.524.46-1.136 1-1.875 1m30.003 6c-.739 0-1.379-.54-1.903-1s-1.111-1-1.85-1c-.739 0-1.351.54-1.875 1s-1.136 1-1.875 1-1.351-.54-1.875-1c-.524-.46-1.136-1-1.875-1-.739 0-1.351.54-1.875 1-.524.46-1.136 1-1.875 1-.739 0-1.351-.54-1.875-1-.524-.46-1.136-1-1.875-1-.739 0-1.351.54-1.875 1-.524.46-1.136 1-1.875 1-.739 0-1.351-.54-1.875-1-.524-.46-1.136-1-1.875-1s-1.351.54-1.875 1c-.524.46-1.136 1-1.875 1"
  }), props.children);
});
var Hurricane =
/*#__PURE__*/
React.forwardRef(function Hurricane(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M33 24c0 4.971-4.029 9-9 9s-9-4.029-9-9 4.029-9 9-9 9 4.029 9 9zm-9-4a4 4 0 1 0 0 8 4 4 0 0 0 0-8zM34 9c-12.895 0-19 6-19 15m-1 15c12.895 0 19-6 19-15"
  }), props.children);
});
var HybridCloudServices =
/*#__PURE__*/
React.forwardRef(function HybridCloudServices(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M34.001 27c3 0 4.999-1.604 4.999-4.153S36.932 18 34.383 18c0-5.098-4.13-9-9.228-9-3.458 0-6.573 2.287-8.154 5.102a6.95 6.95 0 0 0-1.18-.102C11.998 14 9 16.715 9 20.539S12.177 27 16.001 27M32 25H18v-5h14v5zm-12-2.5h2M32 39H18v-5h14v5zm-12-2.5h2m7-2.5v-2.5a2 2 0 0 0-2-2h-4a2 2 0 0 1-2-2V25"
  }), props.children);
});
var HybridCloud =
/*#__PURE__*/
React.forwardRef(function HybridCloud(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M24.003 10.142l-9.467 5.466m9.467 22.247l9.462-5.463M12 15v13m-1.794 1.892l11.258 6.5M36 20v13m1.794-14.892l-11.258-6.5M24 39v-9l-5.196-3 10.392-6L24 18V9m0 0C15.716 9 9 15.716 9 24s6.716 15 15 15 15-6.716 15-15S32.284 9 24 9z"
  }), props.children);
});
var IbmIx =
/*#__PURE__*/
React.forwardRef(function IbmIx(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M24 24l-4.75 4.75L14.5 24l4.75-4.75L24 24zm-9.5-9.5l-4.75 4.75L14.5 24l4.75-4.75-4.75-4.75zm4.75 14.25L24 33.5l4.75-4.75 4.75 4.75 4.75-4.75L33.5 24l4.75-4.75-4.75-4.75-4.75 4.75L24 14.5l-4.75 4.75L24 24l-4.75 4.75zM14.5 24l-4.75 4.75 4.75 4.75 4.75-4.75L14.5 24z"
  }), props.children);
});
var IbmZ =
/*#__PURE__*/
React.forwardRef(function IbmZ(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M16.5 39l15-30m-15 0l17.143 8.571M31.5 39l-17.143-8.571M28.5 15L12 33v6h24v-6H19.5m0 0L36 15V9H12v6h16.5"
  }), props.children);
});
var Idea =
/*#__PURE__*/
React.forwardRef(function Idea(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M24 9c5.081 0 9 4.148 9 9.264 0 2.543-1.075 4.982-2.858 6.837C28.031 27.297 28 29.818 28 31.547V33h-8v-1.453c0-1.729-.031-4.25-2.142-6.446C16.075 23.246 15 20.807 15 18.264 15 13.148 18.919 9 24 9m-4 26h8m-8 2h8m-7 2h6"
  }), props.children);
});
var Ideate =
/*#__PURE__*/
React.forwardRef(function Ideate(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M36.652 27C35.298 32.733 30.147 37 24 37c-7.18 0-13-5.82-13-13m-2 2l2-2 2 2m-1.649-5c1.354-5.733 6.505-10 12.652-10C31.183 11 37 16.82 37 24m2-2l-2 2-2-2"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M24 15c2.973 0 5.5 2.45 5.5 5.4 0 1.467-.863 2.873-1.906 3.942-1.235 1.266-1.529 2.392-1.529 3.389V28h-4.13v-.268c0-.997-.294-2.123-1.529-3.389-1.044-1.07-1.906-2.476-1.906-3.942C18.5 17.449 21.027 15 24 15m-2 15h4m-3 2h2"
  }), props.children);
});
var Innovate =
/*#__PURE__*/
React.forwardRef(function Innovate(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M24 9c5.081 0 9 4.148 9 9.264 0 2.543-1.075 4.982-2.858 6.837C28.031 27.297 28 29.818 28 31.547V33h-8v-1.453c0-1.729-.031-4.25-2.142-6.446C16.075 23.246 15 20.807 15 18.264 15 13.148 18.919 9 24 9m-4 26h8m-8 2h8m-7 2h6"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M26.5 18.5a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0zm3.5 1.183v-2.366h-1.553l-.463-1.128 1.095-1.095-1.673-1.673-1.098 1.098-1.125-.47V12.5h-2.366v1.553l-1.128.463-1.095-1.095-1.673 1.673 1.098 1.099-.471 1.125H18v2.366h1.553l.463 1.128-1.095 1.095 1.673 1.673 1.098-1.098 1.125.47V24.5h2.366v-1.553l1.128-.463 1.095 1.095 1.673-1.673-1.099-1.098.471-1.125H30z"
  }), props.children);
});
var Integration =
/*#__PURE__*/
React.forwardRef(function Integration(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M39 23.99L31.5 37h-15L9 23.99 16.5 11h15L39 23.99zm-30 0h30M16.5 37l15-26m0 26l-15-26"
  }), props.children);
});
var Intelligence =
/*#__PURE__*/
React.forwardRef(function Intelligence(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M37 24.5a3.499 3.499 0 0 0-2.099-3.204c.06-.257.099-.521.099-.796a3.499 3.499 0 0 0-2.099-3.204c.06-.257.099-.521.099-.796 0-1.4-.828-2.94-2.016-3.5-.124-1.66-1.605-3-3.484-3a3.5 3.5 0 0 0-3.5 3.5v22a3.5 3.5 0 0 0 3.5 3.5 3.49 3.49 0 0 0 3.454-3.046A3.49 3.49 0 0 0 34 32.5c0-.22-.026-.434-.065-.643A3.489 3.489 0 0 0 36.5 28.5a3.46 3.46 0 0 0-.428-1.643A3.477 3.477 0 0 0 37 24.5z"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M11 24.5c0-1.434.865-2.663 2.099-3.204A3.484 3.484 0 0 1 13 20.5c0-1.434.865-2.663 2.099-3.204A3.484 3.484 0 0 1 15 16.5c0-1.4.828-2.599 2.016-3.159A3.491 3.491 0 0 1 20.5 10a3.5 3.5 0 0 1 3.5 3.5v22a3.5 3.5 0 0 1-3.5 3.5 3.49 3.49 0 0 1-3.454-3.046A3.49 3.49 0 0 1 14 32.5c0-.22.026-.434.065-.643A3.489 3.489 0 0 1 11.5 28.5c0-.597.164-1.151.428-1.643A3.477 3.477 0 0 1 11 24.5z"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M28 13h2.984M24 14c0 2.026 1 3 3 3m-3 3c0-2.026-1-3-3-3m11.901.296C31.802 18.217 31 19 31 20v3M19.099 34c1.099.921 1.901 1.704 1.901 2.704v2M31 20h-3m5 7h3.072M28 28c0 1.482.56 2 1.935 2l1.009-.011c1.609-.016 2.431.48 2.991 1.869M19 29c.5 1.5 1.5 2 2.5 2l2.484-.011m6.017 2.274c.596.561.999 1.344.999 2.691M27 33c-2 0-3 0-3 2m1 3l2-2m1-12c-2 0-1 .986-4 .986-2 0-1.5 1.514-4 1.014m-2-11.836l-.984-.823m-1.917 3.955L17 19.71c.725.88 1.175 1.29 2 1.29h2m-5 2l2-2m-3 6h-3.072M16 31l-1.935.857"
  }), props.children);
});
var Intercom =
/*#__PURE__*/
React.forwardRef(function Intercom(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    d: "M24.5 33.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0zM24 31a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1zm0 4a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1zm2-2a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1zm-4 0a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1z"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M34 26.5a1.5 1.5 0 1 1-3.001-.001A1.5 1.5 0 0 1 34 26.5zM37 9H11v30h26V9zm-3 3H14v10h20V12zM20 25h-6v3h6v-3z"
  }), props.children);
});
var IotMunich =
/*#__PURE__*/
React.forwardRef(function IotMunich(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M9 39h30m-19-7h8m-8 3h8m-8-13h8m-8-8.999L14 9v30h6V13.001zM34 21l-6-4v22h6V21zm-20-3h4m0-2h2m-4 4h2m-4 6h2m2 8h2m-6 2h4m10-10h2m0-2h4m-2 10h2m-4 2h2"
  }), props.children);
});
var Java =
/*#__PURE__*/
React.forwardRef(function Java(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("font", {
    horizAdvX: "1000"
  }), React.createElement("text", {
    fontFamily: "IBMPlexSans",
    fontSize: "14",
    transform: "translate(11.442 23.996)"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M39 39H9M39 9H9v23h30V9z"
  }), props.children);
});
var Javascript =
/*#__PURE__*/
React.forwardRef(function Javascript(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("font", {
    horizAdvX: "1000"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M39 39H9M38.999 9H9v23h30l-.001-23z"
  }), React.createElement("text", {
    fontFamily: "IBMPlexSans",
    fontSize: "14",
    transform: "translate(17 23.998)"
  }), props.children);
});
var Justice =
/*#__PURE__*/
React.forwardRef(function Justice(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M26 19a2 2 0 1 1-3.999.001A2 2 0 0 1 26 19zm-2 17c-1.66 0-3 1.34-3 3h6c0-1.66-1.34-3-3-3zM13.5 15.649L9 23.524a4.5 4.5 0 0 0 9 0l-4.5-7.875zm-4.5 8h9M34.5 10L30 17.875a4.5 4.5 0 0 0 9 0L34.5 10zM30 18h9m-5 21H14m-.5-23.38l21-5.62M24 36V21m0-8v4"
  }), props.children);
});
var KeyUsers =
/*#__PURE__*/
React.forwardRef(function KeyUsers(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M16 39v-7.492a8 8 0 0 1 6.149-7.782 4.56 4.56 0 1 1 3.702 0A8 8 0 0 1 32 31.508V39m6-6v-7.492a8 8 0 0 0-6.149-7.782A4.559 4.559 0 0 0 30 9a4.56 4.56 0 0 0-4.183 6.376m-3.633 0a4.561 4.561 0 1 0-8.744-1.816 4.56 4.56 0 0 0 2.709 4.166A8 8 0 0 0 10 25.508V33m12.883-1.565h-3.617l2.926 2.126L21.074 37 24 34.874 26.926 37l-1.118-3.44 2.926-2.126h-3.617L24 27.995l-1.117 3.44z"
  }), props.children);
});
var KnowsDarkData =
/*#__PURE__*/
React.forwardRef(function KnowsDarkData(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M15 11.598l-1.5 2.598h-3L9 11.598 10.5 9h3l1.5 2.598zm5.498 10.399a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5zM11.5 34a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5zm16.998 0a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5zm-1.5-8.003a2 2 0 1 0-.001 3.999 2 2 0 0 0 .001-3.999zm-3.308-13l-6.692 1.793 4.899 4.899 1.793-6.692zm10.291 24.658L39 39l-1.345-5.019-3.674 3.674zm-2.983-6.658l3 3m-9.66-12.341l5.657-5.657m5.199 0l-5.196 3 3 5.196 5.196-3-3-5.196zM19.802 30.804l-3 5.196 5.196 3 3-5.196-5.196-3zm-7.807-5.806v-7m-2.828 4.171l2.828 2.828 2.828-2.828m2.175 6.826l-3 3"
  }), props.children);
});
var Language_01 =
/*#__PURE__*/
React.forwardRef(function Language_01(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "bevel",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M10.533 24h4"
  }), React.createElement("defs", null), React.createElement("clipPath", {
    id: "b"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "bevel",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M9.033 27l3.5-7.5 3.5 7.5",
    clipPath: "url(#b)"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "bevel",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M34.533 12.5H31.5c-1 0-2-.155-2-1.5 0-1 .622-2 1.622-2S33 9.5 33 12c0 2.698-1.467 3-2.967 3h0c-1.5 0-3-.5-3-2.5V11"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M34 39c0-4.625-3.145-8.505-7.409-9.648a5.5 5.5 0 1 0-5.182.001C17.156 30.426 14 34.375 14 39m1.004-29h6m-3-1.5V10m-3 5c4.709 0 4.498-4 4.498-5m-2.963 2c.348 1.219 1.826 3 4.466 3m11.028 5h7.5"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "square",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M37.033 20v6"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M37.033 22.5h-2c-1.139 0-2 .5-2 1.5 0 .94.731 1.683 1.5 2"
  }), props.children);
});
var Language_02 =
/*#__PURE__*/
React.forwardRef(function Language_02(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "bevel",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M33.5 12.5h-3.033c-1 0-2-.155-2-1.5 0-1 .622-2 1.622-2s1.878.5 1.878 3c0 2.698-1.467 3-2.967 3h0c-1.5 0-3-.5-3-2.5V11"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M34 39c0-4.625-3.145-8.505-7.409-9.648a5.5 5.5 0 1 0-5.182.001C17.156 30.426 14 34.375 14 39m1.004-29h6m-3-1.5V10m-3 5c4.709 0 4.498-4 4.498-5m-2.963 2c.348 1.219 1.826 3 4.466 3"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "square",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M36 20v3h-2.5"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "square",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M33 20v3.25c0 1.795 1.343 2.75 3 2.75s3-.955 3-2.75V20"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M14.494 20H9.5l2.335 2.998L9.5 26h4.994"
  }), props.children);
});
var Language_03 =
/*#__PURE__*/
React.forwardRef(function Language_03(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "square",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M36 20v3h-2.5"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "square",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M33 20v3.25c0 1.795 1.343 2.75 3 2.75s3-.955 3-2.75V20"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "bevel",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M34.5 12.5h-3.033c-1 0-2-.155-2-1.5 0-1 .622-2 1.622-2s1.878.5 1.878 3c0 2.698-1.467 3-2.967 3h0c-1.5 0-3-.5-3-2.5V11"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M34 39c0-4.625-3.145-8.505-7.409-9.648a5.5 5.5 0 1 0-5.182.001C17.156 30.425 14 34.375 14 39"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "square",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M9 21h6"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M12 19.5V21m-3 5c4.709 0 4.498-4 4.498-5m-2.964 2c.348 1.219 1.826 3 4.466 3m0-17h7.5"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "square",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M20 9v6"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M20 11.5h-2c-1.139 0-2 .5-2 1.5 0 .94.731 1.683 1.5 2"
  }), props.children);
});
var Language_04 =
/*#__PURE__*/
React.forwardRef(function Language_04(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "bevel",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M34.5 12.5h-3.033c-1 0-2-.155-2-1.5 0-1 .622-2 1.622-2s1.878.5 1.878 3c0 2.698-1.467 3-2.967 3h0c-1.5 0-3-.5-3-2.5V11"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M34 39c0-4.625-3.145-8.505-7.409-9.648a5.5 5.5 0 1 0-5.182.001C17.156 30.426 14 34.375 14 39m1-29h6m-3-1.5V10m-3 5c4.709 0 4.498-4 4.498-5m-2.964 2c.348 1.219 1.826 3 4.466 3"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "bevel",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M9 27l3.5-7.5L16 27m-5.5-3h4"
  }), React.createElement("path", {
    d: "M8.5 26H17v2H8.5z"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "square",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M37.86 26v-6H34.5v2c0 2-.5 4-1.5 4"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M33 27.5V26h5.5v1.5"
  }), props.children);
});
var LanguageTranslationAlphabetAExpanded =
/*#__PURE__*/
React.forwardRef(function LanguageTranslationAlphabetAExpanded(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    d: "M34.986 18l.774-.001-2.437-6.133h-.669L30.216 18h.775l.653-1.641h2.691L34.986 18zm-3.057-2.361l1.06-2.666 1.059 2.666h-2.119z"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M9 27h12v12H9z"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M39 15a6 6 0 1 1-12 0 6 6 0 0 1 12 0zm-14.5 0H17c-1.105 0-2 .897-2 2.002V25m6.67-12.827l2.828 2.828-2.828 2.829M33 23.002v8A1.998 1.998 0 0 1 31 33h-7.502m2.829 2.83l-2.828-2.828 2.828-2.828M12 31h6m-3-1.5V31m1.349.002s.358 5-4.351 5m6 0c-2.639 0-4.262-2.014-4.582-3.501"
  }), props.children);
});
var LanguageTranslation =
/*#__PURE__*/
React.forwardRef(function LanguageTranslation(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M9 27h12v12H9z"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "bevel",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M30.613 18l2.385-6 2.385 6m-4.031-2h3.271"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M39 15a6 6 0 1 1-12 0 6 6 0 0 1 12 0zm-14.5 0H17c-1.105 0-2 .897-2 2.002V25m6.67-12.827l2.828 2.828-2.828 2.829M33 23.002v8A1.998 1.998 0 0 1 31 33h-7.502m2.829 2.83l-2.828-2.828 2.828-2.828M12 31h6m-3-1.5V31m1.349.002s.358 5-4.351 5m6 0c-2.639 0-4.262-2.014-4.582-3.501"
  }), props.children);
});
var Language =
/*#__PURE__*/
React.forwardRef(function Language(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M32.536 23.028a1.75 1.75 0 0 1-.519-1.235c0-.452.168-.922.519-1.273.34-.34.782-.513 1.227-.519.463-.007.928.166 1.281.519l.465.464.465-.464a1.772 1.772 0 0 1 3.027 1.269c0 .449-.177.897-.519 1.239L35.508 26l-2.972-2.972zM13.994 21.5V20H9l2.335 2.998L9 26h4.994v-1.5M27.504 12h5m.5-2.008c-.5-.5-1.271-.993-2-.993-1.198 0-2.168.744-2.168 2.069 0 1.004.883.933.883 1.931 0 .899-.694 1.418-1.715 2h5M34 39c0-4.625-3.145-8.505-7.409-9.648a5.5 5.5 0 1 0-5.182.001C17.156 30.425 14 34.375 14 39m1.004-29h6m-3-1.5V10m-3 5c4.709 0 4.498-4 4.498-5m-2.963 2c.348 1.219 1.826 3 4.466 3"
  }), props.children);
});
var Launch =
/*#__PURE__*/
React.forwardRef(function Launch(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M30 9h9v9m-15-7H11a2 2 0 0 0-2 2v24a2 2 0 0 0 2 2h24a2 2 0 0 0 2-2V24m2-15L22 26"
  }), props.children);
});
var Lightning =
/*#__PURE__*/
React.forwardRef(function Lightning(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M20 37l4-7h-4l4-7m3 4h6.426C36.504 26.967 39 24.652 39 21.574S36.504 16 33.426 16c-.627 0-1.458.108-2.02.299C30.24 13.304 27.335 11 23.927 11c-4.177 0-7.606 3.537-7.992 7.613A4.639 4.639 0 0 0 13.631 18C11.058 18 9 20.086 9 22.658c0 2.573 2.058 4.309 4.631 4.342h3.357"
  }), props.children);
});
var ListBullet =
/*#__PURE__*/
React.forwardRef(function ListBullet(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0zm-3 21a3 3 0 1 0 0 6 3 3 0 0 0 0-6zm0-12a3 3 0 1 0 0 6 3 3 0 0 0 0-6zm7-9h20M19 24h20M19 36h20"
  }), props.children);
});
var ListCheckbox =
/*#__PURE__*/
React.forwardRef(function ListCheckbox(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M19 12h20M19 24h20M19 36h20M15 9H9v6h6V9zm0 12H9v6h6v-6zm0 12H9v6h6v-6z"
  }), props.children);
});
var Location =
/*#__PURE__*/
React.forwardRef(function Location(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M35 20c0 8-11 19-11 19S13 29 13 20c0-6 4.925-11 11-11s11 5 11 11zm-11-4a4 4 0 1 0 0 8 4 4 0 0 0 0-8z"
  }), props.children);
});
var LockAlt =
/*#__PURE__*/
React.forwardRef(function LockAlt(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("circle", {
    cx: "24",
    cy: "29.5",
    r: "1.5"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M29 21v-7a5 5 0 0 0-10 0v7m5 8.5V33"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".711",
    d: "M14 21h20v18H14z"
  }), props.children);
});
var Lock =
/*#__PURE__*/
React.forwardRef(function Lock(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("circle", {
    cx: "24",
    cy: "28.5",
    r: "1.5"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M34 29c0 5.523-4.477 10-10 10s-10-4.477-10-10 4.477-10 10-10 10 4.477 10 10zm-5-8.662V14a5 5 0 0 0-10 0v6.338m5 8.162V32"
  }), props.children);
});
var LockedNetworkAlt =
/*#__PURE__*/
React.forwardRef(function LockedNetworkAlt(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M37 35v-4H11v4m26 0a2 2 0 1 0-.001 3.999A2 2 0 0 0 37 35zm-13-8v8"
  }), React.createElement("circle", {
    cx: "24",
    cy: "37",
    r: "2",
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72"
  }), React.createElement("circle", {
    cx: "11",
    cy: "37",
    r: "2",
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M24 19v2"
  }), React.createElement("circle", {
    cx: "24",
    cy: "19",
    r: "1"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M26.5 15v-3.5a2.5 2.5 0 1 0-5 0V15M19 15h10v10H19z"
  }), props.children);
});
var LockedNetwork =
/*#__PURE__*/
React.forwardRef(function LockedNetwork(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M29 20a5 5 0 1 1-10.001-.001A5 5 0 0 1 29 20zm-2-8a3 3 0 1 0-6 0m0 0v4m6-4v4m10 19v-4H11v4m26 0a2 2 0 1 0-.001 3.999A2 2 0 0 0 37 35zm-13-8v8"
  }), React.createElement("circle", {
    cx: "24",
    cy: "37",
    r: "2",
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72"
  }), React.createElement("circle", {
    cx: "11",
    cy: "37",
    r: "2",
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M24 19v2"
  }), React.createElement("circle", {
    cx: "24",
    cy: "19",
    r: "1"
  }), props.children);
});
var LondonBigBen =
/*#__PURE__*/
React.forwardRef(function LondonBigBen(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M20.5 23v-3l2-2v-3l1.5-4 1.5 4v3l2 2v3M24 9v2m-1.5 4h3m-3 3h3m-5 2h7m.5 3h-8v8h8v-8zm-.5 8v8m-7-8v8m3.5-7v3m-2-3v3m4-3v3m-2 1v3m-2-3v3m4-3v3m-5.5-4h7M24 23v-2m0-3v-2m2 7v-2m-4 2v-2m-5.685-8.547c-.19 0-.371.033-.541.091a2.421 2.421 0 0 0-2.261-1.542 2.422 2.422 0 0 0-2.416 2.19 1.405 1.405 0 0 0-.696-.185c-.778 0-1.4.808-1.4 1.586A1.399 1.399 0 0 0 10.4 16h5.915c.931 0 1.685-.754 1.685-1.685s-.754-1.862-1.685-1.862zm21.374 4.801a1.3 1.3 0 0 0-.421.07 1.883 1.883 0 0 0-1.759-1.199c-.982 0-1.788.745-1.879 1.703a1.09 1.09 0 0 0-.542-.144c-.605 0-1.089.615-1.089 1.22A1.091 1.091 0 0 0 33.089 20h4.601A1.31 1.31 0 0 0 39 18.689c0-.723-.587-1.435-1.311-1.435zM24 24.25a2.25 2.25 0 1 0 0 4.5 2.25 2.25 0 0 0 0-4.5zm.002.75L24 26.5h1.5"
  }), props.children);
});
var LondonExpandedBase =
/*#__PURE__*/
React.forwardRef(function LondonExpandedBase(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("circle", {
    cx: "24",
    cy: "24",
    r: "11",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72"
  }), React.createElement("circle", {
    cx: "24",
    cy: "24",
    r: "13",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72"
  }), React.createElement("circle", {
    cx: "24",
    cy: "9",
    r: ".5"
  }), React.createElement("circle", {
    cx: "24",
    cy: "39",
    r: ".5"
  }), React.createElement("circle", {
    cx: "20.118",
    cy: "9.511",
    r: ".5"
  }), React.createElement("circle", {
    cx: "16.5",
    cy: "11.01",
    r: ".5"
  }), React.createElement("circle", {
    cx: "31.5",
    cy: "36.99",
    r: ".5"
  }), React.createElement("circle", {
    cx: "13.393",
    cy: "13.393",
    r: ".5"
  }), React.createElement("circle", {
    cx: "34.607",
    cy: "34.607",
    r: ".5"
  }), React.createElement("circle", {
    cx: "11.01",
    cy: "16.5",
    r: ".5"
  }), React.createElement("circle", {
    cx: "36.99",
    cy: "31.5",
    r: ".5"
  }), React.createElement("circle", {
    cx: "9.511",
    cy: "20.118",
    r: ".5"
  }), React.createElement("circle", {
    cx: "38.489",
    cy: "27.882",
    r: ".5"
  }), React.createElement("circle", {
    cx: "9",
    cy: "24",
    r: ".5"
  }), React.createElement("circle", {
    cx: "39",
    cy: "24",
    r: ".5"
  }), React.createElement("circle", {
    cx: "9.511",
    cy: "27.882",
    r: ".5"
  }), React.createElement("circle", {
    cx: "38.489",
    cy: "20.118",
    r: ".5"
  }), React.createElement("circle", {
    cx: "11.01",
    cy: "31.5",
    r: ".5"
  }), React.createElement("circle", {
    cx: "36.99",
    cy: "16.5",
    r: ".5"
  }), React.createElement("circle", {
    cx: "13.393",
    cy: "34.607",
    r: ".5"
  }), React.createElement("circle", {
    cx: "34.607",
    cy: "13.393",
    r: ".5"
  }), React.createElement("circle", {
    cx: "16.5",
    cy: "36.99",
    r: ".5"
  }), React.createElement("circle", {
    cx: "31.5",
    cy: "11.01",
    r: ".5"
  }), React.createElement("circle", {
    cx: "27.882",
    cy: "9.511",
    r: ".5"
  }), React.createElement("path", {
    d: "M28.348 38.907l-4-15c-.084-.314-.611-.314-.695 0l-4 15c-.008.031-.006.062-.006.093h.726L24 25.397 27.628 39h.726c-.001-.031.002-.062-.006-.093z"
  }), props.children);
});
var London =
/*#__PURE__*/
React.forwardRef(function London(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("circle", {
    cx: "24",
    cy: "24",
    r: "11",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72"
  }), React.createElement("circle", {
    cx: "24",
    cy: "24",
    r: "13",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72"
  }), React.createElement("circle", {
    cx: "24",
    cy: "9",
    r: ".5"
  }), React.createElement("circle", {
    cx: "24",
    cy: "39",
    r: ".5"
  }), React.createElement("circle", {
    cx: "20.118",
    cy: "9.511",
    r: ".5"
  }), React.createElement("circle", {
    cx: "16.5",
    cy: "11.01",
    r: ".5"
  }), React.createElement("circle", {
    cx: "31.5",
    cy: "36.99",
    r: ".5"
  }), React.createElement("circle", {
    cx: "13.393",
    cy: "13.393",
    r: ".5"
  }), React.createElement("circle", {
    cx: "34.607",
    cy: "34.607",
    r: ".5"
  }), React.createElement("circle", {
    cx: "11.01",
    cy: "16.5",
    r: ".5"
  }), React.createElement("circle", {
    cx: "36.99",
    cy: "31.5",
    r: ".5"
  }), React.createElement("circle", {
    cx: "9.511",
    cy: "20.118",
    r: ".5"
  }), React.createElement("circle", {
    cx: "38.489",
    cy: "27.882",
    r: ".5"
  }), React.createElement("circle", {
    cx: "9",
    cy: "24",
    r: ".5"
  }), React.createElement("circle", {
    cx: "39",
    cy: "24",
    r: ".5"
  }), React.createElement("circle", {
    cx: "9.511",
    cy: "27.882",
    r: ".5"
  }), React.createElement("circle", {
    cx: "38.489",
    cy: "20.118",
    r: ".5"
  }), React.createElement("circle", {
    cx: "11.01",
    cy: "31.5",
    r: ".5"
  }), React.createElement("circle", {
    cx: "36.99",
    cy: "16.5",
    r: ".5"
  }), React.createElement("circle", {
    cx: "13.393",
    cy: "34.607",
    r: ".5"
  }), React.createElement("circle", {
    cx: "34.607",
    cy: "13.393",
    r: ".5"
  }), React.createElement("circle", {
    cx: "16.5",
    cy: "36.99",
    r: ".5"
  }), React.createElement("circle", {
    cx: "31.5",
    cy: "11.01",
    r: ".5"
  }), React.createElement("circle", {
    cx: "27.882",
    cy: "9.511",
    r: ".5"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M20 39l4-15 4 15"
  }), props.children);
});
var Lungs =
/*#__PURE__*/
React.forwardRef(function Lungs(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M22 9v5.504c0 1.424-.612 2.866-2 2.866M26 9v5.504c0 1.424.615 2.866 2.003 2.866"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M23.999 19.252c-1.461 0-2.938.511-3.997 1.023m8.001-.001c-1.059-.511-2.542-1.023-4.003-1.023m-5.626-5.624C14.845 13.627 9 20.823 9 27.653v8.535C9 38.306 9.84 39 11.812 39h7.499C21.357 39 22 38.306 22 36.188v-8.499c0-1.899-1.999-4.054-1.999-5.624v-6.562c0-1.352-.202-1.876-1.627-1.876zm9.625 1.875v6.562c0 1.571-1.999 3.725-1.999 5.624v8.499c0 2.119.643 2.813 2.688 2.813h7.499C38.16 39 39 38.306 39 36.188v-8.535c0-6.83-5.845-14.026-9.374-14.026-1.425 0-1.627.524-1.627 1.875zM11.003 30.501c1.544 0 3.623-1.905 3.623-4.497v-1.769c0-3.47 1.243-7.037 3.75-8.732m-3.751 8.731v5.291c0 4.638.409 7.474 3.751 7.474m1.627-6.498v-1.875c0-3.427-5.375-1.105-5.375-4.762m14.996-8.362c2.506 1.695 3.75 5.262 3.75 8.732v1.769c0 2.592 2.084 4.497 3.628 4.497m-7.378 6.499c3.341 0 3.751-2.836 3.751-7.474v-5.291m-.002-.37c0 3.657-5.37 1.336-5.37 4.762v1.875"
  }), props.children);
});
var MachineLearning_01 =
/*#__PURE__*/
React.forwardRef(function MachineLearning_01(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#231F20",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M9.001 23.31c-.038 2.182 1.487 4.318 3.695 4.925-.549.53-1.106 1.494-1.125 2.587-.042 2.386 1.866 3.907 4.252 3.949l.724.013a3.24 3.24 0 0 0 6.313-.97l.358-20.517a3.24 3.24 0 0 0-6.276-1.19l-.724-.012c-2.386-.042-4.345 1.412-4.387 3.798-.019 1.092.504 2.075 1.034 2.624-2.227.529-3.826 2.611-3.864 4.793z"
  }), React.createElement("circle", {
    cx: "19.959",
    cy: "14.32",
    r: "1.08",
    fill: "none",
    stroke: "#231F20",
    strokeMiterlimit: "10",
    strokeWidth: ".72"
  }), React.createElement("circle", {
    cx: "16.644",
    cy: "18.583",
    r: "1.08",
    fill: "none",
    stroke: "#231F20",
    strokeMiterlimit: "10",
    strokeWidth: ".72"
  }), React.createElement("circle", {
    cx: "19.752",
    cy: "26.198",
    r: "1.08",
    fill: "none",
    stroke: "#231F20",
    strokeMiterlimit: "10",
    strokeWidth: ".72"
  }), React.createElement("circle", {
    cx: "13.311",
    cy: "23.925",
    r: "1.08",
    fill: "none",
    stroke: "#231F20",
    strokeMiterlimit: "10",
    strokeWidth: ".72"
  }), React.createElement("circle", {
    cx: "16.418",
    cy: "31.541",
    r: "1.08",
    fill: "none",
    stroke: "#231F20",
    strokeMiterlimit: "10",
    strokeWidth: ".72"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#231F20",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M19.94 15.4l-.113 6.479m-.094 5.399l-.17 9.718"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#231F20",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M23.067 21.935l-5.399-.094a1.081 1.081 0 0 0-1.099 1.061l-.132 7.559"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#231F20",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M15.565 18.564l-3.051-.053m4.036 5.471l-2.16-.038"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#231F20",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M39.236 23.838c.038-2.182-1.487-4.318-3.695-4.925.549-.53 1.106-1.494 1.125-2.587.042-2.386-1.866-3.907-4.252-3.949l-.724-.013a3.24 3.24 0 0 0-6.313.97l-.358 20.517a3.24 3.24 0 0 0 6.276 1.19l.724.012c2.386.042 4.345-1.412 4.387-3.798.019-1.092-.504-2.075-1.034-2.624 2.227-.53 3.826-2.611 3.864-4.793z"
  }), React.createElement("circle", {
    cx: "28.278",
    cy: "32.828",
    r: "1.08",
    fill: "none",
    stroke: "#231F20",
    strokeMiterlimit: "10",
    strokeWidth: ".72"
  }), React.createElement("circle", {
    cx: "31.592",
    cy: "28.565",
    r: "1.08",
    fill: "none",
    stroke: "#231F20",
    strokeMiterlimit: "10",
    strokeWidth: ".72"
  }), React.createElement("circle", {
    cx: "28.485",
    cy: "20.95",
    r: "1.08",
    fill: "none",
    stroke: "#231F20",
    strokeMiterlimit: "10",
    strokeWidth: ".72"
  }), React.createElement("circle", {
    cx: "34.926",
    cy: "23.222",
    r: "1.08",
    fill: "none",
    stroke: "#231F20",
    strokeMiterlimit: "10",
    strokeWidth: ".72"
  }), React.createElement("circle", {
    cx: "31.819",
    cy: "15.607",
    r: "1.08",
    fill: "none",
    stroke: "#231F20",
    strokeMiterlimit: "10",
    strokeWidth: ".72"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#231F20",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M28.296 31.748l.113-6.479m.095-5.399l.169-9.719"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#231F20",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M25.17 25.212l5.399.094a1.081 1.081 0 0 0 1.099-1.061l.132-7.559"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#231F20",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M32.672 28.584l3.051.053m-4.036-5.471l2.159.038"
  }), props.children);
});
var MachineLearning_02 =
/*#__PURE__*/
React.forwardRef(function MachineLearning_02(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("circle", {
    cx: "19.192",
    cy: "16.5",
    r: "1.5",
    fill: "none",
    stroke: "#231F20",
    strokeMiterlimit: "10",
    strokeWidth: ".72"
  }), React.createElement("circle", {
    cx: "19.692",
    cy: "26.5",
    r: "1.5",
    fill: "none",
    stroke: "#231F20",
    strokeMiterlimit: "10",
    strokeWidth: ".72"
  }), React.createElement("circle", {
    cx: "26.192",
    cy: "13.5",
    r: "1.5",
    fill: "none",
    stroke: "#231F20",
    strokeMiterlimit: "10",
    strokeWidth: ".72"
  }), React.createElement("circle", {
    cx: "31.192",
    cy: "31.5",
    r: "1.5",
    fill: "none",
    stroke: "#231F20",
    strokeMiterlimit: "10",
    strokeWidth: ".72"
  }), React.createElement("circle", {
    cx: "31.692",
    cy: "21.5",
    r: "1.5",
    fill: "none",
    stroke: "#231F20",
    strokeMiterlimit: "10",
    strokeWidth: ".72"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#231F20",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M34.192 39l.002-10.756a11.46 11.46 0 0 0 2.998-7.744c0-6.351-5.149-11.5-11.5-11.5s-11.5 5.149-11.5 11.5l-3.276 6.053A1 1 0 0 0 11.81 28h2.382v3"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#231F20",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M14.192 31c0 3.314 3.686 6 7 6h0v2m3 0v-8.817l-3.341-2.734M24.192 27v-6l-3.897-3.488M26.192 39V15m2 16v-7l2.198-1.759M28.192 39v-5l1.825-1.569"
  }), props.children);
});
var MachineLearning_03 =
/*#__PURE__*/
React.forwardRef(function MachineLearning_03(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("circle", {
    cx: "25",
    cy: "31",
    r: "1",
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M31 30v6m-6-4v4m7.123-21.397L17.88 24.395m-5.686-6.514l7.504-.751m1.136-5.482L29 18l7.196 6.297M36 19.444l-7.171 3.187M30 28.714L17.875 25.25m18.253.331l-4.262 2.842M37 20.104v3.823m-3.319-9.076l2.618 3.273m-8.357-6.653l4.115 2.058M21.09 11h4.831m-9.98 2.03l3.116-1.559m-7.355 5.74l2.693-3.031M11 23.082v-4.177m4.925 5.916l-3.875-.646"
  }), React.createElement("circle", {
    cx: "27",
    cy: "11",
    r: "1",
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72"
  }), React.createElement("circle", {
    cx: "33",
    cy: "14",
    r: "1",
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72"
  }), React.createElement("circle", {
    cx: "37",
    cy: "19",
    r: "1",
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72"
  }), React.createElement("circle", {
    cx: "37",
    cy: "25",
    r: "1",
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72"
  }), React.createElement("circle", {
    cx: "31",
    cy: "29",
    r: "1",
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72"
  }), React.createElement("circle", {
    cx: "28",
    cy: "23",
    r: "1",
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72"
  }), React.createElement("circle", {
    cx: "21",
    cy: "17",
    r: "1",
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72"
  }), React.createElement("circle", {
    cx: "19",
    cy: "29",
    r: "1",
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72"
  }), React.createElement("circle", {
    cx: "25",
    cy: "37",
    r: "1",
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72"
  }), React.createElement("circle", {
    cx: "31",
    cy: "37",
    r: "1",
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72"
  }), React.createElement("circle", {
    cx: "17",
    cy: "25",
    r: "1",
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72"
  }), React.createElement("circle", {
    cx: "11",
    cy: "24",
    r: "1",
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72"
  }), React.createElement("circle", {
    cx: "11",
    cy: "18",
    r: "1",
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72"
  }), React.createElement("circle", {
    cx: "15",
    cy: "13.5",
    r: "1",
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72"
  }), React.createElement("circle", {
    cx: "20",
    cy: "11",
    r: "1",
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M29.111 23.247L36 24.778M25.375 30l2.292-6.113M21.286 18l3.428 12m-7.885-5.985l-1.636-9.408m3.324 13.428l-1.045-2.09m6.469 4.702l-4.026-1.342"
  }), props.children);
});
var MachineLearning_04 =
/*#__PURE__*/
React.forwardRef(function MachineLearning_04(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M35 23v11a4 4 0 0 1-4 4H17a4 4 0 0 1-4-4V23a4 4 0 0 1 4-4h14a4 4 0 0 1 4 4zm-5 3a2 2 0 1 0-3.999-.001A2 2 0 0 0 30 26zm-4-15a2 2 0 1 0-3.999-.001A2 2 0 0 0 26 11zm1 8a3 3 0 1 0-6 0m1 7a2 2 0 1 0-3.999-.001A2 2 0 0 0 22 26zm6 9a2 2 0 1 0 0-4h-8a2 2 0 1 0 0 4h8zm-4-22v3m15 7h-2v8.5h2V23zm-28 0H9v8.5h2V23z"
  }), props.children);
});
var MachineLearning_05 =
/*#__PURE__*/
React.forwardRef(function MachineLearning_05(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M15 15h18v18H15zm5 0v-3"
  }), React.createElement("circle", {
    cx: "20",
    cy: "10.5",
    r: "1.5",
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M28 15v-3"
  }), React.createElement("circle", {
    cx: "28",
    cy: "10.5",
    r: "1.5",
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72"
  }), React.createElement("circle", {
    cx: "24",
    cy: "24",
    r: "7",
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M28 33v3"
  }), React.createElement("circle", {
    cx: "28",
    cy: "37.5",
    r: "1.5",
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M20 33v3"
  }), React.createElement("circle", {
    cx: "20",
    cy: "37.5",
    r: "1.5",
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M33 20h3"
  }), React.createElement("circle", {
    cx: "37.5",
    cy: "20",
    r: "1.5",
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M33 28h3"
  }), React.createElement("circle", {
    cx: "37.5",
    cy: "28",
    r: "1.5",
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M15 28h-3"
  }), React.createElement("circle", {
    cx: "10.5",
    cy: "28",
    r: "1.5",
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M15 20h-3"
  }), React.createElement("circle", {
    cx: "10.5",
    cy: "20",
    r: "1.5",
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M28 29.5v-1c0-1.798-1.194-3.301-2.827-3.805A2.49 2.49 0 0 0 26.5 22.5a2.5 2.5 0 1 0-5 0 2.49 2.49 0 0 0 1.327 2.195C21.194 25.199 20 26.702 20 28.5V30"
  }), props.children);
});
var MachineLearning_06 =
/*#__PURE__*/
React.forwardRef(function MachineLearning_06(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M17 34a2.5 2.5 0 0 1-2.5-2.5M22 14a2 2 0 1 0-4 0m2 6.5a2 2 0 1 0 0-4m-2.586 5.084A1.958 1.958 0 0 0 16 21c-1.23 0-2 .842-2 2 0 .511.196 1.022.586 1.412M20 28a2 2 0 1 0 0 4m0 4a2 2 0 0 0 2-2m2-15h9a2 2 0 0 0 2-2v-2m0 18v-2a2 2 0 0 0-2-2h-9m0-7h12m0-8a1 1 0 1 0-2 0 1 1 0 0 0 2 0zm0 20a1 1 0 1 0-2 0 1 1 0 0 0 2 0zm2-12a1 1 0 1 0-2 0 1 1 0 0 0 2 0zm-14 4h12m2 0a1 1 0 1 0-2 0 1 1 0 0 0 2 0zM24 14a4 4 0 0 0-4-4c-1.479 0-2.756.812-3.448 2.005-.018 0-.034-.005-.052-.005a4.5 4.5 0 0 0-4.5 4.5c0 .999.336 1.913.887 2.66C11.168 20.09 10 21.908 10 24s1.168 3.91 2.887 4.84A4.462 4.462 0 0 0 12 31.5a4.5 4.5 0 0 0 4.5 4.5c.018 0 .034-.005.052-.005C17.244 37.188 18.521 38 20 38a4 4 0 0 0 4-4V14zm-7.5-1.938A3.977 3.977 0 0 0 16 14c0 .729.195 1.412.535 2M16.5 27a4.49 4.49 0 0 0-3.5 1.672"
  }), props.children);
});
var MadridCathedral =
/*#__PURE__*/
React.forwardRef(function MadridCathedral(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M39 39v-9H9v9"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M32 22v2m2-2v2"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M36 20v10m-6-8h7m0 2h-7m6 2h-4"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M30 20v10m-4-10v10m2-18v2m0 12v4m-5-4v4m3-6h4"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M28 14l-2 6h4z"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M20 20v10m-4-10v10m2-8v2m10-2v2M18 12v2m0 12v4m-2-6h4"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M18 14l-2 6h4z"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M26 24h-2v-1a1 1 0 0 0-2 0v1h-2"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M12 37v2m2-2v2m4-2v2m2-2v2m2-2v2m2-2v2m2-2v2m2-2v2m2-2v2m2-2v2m2-2v2m2-2v2m-20-2v2"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M13 33a1 1 0 0 0-2 0v2h2v-2zm4 0a1 1 0 0 0-2 0v2h2v-2zm4 0a1 1 0 0 0-2 0v2h2v-2zm4 0a1 1 0 0 0-2 0v2h2v-2zm4 0a1 1 0 0 0-2 0v2h2v-2zm4 0a1 1 0 0 0-2 0v2h2v-2zm4 0a1 1 0 0 0-2 0v2h2v-2z"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M10 27a2 2 0 1 1 4 0m-3-3a1 1 0 0 1 2 0m-3 3h4m-3-3v1m2-1v1m-1-4v2m-2 4v3m4-3v3m17-18a1 1 0 0 1 2 0m-2 0v4m2-4v4m-1-7v2m-1 2h2"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M29 17.354A4 4 0 0 1 36 20"
  }), React.createElement("circle", {
    cx: "34.5",
    cy: "28.5",
    r: ".5"
  }), React.createElement("circle", {
    cx: "32.5",
    cy: "28.5",
    r: ".5"
  }), props.children);
});
var MadridSkyscrapers =
/*#__PURE__*/
React.forwardRef(function MadridSkyscrapers(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M12 38V12m13.979 26L26 30l-.062-12.044L30 15l1 2v20.979M23 15v22.979M18 38V15m21 1c0 9-4.995 11-4.995 21.634M26 36.979L30 15m-7 3h-3v20"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "square",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M9 32h1M9 17h1m4 7h1"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M27 21.956h2M34 19h2m-2 2h2m1 12h2m-10 0h2"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "square",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M9 38h30V16h-5.005L34 37.979h0"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M21 26.999l2.063.001M21 30l2.063.001M10 37.979V34H9v-5h1v-2.021H9v-5h1v-2H9V15h1v-3h4v3h1v4.979h-1v2h1v5h-1V29h1v5h-1v3.979M23 15c0-.552-1.119-1-2.5-1s-2.5.448-2.5 1"
  }), props.children);
});
var MadridStatue =
/*#__PURE__*/
React.forwardRef(function MadridStatue(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M28 23v-1l2 1h1l1 1h.884v1.022l-1 .978L33 28l1.587 1.587c.269.269.456.61.539.982l.53 2.397a2 2 0 0 1-.497 1.803L34 36l1 3h-6v-3l1-3-1-2.5-1.884-1L24 27.962V25h0l2.116 1.5 2.884 1v-2l-1.116-1L28 23zM9 38.991h30"
  }), React.createElement("ellipse", {
    cx: "18.017",
    cy: "16.461",
    rx: ".5",
    ry: ".508"
  }), React.createElement("ellipse", {
    cx: "20.5",
    cy: "18.008",
    rx: ".5",
    ry: ".508"
  }), React.createElement("ellipse", {
    cx: "16.5",
    cy: "18.992",
    rx: ".5",
    ry: ".508"
  }), React.createElement("ellipse", {
    cx: "22.5",
    cy: "20.008",
    rx: ".5",
    ry: ".508"
  }), React.createElement("ellipse", {
    cx: "26.997",
    cy: "16.461",
    rx: ".5",
    ry: ".508"
  }), React.createElement("ellipse", {
    cx: "24.5",
    cy: "17.992",
    rx: ".5",
    ry: ".508"
  }), React.createElement("ellipse", {
    cx: "20.5",
    cy: "12.992",
    rx: ".5",
    ry: ".508"
  }), React.createElement("ellipse", {
    cx: "23.5",
    cy: "12.008",
    rx: ".5",
    ry: ".508"
  }), React.createElement("ellipse", {
    cx: "28.5",
    cy: "18.992",
    rx: ".5",
    ry: ".508"
  }), React.createElement("ellipse", {
    cx: "17.5",
    cy: "13.008",
    rx: ".5",
    ry: ".508"
  }), React.createElement("ellipse", {
    cx: "24.5",
    cy: "15.008",
    rx: ".5",
    ry: ".508"
  }), React.createElement("ellipse", {
    cx: "21.5",
    cy: "15.992",
    rx: ".5",
    ry: ".508"
  }), React.createElement("ellipse", {
    cx: "26.5",
    cy: "13.008",
    rx: ".5",
    ry: ".508"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M17 39c2.108 0 4-1.892 4-4V23m7 16c-2.108 0-4-1.892-4-4V23"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M29.033 15.694A2.982 2.982 0 0 0 30 13.5a3 3 0 0 0-3-3c-.516 0-.995.142-1.419.372C24.994 9.764 23.842 9 22.5 9s-2.494.764-3.081 1.872A2.964 2.964 0 0 0 18 10.5a3 3 0 0 0-3 3c0 .87.376 1.646.967 2.194A2.992 2.992 0 0 0 14 18.5a3 3 0 0 0 3 3c.861 0 1.632-.367 2.179-.948C19.627 21.967 20.936 23 22.5 23s2.873-1.033 3.321-2.448A2.983 2.983 0 0 0 28 21.5a3 3 0 0 0 3-3 2.992 2.992 0 0 0-1.967-2.806z"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M32 34l-1 2 1 3"
  }), props.children);
});
var Magnify =
/*#__PURE__*/
React.forwardRef(function Magnify(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M37 20c0 6.075-4.925 11-11 11s-11-4.925-11-11S19.925 9 26 9s11 4.925 11 11zm2 13l-5.215-5.215M26 14a3 3 0 1 0 0 6 3 3 0 0 0 0-6zm3 8a3 3 0 1 0 0 6 3 3 0 0 0 0-6zm-13.713.462a3 3 0 1 0-.012-4.917m7.753-8.139a3 3 0 0 0 5.945.001m3.627 1.792a3 3 0 0 0 3.568 4.565"
  }), React.createElement("path", {
    d: "M9.5 11a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0zm5.5 1.5a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1zm-3 2a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1zm1 2a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1zm-3-1a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1zm1 2a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1zm-2 2a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1zm3 2a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1zm-2 1a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1zm5 1a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1zm-3 1a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1zm5 4a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1zm3 2a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1zm-6-1a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1zm-2 1a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1zm-2 1a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1zm3 2a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1zm-1 2a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1zm4-3a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1zm3 2a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1zm10-2a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1zm-7 6a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1zM13 9a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1zm4 .5a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1z"
  }), props.children);
});
var Marketplace =
/*#__PURE__*/
React.forwardRef(function Marketplace(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M27 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0zm-13.607 1.393a3 3 0 1 0 4.241 4.243 3 3 0 0 0-4.241-4.243zM9 24a3 3 0 1 0 6 0 3 3 0 0 0-6 0zm4.393 10.607a3 3 0 1 0 4.243-4.241 3 3 0 0 0-4.243 4.241zM24 39a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm10.607-4.393a3 3 0 1 0-4.241-4.243 3 3 0 0 0 4.241 4.243zM39 24a3 3 0 1 0-6 0 3 3 0 0 0 6 0zm-4.393-10.607a3 3 0 1 0-4.243 4.241 3 3 0 0 0 4.243-4.241z"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".752",
    d: "M24 18v12m-6-6h12m-10.243-4.243l8.486 8.486m-8.486 0l8.486-8.486"
  }), props.children);
});
var Mas =
/*#__PURE__*/
React.forwardRef(function Mas(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("font", {
    horizAdvX: "1000"
  }), React.createElement("text", {
    fontFamily: "IBMPlexSans",
    fontSize: "14",
    transform: "translate(10.5 23.996)"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M39 39H9M39 9H9v23h30V9z"
  }), props.children);
});
var Maximize =
/*#__PURE__*/
React.forwardRef(function Maximize(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M30 9h9v9m-10 1L39 9M18 9H9v9m0-9l10 10m11 20h9v-9m-10-1l10 10M9 30v9h9m1-10L9 39"
  }), props.children);
});
var MedicalCharts =
/*#__PURE__*/
React.forwardRef(function MedicalCharts(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M15.5 19h4m-2-2v4m.5-10h-5v24h18V11h-5M14 35v2h19V13h-2M16 37v2h19V15h-2m-9-5V9h-4v1h-2v2h8v-2h-2zm-3.5 7h8m-8 4h8m-13 4h13m-13 4h13"
  }), props.children);
});
var MedicalStaff =
/*#__PURE__*/
React.forwardRef(function MedicalStaff(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M16 40v-6.809c0-3.781 2.656-6.927 6.149-7.782a4.56 4.56 0 1 1 3.702 0A8 8 0 0 1 32 33.191V40M16.051 11.437a4.56 4.56 0 0 0 .098 8.29A8 8 0 0 0 10 27.509v6.49m12.329-17a4.562 4.562 0 0 0-2.375-5.56m7.114.628a4.551 4.551 0 0 0-1.629 3.494c0 .503.082.987.232 1.44M38 34v-6.492a8 8 0 0 0-6.149-7.782 4.559 4.559 0 0 0 1.081-7.659m-8.93 23.932v-3m0 3.001a1.499 1.499 0 1 0 0 2.998 1.499 1.499 0 0 0 0-2.998zM18.003 9a2 2 0 1 0-.001 3.999A2 2 0 0 0 18.003 9zM20 26.264V29c0 2.2 1.8 4 4 4h0c2.2 0 4-1.8 4-4v-2.736M28 13s.579-.727 2-.727c1.454 0 2 .728 2 .728L34 11s-.988-2-4-2-4 2-4 2l2 2z"
  }), props.children);
});
var Medical =
/*#__PURE__*/
React.forwardRef(function Medical(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M24 31v8m0-26.001v13.002m1.617-6c.937-.658 1.478-1.446 1.478-2.637 0-1.035-.617-1.993-1.478-2.361m-3.235 14.824c-.937.658-1.478 1.446-1.478 2.637 0 1.035.617 1.993 1.478 2.361m3.235-7.34c.976-.74 1.478-1.33 1.478-2.622 0-3.246-6.179-4.1-6.179-7.618 0-.999.608-1.865 1.442-2.242m3.259 19.822c.976-.74 1.478-1.33 1.478-2.622 0-3.246-6.179-4.1-6.179-7.618 0-.999.608-1.865 1.442-2.242M36 17h-6.848m4.827 2.001h-5.164M38 15h-6.286c-1.241 0-2.619.453-2.619 2.576 0 1.275-.855 2.84-2.095 3.424m-15-4h6.869M14 19.001h5.187M21 21c-1.239-.584-2.093-2.149-2.093-3.424 0-2.123-1.378-2.576-2.619-2.576H10m14-6a2 2 0 1 0-.001 3.999A2 2 0 0 0 24 9z"
  }), props.children);
});
var Melbourne =
/*#__PURE__*/
React.forwardRef(function Melbourne(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M19.5 10h10"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M18.5 24h12m-9-14l3 4 3-4m-5 6h4m-8 4a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2m-8-2v6m-4-4v4m8-6v6m4-4v4"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M16 20a6 6 0 0 1 6-6h5a6 6 0 0 1 6 6v8a2 2 0 0 1-2 2H18a2 2 0 0 1-2-2v-8z"
  }), React.createElement("circle", {
    cx: "24.5",
    cy: "27",
    r: "1",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M20 32l-4 6m13-6l4 6"
  }), React.createElement("circle", {
    cx: "20.5",
    cy: "26",
    r: ".5"
  }), React.createElement("circle", {
    cx: "28.5",
    cy: "26",
    r: ".5"
  }), React.createElement("circle", {
    cx: "20.5",
    cy: "28",
    r: ".5"
  }), React.createElement("circle", {
    cx: "28.5",
    cy: "28",
    r: ".5"
  }), props.children);
});
var Meter =
/*#__PURE__*/
React.forwardRef(function Meter(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M39 24c0 8.284-6.716 15-15 15S9 32.284 9 24 15.716 9 24 9s15 6.716 15 15zM24 11v3m-6.5-1.258L18.804 15m-6.062 2.5l1.758 1.015M11 24h1.5m.242 6.5l.866-.5m21.65.5l-3.899-2.251M37 24h-4m2.258-6.5L24 24m6.5-11.258L28.619 16"
  }), props.children);
});
var Microorganisms =
/*#__PURE__*/
React.forwardRef(function Microorganisms(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M27.734 11.999l-3 5.196a2.005 2.005 0 0 1-2.732.732h0a2.005 2.005 0 0 1-.732-2.732l3-5.196a2.005 2.005 0 0 1 2.732-.732h0a2.005 2.005 0 0 1 .732 2.732zm1.954 24.38l5.796 1.553a2.005 2.005 0 0 0 2.449-1.414v0a2.005 2.005 0 0 0-1.414-2.449l-5.796-1.553a2.005 2.005 0 0 0-2.449 1.414h0a2.005 2.005 0 0 0 1.414 2.449zm-14.69-11.306h0a2.005 2.005 0 0 0-2.732.732l-3 5.196a2.005 2.005 0 0 0 .732 2.732h0c.953.55 2.182.221 2.732-.732l3-5.196a2.005 2.005 0 0 0-.732-2.732zm22.001 3.854h0a2.005 2.005 0 0 0 .732-2.732l-3-5.196a2.005 2.005 0 0 0-2.732-.732h0a2.005 2.005 0 0 0-.732 2.732l3 5.196a2.007 2.007 0 0 0 2.732.732zM18.928 12.999h0a2.005 2.005 0 0 0-2.732-.732l-5.196 3a2.005 2.005 0 0 0-.732 2.732h0a2.005 2.005 0 0 0 2.732.732l5.196-3a2.007 2.007 0 0 0 .732-2.732zm3.998 20.002h0a2.005 2.005 0 0 0-2.732-.732l-5.196 3a2.005 2.005 0 0 0-.732 2.732h0a2.005 2.005 0 0 0 2.732.732l5.196-3a2.005 2.005 0 0 0 .732-2.732zm7.147-21.002h0a2.005 2.005 0 0 0 .732 2.732l5.196 3c.953.55 2.182.221 2.732-.732v0a2.005 2.005 0 0 0-.732-2.732l-5.196-3a2.006 2.006 0 0 0-2.732.732zM19.074 23.002h0a2.005 2.005 0 0 0 .732 2.732l5.196 3c.953.55 2.182.221 2.732-.732h0a2.005 2.005 0 0 0-.732-2.732l-5.196-3a2.006 2.006 0 0 0-2.732.732z"
  }), props.children);
});
var Microscope =
/*#__PURE__*/
React.forwardRef(function Microscope(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M29.5 33.5H35V39H13l3.667-3.666H29.5V33.5zm-3.667-16.498a2.75 2.75 0 1 0 0 5.5 2.75 2.75 0 0 0 0-5.5zM14.41 28.048l4.763 2.75.917-1.588-4.763-2.75-.917 1.588zm12.583-10.795l3.179-5.506-4.763-2.75-9.166 15.875 4.763 2.75 3.249-5.627m-6.424 3.794l-.917 1.588 1.588.917.917-1.588-1.588-.917zm14.108 7.712a9.12 9.12 0 0 0 1.226-4.583 9.164 9.164 0 0 0-4.812-8.068"
  }), props.children);
});
var Minimize =
/*#__PURE__*/
React.forwardRef(function Minimize(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M38 19h-9v-9m0 9L39 9M10 19h9v-9M9 9l10 10m19 10h-9v9m10 1L29 29m-10 9v-9h-9M9 39l10-10"
  }), props.children);
});
var MobileAdd =
/*#__PURE__*/
React.forwardRef(function MobileAdd(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("circle", {
    cx: "28",
    cy: "35.5",
    r: "1"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M37 9v30H19V28c4.42 0 8-3.58 8-8s-3.58-8-8-8V9h18zM19 32h18M19 16v8m4-4h-8m4-8a8 8 0 1 0 0 16 8 8 0 0 0 0-16z"
  }), props.children);
});
var MobileChat =
/*#__PURE__*/
React.forwardRef(function MobileChat(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("circle", {
    cx: "19",
    cy: "35.5",
    r: "1"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M28 24v15H10V9h18v3M10 32h18m8-20H25a2 2 0 0 0-2 2v14l4-4h9a2 2 0 0 0 2-2v-8a2 2 0 0 0-2-2zm-10 4h9m-9 4h9"
  }), props.children);
});
var MobileDevices =
/*#__PURE__*/
React.forwardRef(function MobileDevices(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("circle", {
    cx: "16",
    cy: "35.5",
    r: "1"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M23 39H9V15h14v24zM9 32h30m-11 7V19h-5m0 20h16V9H15v6"
  }), props.children);
});
var MobilePhone =
/*#__PURE__*/
React.forwardRef(function MobilePhone(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M33 39H15V9h18v30zm-18-7h18"
  }), React.createElement("circle", {
    cx: "24",
    cy: "35.5",
    r: "1"
  }), props.children);
});
var MortarAndPestle =
/*#__PURE__*/
React.forwardRef(function MortarAndPestle(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M39 23c0 8.284-6.734 15-15.018 15S9 31.284 9 23h30zm-16.804 0l-6.64-11.502a3.009 3.009 0 0 0-4.098-1.098h0a3.009 3.009 0 0 0-1.098 4.098L15.271 23"
  }), props.children);
});
var Moscow =
/*#__PURE__*/
React.forwardRef(function Moscow(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M17.723 26H28v2H16"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M34 34a1 1 0 0 1 2 0m-4 0a1 1 0 0 1 2 0"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M34 33v6m-2-10v10"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M36 30v4"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M28 27v12"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M24 35v4m-4-4v4m4-11v5m-4-5v5m-4-5v5m6 6h0m4 0h0m-4-2v2m-4 0h0m0-2v2m8-2v2"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M22 37v1m-4-1v1m8-1v1"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M36 33v6"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M32 35h4m-4-7h4v1.906h-4zm2 0V14m-20 4v-4m0 20a1 1 0 0 1 2 0m-4 0a1 1 0 0 1 2 0"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M12 34v5m2-5v5m2-5v5"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M14 30v1m-2-1v4m0 1h4m0-2h12v2H16zm-1 0l-1-2-1 2m11-7l-2-4-2 4"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M20 19l-2.366 4.14"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M22 19l-4 7"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M28 26l-4-7"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M26 26l-4-7"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M24 31c1.105-1.333 2.895-1.333 4 0m-8 0c1.105-1.333 2.895-1.333 4 0m-8 0c1.105-1.333 2.895-1.333 4 0"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M20 17h4v2h-4z"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M21 15h2v2h-2z"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M22 9v2"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M22 11c0 .724.333 1.448 1 2s.667 1.448 0 2m-1-4c0 .724-.333 1.448-1 2s-.667 1.448 0 2m13 3c0 1.302.764 2.48 2 3.333 1.236.853 2 2.032 2 3.333 0 1.302-.764 2.48-2 3.333"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M34 18c0 1.302.382 2.48 1 3.333.618.853 1 2.032 1 3.333 0 1.302-.382 2.48-1 3.333M34 18c0 1.302-.382 2.48-1 3.333-.618.853-1 2.032-1 3.333 0 1.302.382 2.48 1 3.333"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M34 18c0 1.302-.764 2.48-2 3.333-1.236.853-2 2.032-2 3.333 0 1.302.764 2.48 2 3.333M12 28c-1.236-.853-2-2.032-2-3.333 0-1.302.764-2.48 2-3.333 1.236-.853 2-2.032 2-3.333 0 1.302.764 2.48 2 3.333 1.236.853 2 2.032 2 3.333 0 1.302-.764 2.48-2 3.333"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M16 30h-4v-2h4"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M10.019 25L11 26l1-1 1 1 1-1 1 1 1-1 1.478 1.478m-7.179-3.193L11 24l1-1 1 1 1-1 1 1 1-1 1 1 .701-.715"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M34 30v1m1 2l-1-2-1 2"
  }), props.children);
});
var Mqa =
/*#__PURE__*/
React.forwardRef(function Mqa(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("font", {
    horizAdvX: "1000"
  }), React.createElement("text", {
    fontFamily: "IBMPlexSans",
    fontSize: "14",
    transform: "translate(10.005 23.994)"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M39 39H9M39 9H9v23h30V9z"
  }), props.children);
});
var Multitask =
/*#__PURE__*/
React.forwardRef(function Multitask(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M28 13a4 4 0 1 1-8 0 4 4 0 0 1 8 0zm-15 4a4 4 0 1 0 0 8 4 4 0 0 0 0-8zm22 0a4 4 0 1 0 0 8 4 4 0 0 0 0-8zm-3.75 22c0-3.357-2.285-6.173-5.382-6.998 1.392-.691 2.357-2.113 2.357-3.772a4.226 4.226 0 0 0-8.45 0c0 1.659.966 3.081 2.357 3.772-3.097.825-5.382 3.641-5.382 6.998"
  }), props.children);
});
var Munich =
/*#__PURE__*/
React.forwardRef(function Munich(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M9 32h30M9 34h30"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M32 14a7.952 7.952 0 0 1-1.15 4.117M16 14a7.98 7.98 0 0 0 2.85 6.117m3.723 1.749c.464.083.939.134 1.427.134 2.91 0 5.45-1.559 6.85-3.883m3.723 1.749A7.97 7.97 0 0 1 32 14m-4-2a7.98 7.98 0 0 0 2.85 6.117m-9.816 1.809C24.963 19.418 28 16.067 28 12"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: ".72",
    d: "M22.573 21.866a8.025 8.025 0 0 1-1.539-1.94m-2.184.191A7.952 7.952 0 0 0 20 16c0 1.428.378 2.765 1.034 3.926M28 24c-2.097 0-4-.814-5.427-2.134m-3.723-1.749A7.988 7.988 0 0 1 12 24"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M12 30v2m16-2v2m-14-3.911V32m2-5.109V32m2-5.778V32m2-6v6m2-5.778V32m2-5.109V32m2-3.911V32m0-3.911a10.582 10.582 0 0 0-2-1.198M28 30a11.957 11.957 0 0 0-2-1.911m-10-1.198c-.691.315-1.361.714-2 1.198m4-1.867a9.858 9.858 0 0 0-2 .669m8 0a9.796 9.796 0 0 0-2-.669m-8 1.867A11.957 11.957 0 0 0 12 30m8-4c-.67 0-1.339.079-2 .222m4 0A9.458 9.458 0 0 0 20 26M9 21.931c3.945-.493 7-3.852 7-7.931m-4 16a11.575 11.575 0 0 0-3-2.584m25.573-7.55A7.973 7.973 0 0 0 39 21.93m0 4.567c-3.793-1.255-8.02-.094-11 3.503"
  }), props.children);
});
var NaturalLanguageClassifier =
/*#__PURE__*/
React.forwardRef(function NaturalLanguageClassifier(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M28 26h-8v-4h8v4zm-11-4H9v4h8v-4zm22 0h-8v4h8v-4zM27 33h-6v6h6v-6zM13 9a3 3 0 1 0 0 6 3 3 0 0 0 0-6zm22 0l-3.464 6h6.928L35 9zm-22 6v7m22-7v7m-11 4v7"
  }), props.children);
});
var NetworkServices =
/*#__PURE__*/
React.forwardRef(function NetworkServices(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M26.5 36.5a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0zM28 20a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5zm0 5v6a2 2 0 0 0 2 2h4m-20 0h4a2 2 0 0 0 2-2v-2m-6 1.5H9v5h5v-5zm20-.5v6l5-3-5-3zm-2-2.986L34.5 27a4.5 4.5 0 0 0 0-9H34a9 9 0 0 0-9-9c-3.529 0-6.567 2.042-8.041 5H15.5a6.5 6.5 0 1 0 0 13h6.486a2 2 0 0 1 2 2L24 34"
  }), props.children);
});
var Network =
/*#__PURE__*/
React.forwardRef(function Network(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M28 24l-2 3.464h-4L20 24l2-3.464h4zm-8 0h-5.5m7.5 3.464l-2.75 4.763M26 27.464l2.75 4.763M33.5 24H28m-2-3.464l2.75-4.763"
  }), React.createElement("circle", {
    cx: "12",
    cy: "24",
    r: "2.5",
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72"
  }), React.createElement("circle", {
    cx: "18",
    cy: "34.392",
    r: "2.5",
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72"
  }), React.createElement("circle", {
    cx: "30",
    cy: "34.392",
    r: "2.5",
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72"
  }), React.createElement("circle", {
    cx: "36",
    cy: "24",
    r: "2.5",
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72"
  }), React.createElement("circle", {
    cx: "30",
    cy: "13.608",
    r: "2.5",
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72"
  }), React.createElement("circle", {
    cx: "18",
    cy: "13.608",
    r: "2.5",
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M27.51 13.607h-7.02m14.265 8.237l-3.51-6.08m0 16.472l3.51-6.08M20.49 34.392h7.02m-14.265-8.236l3.51 6.08m0-16.472l-3.51 6.08M22 20.536l-2.75-4.763"
  }), props.children);
});
var Networking_01 =
/*#__PURE__*/
React.forwardRef(function Networking_01(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M26.5 24a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0zm10-2.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5zm-25 0a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5zm3.835 11.75a2.499 2.499 0 1 0 4.327 2.5 2.499 2.499 0 0 0-4.327-2.5zm13 0a2.499 2.499 0 1 0 4.327 2.5 2.499 2.499 0 0 0-4.327-2.5zm-13-18.5a2.499 2.499 0 1 0 4.329-2.498 2.499 2.499 0 0 0-4.329 2.498zm13 0a2.499 2.499 0 1 0 4.329-2.498 2.499 2.499 0 0 0-4.329 2.498z"
  }), props.children);
});
var Networking_02 =
/*#__PURE__*/
React.forwardRef(function Networking_02(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M14.995 24H33m-21-3a3 3 0 1 0 0 6 3 3 0 0 0 0-6zm24 0a3 3 0 1 0 0 6 3 3 0 0 0 0-6zm0-12a3 3 0 1 0 0 6 3 3 0 0 0 0-6zm0 24a3 3 0 1 0 0 6 3 3 0 0 0 0-6zm-3-21h-9v24h9"
  }), props.children);
});
var Networking_03 =
/*#__PURE__*/
React.forwardRef(function Networking_03(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M18 12h15a6 6 0 0 1 0 12h-3m-12 0h-3a6.001 6.001 0 0 0 0 12h15M15 9H9v6h6V9zm24 24h-6v6h6v-6zM27 21h-6v6h6v-6z"
  }), props.children);
});
var Networking_04 =
/*#__PURE__*/
React.forwardRef(function Networking_04(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M9 27h12v12H9z"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M39 15a6 6 0 1 1-12 0 6 6 0 0 1 12 0zm-14.5 0H17a2 2 0 0 0-2 2v8m6.672-7.172L24.5 15l-2.828-2.828M23.5 33H31a2 2 0 0 0 2-2v-8m-6.672 7.172L23.5 33l2.828 2.828M13 33h2.5c.825 0 1.5-.675 1.5-1.5v0c0-.825-.675-1.5-1.5-1.5H13v3zm0 0v3h2.5c.825 0 1.5-.675 1.5-1.5h0c0-.825-.675-1.5-1.5-1.5"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "bevel",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M30.62 17.995l2.386-6 2.384 6"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M31.359 15.995h3.272"
  }), props.children);
});
var Networking_05 =
/*#__PURE__*/
React.forwardRef(function Networking_05(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M12 33v-7m3 10.001a3 3 0 1 0-6 0 3 3 0 1 0 6 0zm0-24a3 3 0 1 0-6 0 3 3 0 0 0 6 0zM20 31a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm16-12v7m-.001-13a3 3 0 1 0 0 6 3 3 0 1 0 0-6zM22 37h6V18m-8 7v-5l-6-6m21.965 11.984a2 2 0 1 0-.001 3.999 2 2 0 0 0 .001-3.999zM28 14a2 2 0 1 0-.001 3.999A2 2 0 0 0 28 14zm-8 21a2 2 0 1 0-.001 3.999A2 2 0 0 0 20 35zm-8-13a2 2 0 1 0-.001 3.999A2 2 0 0 0 12 22z"
  }), props.children);
});
var Nice =
/*#__PURE__*/
React.forwardRef(function Nice(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M19.394 27.801L17 31m11.606-3.199L31 31m-10 4l-2-4h-2l-.855 1.185L15 33v2m12 0l-1-3h-4l-1 3"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M23 25c0 2.954-2 5-2 5h6s-2-1.892-2-5"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M27 13h-2m-2 12l-3 3-1-1 3-4c-.363-.621-1-2-1-3 0-2 2-3 2-5 0-1 0-1-1-1h-1m6-2.984h-3M27 15h-2"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M16 22v4a1 1 0 0 1-2 0V16a2 2 0 0 1 2-2h1.034C17 16 18 17 20 17h2.325"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M16 23a1 1 0 0 0 2 0v-3m0 1a1 1 0 0 0 2 0v-1m11 2v4a1 1 0 0 0 2 0V16a2 2 0 0 0-2-2h-1.034C30 16 29 17 27 17"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M31 23a1 1 0 0 1-2 0v-3m-2-3h-2v-4.984"
  }), React.createElement("ellipse", {
    cx: "21.5",
    cy: "9.508",
    rx: ".5",
    ry: ".508"
  }), React.createElement("ellipse", {
    cx: "23.5",
    cy: "9.508",
    rx: ".5",
    ry: ".508"
  }), React.createElement("ellipse", {
    cx: "25.5",
    cy: "9.508",
    rx: ".5",
    ry: ".508"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M29 21a1 1 0 0 1-2 0v-1M15 39c-.605 0-1.053-.191-1.482-.525S12.605 38 12 38s-1.089.14-1.518.475S9.605 39 9 39m12 0c-.605 0-1.053-.191-1.482-.525C19.089 38.14 18.605 38 18 38s-1.089.14-1.518.475c-.429.334-.877.525-1.482.525m12 0c-.605 0-1.053-.191-1.482-.525C25.089 38.14 24.605 38 24 38s-1.089.14-1.518.475c-.429.334-.877.525-1.482.525m12 0c-.605 0-1.053-.191-1.482-.525C31.089 38.14 30.605 38 30 38s-1.089.14-1.518.475c-.429.334-.877.525-1.482.525m12 0c-.605 0-1.053-.191-1.482-.525C37.089 38.14 36.605 38 36 38s-1.089.14-1.518.475c-.429.334-.877.525-1.482.525m-18-2c-.605 0-1.053-.191-1.482-.525S12.605 36 12 36s-1.089.14-1.518.475S9.605 37 9 37m12 0c-.605 0-1.053-.191-1.482-.525C19.089 36.14 18.605 36 18 36s-1.089.14-1.518.475c-.429.334-.877.525-1.482.525m12 0c-.605 0-1.053-.191-1.482-.525C25.089 36.14 24.605 36 24 36s-1.089.14-1.518.475c-.429.334-.877.525-1.482.525m12 0c-.605 0-1.053-.191-1.482-.525C31.089 36.14 30.605 36 30 36s-1.089.14-1.518.475c-.429.334-.877.525-1.482.525m12 0c-.605 0-1.053-.191-1.482-.525C37.089 36.14 36.605 36 36 36s-1.089.14-1.518.475c-.429.334-.877.525-1.482.525m-18-2c-.605 0-1.053-.191-1.482-.525S12.605 34 12 34s-1.089.14-1.518.475S9.605 35 9 35m12 0c-.605 0-1.053-.191-1.482-.525C19.089 34.14 18.605 34 18 34s-1.089.14-1.518.475c-.429.334-.877.525-1.482.525m12 0c-.605 0-1.053-.191-1.482-.525C25.089 34.14 24.605 34 24 34s-1.089.14-1.518.475c-.429.334-.877.525-1.482.525m12 0c-.605 0-1.053-.191-1.482-.525C31.089 34.14 30.605 34 30 34s-1.089.14-1.518.475c-.429.334-.877.525-1.482.525m12 0c-.605 0-1.053-.191-1.482-.525C37.089 34.14 36.605 34 36 34s-1.089.14-1.518.475c-.429.334-.877.525-1.482.525"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M27 35l2-4h2l.855 1.185L33 33v2M21 12h1s0-1 1-1h1c.465 0 1 .393 1 .857v1.091l-.001-.003M21 12a1 1 0 0 0-1 1m5 12l3 3 1-1-3-4v-3"
  }), props.children);
});
var NightClear =
/*#__PURE__*/
React.forwardRef(function NightClear(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M32.4 32.839c.042 0 .083-.006.126-.006C30.151 35.391 26.77 37 23.004 37 15.822 37 10 31.179 10 23.997 10 16.858 15.698 11.068 22.821 11c-2.154 2.32-3.425 5.419-3.425 8.835.001 7.182 5.823 13.004 13.004 13.004zM34 14h-4m2 2v-4m-4 6h-4m2 2v-4m12 11h-4m2 2v-4"
  }), props.children);
});
var NycBrooklyn =
/*#__PURE__*/
React.forwardRef(function NycBrooklyn(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M36 18v4m-4-4v4m5-10v6h-6v-6l3-2z"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M20 32V9H9"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M16 24v4m0-10v4m0-10v4m2 8v4m0-10v4m0-10v4m-4 8v4m0-10v4m0-10v4m-2 8v4m0-10v4m0-10v4m-2 8v4m0-10v4m0-10v4"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M12 39v-7h16m0 7V22h11M20 36v3"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M36 29v3m-4-3v3m4 2v3m-4-3v3m0-13v3m4-3v3"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M16 39v-3h8v3m0-7V16h-4"
  }), props.children);
});
var NycManhattanAlt =
/*#__PURE__*/
React.forwardRef(function NycManhattanAlt(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M18 15.998h-6v-5l3-2 3 2v5zm-5 0v4m4-4v4m7 19v-19H9m15 7h8m7-11h-7v23m-21-14v-2m4 2v-2m4 2v-2m-8 8v-2m4 2v-2m4 2v-2m7.5 2v-2m3 2v-2m-3 6v-2m3 2v-2m5-12v-2m3 2v-2m-3 6v-2m3 2v-2"
  }), props.children);
});
var NycManhattan =
/*#__PURE__*/
React.forwardRef(function NycManhattan(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M9 13h15v16m6 0H16v9.998m23-17h-9v17m8-27l-3-2-3 2v6h6v-6zm-5 6v4m4-4v4M12 17v-2m4 2v-2m4 2v-2m-8 7v-2m4 2v-2m4 2v-2m-8 7.002v-2m4 2v-2m4 2v-2M20 33v-2m4 2v-2m9-2.998v-2m4 2v-2M33 33v-2m4 2v-2m-17 7v-2m4 2v-2m9 2v-2m4 2v-2"
  }), props.children);
});
var Office =
/*#__PURE__*/
React.forwardRef(function Office(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M20 39h-4v-8h4v8zm-8-24v-2m0 8v-2m0 8v-2m8-10v-2m0 8v-2m0 8v-2m-4-10v-2m0 8v-2m0 8v-2m-4 8v-2m12-16v-2m0 8v-2m0 8v-2m0 8v-2m7-10v-2m0 8v-2m0 8v-2m4-10v-2m0 8v-2m0 8v-2M27 9H9v30h18V9zm12 7H27v23h12V16zm-6-4h-6v4h6v-4z"
  }), props.children);
});
var OilPump =
/*#__PURE__*/
React.forwardRef(function OilPump(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M34.478 39v-4h3.043v4m-1.533-9v5M13 23.5V39m17.059-.02l-6.06-16-6.088 16m3.089-8h6M19.434 35h9.111M22.5 26.979h3M40 39H8m29.664-11.598L18.661 16.439l-1.5 2.598L36.164 30l1.5-2.598zM19.874 9.333h0a2.506 2.506 0 0 0-3.415.915l-5.5 9.526a2.507 2.507 0 0 0 .915 3.415h0a2.507 2.507 0 0 0 3.415-.915l5.5-9.526a2.508 2.508 0 0 0-.915-3.415z"
  }), React.createElement("circle", {
    cx: "13.134",
    cy: "20.98",
    r: "1"
  }), props.children);
});
var OilRig =
/*#__PURE__*/
React.forwardRef(function OilRig(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M39 31H9v-4h30v4zM23 20H9v7h14v-7zm8 0h-6v7h6v-7zm-2 7h6V15h-6v5m-10-7h-4v7h4v-7zm14-2h-2l-2 4h6l-2-4zm0-2h-2v2h2V9zM21 31v7.5M15 31v7.5M35 31v7.5M33 31v7.5M31 9l-12 6M9 38a1 1 0 0 0 2 0m0 0a1 1 0 0 0 2 0m0 0a1 1 0 0 0 2 0m0 0a1 1 0 0 0 2 0m.001 0a1 1 0 0 0 2 0M19 38a1 1 0 0 0 2 0m0 0a1 1 0 0 0 2 0m0 0a1 1 0 0 0 2 0m.001 0a1 1 0 0 0 2 0M27 38a1 1 0 0 0 2 0m0 0a1 1 0 0 0 2 0m0 0a1 1 0 0 0 2 0m.001 0a1 1 0 0 0 2 0M35 38a1 1 0 0 0 2 0m0 0a1 1 0 0 0 2 0"
  }), props.children);
});
var Overcast =
/*#__PURE__*/
React.forwardRef(function Overcast(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M39 22.574c0 3.078-2.495 5.393-5.574 5.426H13.631C11.058 27.967 9 26.231 9 23.658 9 21.086 11.058 19 13.631 19c.839 0 1.624.225 2.303.613C16.32 15.537 19.75 12 23.927 12c3.408 0 6.313 2.304 7.479 5.299.563-.191 1.393-.299 2.02-.299A5.574 5.574 0 0 1 39 22.574zM9 33h18m-9 3h18"
  }), props.children);
});
var PaperClip =
/*#__PURE__*/
React.forwardRef(function PaperClip(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M15.982 26.845l11.935-6.89a2.46 2.46 0 0 1 3.361.901h0a2.458 2.458 0 0 1-.901 3.361l-15.676 9.051a3.797 3.797 0 0 1-5.191-1.391h0a3.798 3.798 0 0 1 1.391-5.192l20.388-11.771a5.136 5.136 0 0 1 7.022 1.882h0a5.135 5.135 0 0 1-1.882 7.021l-16.647 9.611"
  }), props.children);
});
var Parliament =
/*#__PURE__*/
React.forwardRef(function Parliament(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M19 34v-2m3 6v-4m-6 0v-2m13 2v-2m-3 6v-4m6 0v-2m-13 6v-2m-3 2v-2m13 2v-2m3 2v-2m4 2v-2m0-2v-2m0-2v-2M12 38v-2m0-2v-2m0-2v-2m12-14v-4m0 18v-2m-3 2v-2m-2-2h10m-2 4v-2M11 39h25.5M14 26h-4v13h4V26zm24 0h-4v13h4V26zm-4 4H14v9h20v-9zm-22-9l-2 5h4zm24 0l-2 5h4zM24 10h3v2h-3zm-5 18v-4l5-10 5 10v4m-3 6a2 2 0 1 0-4 0"
  }), props.children);
});
var PartnerRelationship =
/*#__PURE__*/
React.forwardRef(function PartnerRelationship(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M27.001 22l2 2-2 2M21 22l-2 2 2 2m-1.999-2h10"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M35.001 10a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5zm-2 28v-9c-1.295-.467-2-1.469-2-2.79L31 21a4 4 0 0 1 8 0l.001 5.199c0 1.321-.705 2.333-2 2.801v9m-24-28a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5zm-2 28v-9c-1.295-.467-2-1.469-2-2.79L9 21a4 4 0 0 1 8 0l.001 5.199c0 1.321-.705 2.333-2 2.801v9"
  }), props.children);
});
var Path =
/*#__PURE__*/
React.forwardRef(function Path(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M27 24a3 3 0 1 1-6 0 3 3 0 0 1 6 0zm-14-3a3 3 0 1 0 0 6 3 3 0 0 0 0-6zm22 0a3 3 0 1 0 0 6 3 3 0 0 0 0-6zM24 10a3 3 0 1 0 0 6 3 3 0 0 0 0-6zm-11 0a3 3 0 1 0 0 6 3 3 0 0 0 0-6zm22 0a3 3 0 1 0 0 6 3 3 0 0 0 0-6zM24 32a3 3 0 1 0 0 6 3 3 0 0 0 0-6zm-11 0a3 3 0 1 0 0 6 3 3 0 0 0 0-6zm22 0a3 3 0 1 0 0 6 3 3 0 0 0 0-6zM16 13h5m3 3v5m0 6v5m3 3h5"
  }), props.children);
});
var Pattern =
/*#__PURE__*/
React.forwardRef(function Pattern(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M27 29H11c-1.1 0-2-.9-2-2V11c0-1.1.9-2 2-2h16c1.1 0 2 .9 2 2v16c0 1.1-.9 2-2 2zm-8 0v8c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V21c0-1.1-.9-2-2-2h-8m-6-8v-1a1 1 0 0 0-1-1h-1a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1zm-5 6v-1a1 1 0 0 0-1-1h-1a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1zm11 0v-1a1 1 0 0 0-1-1h-1a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1zm-17 5v-1a1 1 0 0 0-1-1h-1a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1zm11 0v-1a1 1 0 0 0-1-1h-1a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1zm-5 6v-1a1 1 0 0 0-1-1h-1a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1zm11-1h0a1 1 0 0 0-1-1h-1a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h0a2 2 0 0 0 2-2zM9 11h0a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1h0"
  }), props.children);
});
var Perfume =
/*#__PURE__*/
React.forwardRef(function Perfume(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M32 39H16c-.55 0-1-.45-1-1V20c0-.55.45-1 1-1h16c.55 0 1 .45 1 1v18c0 .55-.45 1-1 1zm-5-20v-4.5c0-.275-.225-.5-.5-.5h-5c-.275 0-.5.225-.5.5v4.275m4.5-4.8V10.5c0-.275-.225-.5-.5-.5h-2c-.275 0-.5.225-.5.5V14m6-3.5L31 9m-2.5 3H32m-1 3l-2.5-1.5m1.583 11.562h-12.25V34h12.25v-8.938z"
  }), props.children);
});
var Person_01 =
/*#__PURE__*/
React.forwardRef(function Person_01(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M24 10a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5zm-2 28v-9h-2a2 2 0 0 1-2-2v-5a5 5 0 0 1 5-5h2a5 5 0 0 1 5 5v5a2 2 0 0 1-2 2h-2v9"
  }), props.children);
});
var Person_02 =
/*#__PURE__*/
React.forwardRef(function Person_02(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M24 10a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5zm-2 28v-8.314A6.502 6.502 0 0 1 24 17a6.5 6.5 0 0 1 2 12.686h0V38"
  }), props.children);
});
var Person_03 =
/*#__PURE__*/
React.forwardRef(function Person_03(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M24 10a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5zm-2 28v-9c-1.295-.467-2-1.469-2-2.79V21a4 4 0 0 1 8 0v5.199c0 1.321-.705 2.333-2 2.801v9"
  }), props.children);
});
var Person_04 =
/*#__PURE__*/
React.forwardRef(function Person_04(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M24 10a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5zm-2 28v-9h0-2a2 2 0 0 1-1.845-2.77L21.17 19c.546-1.198 1.401-2 2.829-2h0c1.429 0 2.3.802 2.829 2l-.008-.021 3.024 7.251A1.999 1.999 0 0 1 28 29h-2v9"
  }), props.children);
});
var Person_05 =
/*#__PURE__*/
React.forwardRef(function Person_05(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M24 10a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5zm-2 28v-9l-3.845-9.23A2 2 0 0 1 20 17h8a2 2 0 0 1 1.845 2.77L26 29v9"
  }), props.children);
});
var Person_06 =
/*#__PURE__*/
React.forwardRef(function Person_06(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M24 10a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5zm-2 28V28h-3a1 1 0 0 1-1-1v-9a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v9a1 1 0 0 1-1 1h-3v10"
  }), props.children);
});
var Person_07 =
/*#__PURE__*/
React.forwardRef(function Person_07(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M24 10a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5zm5 11H19a1 1 0 0 1-1-1v-2a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1zm-7 17V28h-3a1 1 0 0 1-1-1v-2a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-3 0v10"
  }), props.children);
});
var Person_08 =
/*#__PURE__*/
React.forwardRef(function Person_08(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M24 10a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5zm-6 17v-9a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v9a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1zm8 0v-9a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v9a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1zm-4 3v8m4 0v-8"
  }), props.children);
});
var Person_09 =
/*#__PURE__*/
React.forwardRef(function Person_09(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M24 17a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5zm-2 21V28h-3a1 1 0 0 1-1-1v-2a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-3 0v10"
  }), props.children);
});
var PersonalityInsights =
/*#__PURE__*/
React.forwardRef(function PersonalityInsights(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M24 24v-9m6 24v-2.98a5.99 5.99 0 0 0-4.433-5.799 3.306 3.306 0 1 0-3.114 0A6.007 6.007 0 0 0 18 36.02V39m-6-23.998v5h23.501V15m-8.503-6h-6v6h6V9zM12 9a3 3 0 1 0 0 6 3 3 0 0 0 0-6zm23.536 0l-3.464 6H39l-3.464-6z"
  }), props.children);
});
var PetriCulture =
/*#__PURE__*/
React.forwardRef(function PetriCulture(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    d: "M24.5 24.001a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0zm4-10.501a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm-12 15a1 1 0 1 0 0 2 1 1 0 0 0 0-2zM20.501 15a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1zM31 28.5a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1z"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M39 24c0 8.284-6.716 15-15 15S9 32.284 9 24 15.716 9 24 9s15 6.716 15 15zM20.5 13a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5zM33 18a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5zm-8.5 12a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5zM14 23a2 2 0 1 0-.001 3.999A2 2 0 0 0 14 23z"
  }), props.children);
});
var PillBottle_01 =
/*#__PURE__*/
React.forwardRef(function PillBottle_01(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M34 15H14V9h20v6zM16 9v4m8-4v4m4-4v4m-8-4v4m12-4v4m0 2H16v24h16V15zm-16 5h16m-13 3h5m-5 3h10m-10 2h10m3 6H16"
  }), props.children);
});
var Pills =
/*#__PURE__*/
React.forwardRef(function Pills(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M37.536 20.364a5 5 0 0 1 0 7.071 5 5 0 0 1-7.071 0l-9.899-9.899a5 5 0 0 1 0-7.071 5 5 0 0 1 7.071 0l9.899 9.899zm-12.021 2.121l7.071-7.071M10.464 27.536a5 5 0 0 0 7.071 0 5 5 0 0 0 0-7.071 5 5 0 1 0-7.071 7.071zM12 33a3 3 0 1 0 0 6 3 3 0 0 0 0-6zM36.5 9a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5zM12 9a3 3 0 1 0 0 6 3 3 0 0 0 0-6zm6.895 15h-9.84m10.288 8.586a2 2 0 1 0 2.828 2.828l4.243-4.243a2 2 0 1 0-2.828-2.828l-4.243 4.243zM36 37.879a2 2 0 1 0 0-4h-6a2 2 0 1 0 0 4h6zM33 34v3.809"
  }), props.children);
});
var Podcast =
/*#__PURE__*/
React.forwardRef(function Podcast(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M13.393 34.607A14.957 14.957 0 0 1 9 24c0-8.284 6.716-15 15-15s15 6.716 15 15c0 4.142-1.679 7.892-4.393 10.607m-2.829-2.829A10.962 10.962 0 0 0 35 24c0-6.075-4.925-11-11-11s-11 4.925-11 11c0 3.038 1.231 5.788 3.222 7.778M24 21a3 3 0 1 0 0 6 3 3 0 0 0 0-6zm0 8v10"
  }), props.children);
});
var Police =
/*#__PURE__*/
React.forwardRef(function Police(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M24 14c-.741-.212-1.25-.964-1.25-1.643v-.981c.64 0 .914-.098 1.25-.376.336.278.61.376 1.25.376v.981c0 .679-.509 1.431-1.25 1.643zm6-3.29c-3.07 0-4.38-.44-6-1.71-1.62 1.27-2.93 1.71-6 1.71-1.15 2.09-4 2.61-4 2.61l1.23 1.62 1.37 1.81.18.23.01.02c1.64-.88 3.83-1.63 7.23-1.63s5.33.75 7.22 1.62l.17-.22 1.37-1.83L34 13.32s-2.85-.52-4-2.61zm1.225 8.28c-1.89-.87-3.82-1.62-7.22-1.62s-5.59.75-7.23 1.63m-.372 0c1.757.959 3.934 2.4 7.567 2.4s5.869-1.442 7.626-2.4M32 35.714v-1.963c-1.28 0-1.827-.196-2.5-.752-.673.556-1.22.752-2.5.752v1.963c0 1.358 1.018 2.861 2.5 3.286 1.482-.425 2.5-1.928 2.5-3.286zm0 0v-1.963c-1.28 0-1.827-.196-2.5-.752-.673.556-1.22.752-2.5.752v1.963c0 1.358 1.018 2.861 2.5 3.286 1.482-.425 2.5-1.928 2.5-3.286zm-.76-18.724c.18.47.31.97.4 1.48.06.41.1.83.1 1.26 0 3.16-1.89 5.86-4.6 7.07C33.12 28.22 38 33.59 38 40m-28 0c0-6.41 4.88-11.78 10.86-13.2-2.7-1.21-4.59-3.91-4.59-7.07 0-.43.04-.86.11-1.27.08-.51.21-1.01.4-1.48M16 36h5"
  }), props.children);
});
var Power =
/*#__PURE__*/
React.forwardRef(function Power(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M23.984 9L38 25H10L23.984 9zm9.544 0L10 33h28L14.568 9h18.96zM31 39l-2.636-25h-8.75L17 39m.627-6h12.736l-6.38-8-6.356 8z"
  }), props.children);
});
var Presentation =
/*#__PURE__*/
React.forwardRef(function Presentation(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M22 15.981V9h17v14H24m0-12h5m-5 2h4m-9.001 26v-1.573c0-2.174-1.415-4.016-3.362-4.7a3.557 3.557 0 0 0 1.933-3.156 3.572 3.572 0 1 0-7.144 0c0 1.379.79 2.562 1.934 3.157-1.947.685-3.36 2.527-3.36 4.699V39m20 0l-.001-1.573c0-2.174-1.415-4.016-3.362-4.7a3.557 3.557 0 0 0 1.933-3.156 3.572 3.572 0 1 0-7.144 0c0 1.379.79 2.562 1.934 3.157-1.946.685-3.36 2.527-3.36 4.699V39m20 0v-1.573c0-2.174-1.415-4.016-3.362-4.7a3.557 3.557 0 0 0 1.933-3.156 3.572 3.572 0 1 0-7.144 0c0 1.379.79 2.562 1.934 3.157-1.947.685-3.36 2.526-3.36 4.699L29 39m7.121-20.879a3 3 0 1 0-4.241-4.243 3 3 0 0 0 4.241 4.243zM34 16l-.745 2.885M34 16l2.152-2.134M34 16l-2.567-1.508M18 23v-5.272h7.04c.55 0 1-.45 1-1v0c0-.55-.45-1-1-1H22v0h-6.384a3.559 3.559 0 0 0 1.927-3.156C17.543 10.599 15.967 9 14 9s-3.578 1.599-3.578 3.572c0 1.379.787 2.562 1.928 3.157-1.941.684-3.35 2.526-3.35 4.698V23"
  }), props.children);
});
var Presenter =
/*#__PURE__*/
React.forwardRef(function Presenter(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M15 25a11.347 11.347 0 0 1 6.525-4.37c-2.12-.95-3.61-3.08-3.61-5.55 0-3.36 2.72-6.08 6.08-6.08s6.08 2.72 6.08 6.08c0 2.47-1.49 4.6-3.61 5.55A11.37 11.37 0 0 1 33 25m-5.818 10.182a4.5 4.5 0 1 0-6.366-6.364 4.5 4.5 0 0 0 6.366 6.364zm-4.305 1.146L24 32m3.19-3.169L24 32m0 0l-3.857-2.262M35 29.47V25H13v4.47m0 5V39h22v-4.53"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M15.5 32a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0zM35 29.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5z"
  }), props.children);
});
var Price =
/*#__PURE__*/
React.forwardRef(function Price(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M39 22.205L22.209 39 9 25.787 25.791 9 39 22.205zM36 12l-6.469 6.474m1.386 1.386a1.963 1.963 0 1 0-2.776-2.777 1.963 1.963 0 0 0 2.776 2.777z"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M25.995 22.011l-8.263 8.263m7.239-4.015c.815-.815.755-2.198-.136-3.089-.89-.89-2.273-.951-3.089-.136-.815.815-.755 2.198.136 3.089m-3.088-.135c-.815.815-.755 2.198.136 3.089.89.89 2.273.951 3.089.136s.755-2.198-.136-3.089"
  }), props.children);
});
var Printer =
/*#__PURE__*/
React.forwardRef(function Printer(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M13 32H9V18h30v14h-4m0-6H13v13h22V26zm0-8V9H13v9m18 4h4"
  }), props.children);
});
var PrivateNetwork_01 =
/*#__PURE__*/
React.forwardRef(function PrivateNetwork_01(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M18 12h15a6 6 0 0 1 0 12h-3m-12 0h-3a6 6 0 0 0 0 12h15"
  }), React.createElement("circle", {
    cx: "24",
    cy: "24",
    r: ".75"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M15 15H9V9h6v6zm24 18h-6v6h6v-6zM25.995 21.022v-2.527a1.995 1.995 0 1 0-3.99 0v2.527M24 24.25v1.5m0-5.25a4 4 0 1 0 0 8 4 4 0 0 0 0-8z"
  }), props.children);
});
var PrivateNetworkAlt_01 =
/*#__PURE__*/
React.forwardRef(function PrivateNetworkAlt_01(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M18 12h15a6 6 0 0 1 0 12h-3m-12 0h-3a6 6 0 0 0 0 12h15"
  }), React.createElement("circle", {
    cx: "24",
    cy: "24",
    r: ".75"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M15 15H9V9h6v6zm24 18h-6v6h6v-6zM25.995 21.022v-2.527a1.995 1.995 0 1 0-3.99 0v2.527M24 24.25v1.5M28 21h-8v7h8v-7z"
  }), props.children);
});
var PrivateNetworkAlt =
/*#__PURE__*/
React.forwardRef(function PrivateNetworkAlt(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M18 12h15a6 6 0 0 1 0 12h-3m-12 0h-3a6.001 6.001 0 0 0 0 12h15"
  }), React.createElement("circle", {
    cx: "24",
    cy: "24",
    r: ".75"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M22.005 21.022v-2.527a1.995 1.995 0 1 1 3.99 0v2.527M24 24.25v1.5M12 9a3 3 0 1 0 0 6 3 3 0 0 0 0-6zm24 24a3 3 0 1 0 0 6 3 3 0 0 0 0-6zm-8-12h-8v7h8v-7z"
  }), props.children);
});
var PrivateNetwork =
/*#__PURE__*/
React.forwardRef(function PrivateNetwork(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M18 12h15a6 6 0 0 1 0 12h-3m-12 0h-3a6.001 6.001 0 0 0 0 12h15"
  }), React.createElement("circle", {
    cx: "24",
    cy: "24",
    r: ".75"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M22.005 21.022v-2.527a1.995 1.995 0 1 1 3.99 0v2.527M24 24.25v1.5m0-5.25a4 4 0 1 0 0 8 4 4 0 0 0 0-8zM12 9a3 3 0 1 0 0 6 3 3 0 0 0 0-6zm24 24a3 3 0 1 0 0 6 3 3 0 0 0 0-6z"
  }), props.children);
});
var Progress =
/*#__PURE__*/
React.forwardRef(function Progress(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M17 35a4 4 0 1 1-8 0 4 4 0 0 1 8 0zm22-4h-8v8h8v-8zm-8-3h8v-8h-8m8-3V9h-8M20 39h8l-4-8-4 8zM9 24a4 4 0 1 0 4-4m0-3a4 4 0 0 0 0-8m7 19h8l-4-8m4-3l-4-8"
  }), props.children);
});
var Puzzle =
/*#__PURE__*/
React.forwardRef(function Puzzle(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M13 24H9V13h4v-.3a2 2 0 0 1-.96-1.7 2 2 0 1 1 4 0c0 .75-.42 1.4-1.04 1.74V13h7v5h.24c.34-.62 1-1 1.75-1 1.11 0 2.01.9 2.01 2s-.9 2-2.01 2c-.72 0-1.35-.43-1.7-1H22v4h-7m8.993 4c-.757 0-1.408.383-1.75 1H22v-5h-7v-.256A1.992 1.992 0 0 0 14.04 20a2 2 0 0 0-2 2c0 .722.386 1.35.96 1.701V24H9v11h4v-.299A1.993 1.993 0 0 1 12.04 33a2 2 0 0 1 4 0c0 .754-.423 1.403-1.04 1.744V35h7v-4h.285c.353.574.983 1 1.708 1C25.101 32 26 31.105 26 30s-.899-2-2.007-2zM22 31v4h4v.27a2 2 0 0 0-.96 1.7c0 1.1.86 2.03 1.96 2.03s2.04-.93 2.04-2.03c0-.75-.42-1.4-1.04-1.74V35h7v-4h.29c.35.57.98 1 1.7 1 1.11 0 2.01-.9 2.01-2s-.9-2-2.01-2c-.75 0-1.41.38-1.75 1H35v-5H22v5m0-9v4h13v-4h-.28c-.36.57-.99 1-1.71 1-1.11 0-2.01-.9-2.01-2s.9-2 2.01-2c.75 0 1.41.38 1.75 1H35v-5h-7v-.26c.62-.34 1.04-.99 1.04-1.74a2 2 0 1 0-4 0 2 2 0 0 0 .96 1.7v.3h-4v5"
  }), props.children);
});
var QuestionAndAnswer =
/*#__PURE__*/
React.forwardRef(function QuestionAndAnswer(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M19 39l-4-6.005h-4c-1.1 0-2-.9-2-2v-10c0-1.1.9-2 2-2h15c1.1 0 2 .9 2 2v10c0 1.1-.9 2-2 2h-7M32 25l2-4h3c1.1 0 2-.9 2-2v-8c0-1.1-.9-2-2-2H25c-1.1 0-2 .9-2 2v7.995M31 21h-3m3.018-4.505c0-1.111.157-1.434.827-1.816.486-.278.961-.691.961-1.517 0-1.064-.812-1.663-1.802-1.663-.997 0-1.81.711-1.81 1.663"
  }), React.createElement("path", {
    d: "M19.5 26a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm4-1a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm-10 0a1 1 0 1 0 0 2 1 1 0 0 0 0-2zM31 18.625a.625.625 0 1 0 0-1.25.625.625 0 0 0 0 1.25z"
  }), props.children);
});
var Question =
/*#__PURE__*/
React.forwardRef(function Question(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M17.33 20.712c0-3.706 2.991-6.71 6.68-6.71 3.689 0 6.68 2.363 6.68 6.069 0 6.676-6.695 4.732-6.695 11.924M31.488 37C35.978 34.408 39 29.557 39 24c0-8.284-6.716-15-15-15S9 15.716 9 24c0 5.557 3.022 10.408 7.512 13"
  }), React.createElement("circle", {
    cx: "24",
    cy: "37.5",
    r: "1"
  }), props.children);
});
var RainyHeavy =
/*#__PURE__*/
React.forwardRef(function RainyHeavy(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M19.861 34.366l1-1.732m-3.5-1.768l1-1.732m-5 8.732l1-1.732m14-1.768l1-1.732m-14 1.732l1-1.732m7.5 1.732l1-1.732m1-1.768l1-1.732m-5 1.732l1-1.732m7.5 1.732l1-1.732m-9.5 8.732l1-1.732m-5 1.732l1-1.732m7.5 1.732l1-1.732M33.426 15c-.627 0-1.458.108-2.02.299C30.24 12.304 27.335 10 23.927 10c-4.177 0-7.606 3.537-7.992 7.613A4.639 4.639 0 0 0 13.631 17C11.058 17 9 19.086 9 21.658c0 2.573 2.058 4.309 4.631 4.342h19.795C36.504 25.967 39 23.652 39 20.574S36.504 15 33.426 15z"
  }), props.children);
});
var Rainy =
/*#__PURE__*/
React.forwardRef(function Rainy(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M14 34.464L16 31m1.5 6l3.5-6m3 3.464L26 31m1.5 6l3.5-6m2.426-15c-.627 0-1.458.108-2.02.299C30.24 13.304 27.335 11 23.927 11c-4.177 0-7.606 3.537-7.992 7.613A4.639 4.639 0 0 0 13.631 18C11.058 18 9 20.086 9 22.658c0 2.573 2.058 4.309 4.631 4.342h19.795C36.504 26.967 39 24.652 39 21.574S36.504 16 33.426 16z"
  }), props.children);
});
var Rank =
/*#__PURE__*/
React.forwardRef(function Rank(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M12 15a3 3 0 1 1 0-6 3 3 0 0 1 0 6zm.045 6.75H12a2.25 2.25 0 1 0 .045 0zM12.03 34.5H12a1.5 1.5 0 1 0 .03 0zM12 22v-7m0 19.5V26m9-17h18m-18 3h18m-18 3h18m-18 6h18m-18 3h18m-18 3h18m-18 6h18m-18 3h18m-18 3h18"
  }), props.children);
});
var Receipt =
/*#__PURE__*/
React.forwardRef(function Receipt(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M15 39h19V9H15v30zm3-25h7m4 0h2m-13 4h7m4 0h2m-13 4h7m4 0h2m-13 4h7m-7 4h13m-2-4h2m-2 8h2"
  }), props.children);
});
var Recycle =
/*#__PURE__*/
React.forwardRef(function Recycle(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M33.112 30l-3.409-6.15 5.252-2.911 3.285 5.934a2.052 2.052 0 0 1-.018 2.03l-3.437 6.075A2.007 2.007 0 0 1 33.02 36H28v2l-4-5 4-5v2h8.409c.81.004 1.463-.48 1.813-1.097m-24.777 6.093c-.37-.606-.477-1.411-.08-2.118l4.077-7.354 1.749.97-2.434-5.923-6.312 1.074 1.749.97-2.434 4.39a2.005 2.005 0 0 0 .038 2.039l3.647 5.952c.356.583.987.999 1.767 1l6.782.004v-6.005h-7.032M21.049 10.5c.71.001 1.453.331 1.848 1.038l4.141 7.319-1.741.985 6.321 1.019L34 14.917l-1.741.985-2.472-4.369a2.006 2.006 0 0 0-1.759-1.033h-6.979a2.052 2.052 0 0 0-1.776.984l-3.548 5.781 5.12 3.138 3.674-5.995"
  }), props.children);
});
var Refinery =
/*#__PURE__*/
React.forwardRef(function Refinery(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M40 39H8"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M10 9c0 1.311.945 2 1.999 2h0c1.311 0 1.999.946 1.999 2M16 12c0-2-1-3-3-3m3 16.171V20h-4v12m16 7V17h-4v22m15 0V25h-9v14M10.5 17c0 1.063.739 2.374 1.5 3h4c.761-.626 1.5-1.937 1.5-3s-.739-2.374-1.5-3h-4c-.762.626-1.5 1.937-1.5 3zM16 39v-3h-4v3m-3-5c0 .805.442 1.526 1 2h8c.558-.474 1-1.195 1-2 0-.805-.442-1.526-1-2h-8c-.559.474-1 1.195-1 2zm21 2h9M27 17v-2a3 3 0 0 0-3-3h-2a3 3 0 0 0-3 3v9a1 1 0 0 1-1 1h-1a3 3 0 0 0-3 3v4m11-15v-2a1 1 0 0 0-1-1h-2a1 1 0 0 0-1 1v9a3 3 0 0 1-3 3h-1a1 1 0 0 0-1 1v4"
  }), props.children);
});
var Refresh =
/*#__PURE__*/
React.forwardRef(function Refresh(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M21 21l-6-6 6-6M10 24v13a2 2 0 0 0 2 2h24a2 2 0 0 0 2-2V17a2 2 0 0 0-2-2H15"
  }), props.children);
});
var RelationshipExtraction =
/*#__PURE__*/
React.forwardRef(function RelationshipExtraction(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M16 16H9v-4h7v4zm23-4H20v4h19v-4zM16 32H9v4h7v-4zm23 0H20v4h19v-4zm-7-6h7v-4h-7v4zM9 26h19v-4H9v4z"
  }), props.children);
});
var RenewTeam =
/*#__PURE__*/
React.forwardRef(function RenewTeam(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M20 32v-3.749a4.003 4.003 0 0 1 3.076-3.891A2.279 2.279 0 0 1 24 20a2.279 2.279 0 1 1 .926 4.36 4 4 0 0 1 3.073 3.891V32M31 29v-3.747a4.001 4.001 0 0 0-3.074-3.891A2.279 2.279 0 0 0 27.001 17a2.28 2.28 0 0 0-2.092 3.188m-1.818 0a2.28 2.28 0 1 0-3.017 1.174A4 4 0 0 0 17 25.253V29m7-18c-7.18 0-13 5.817-13 12.997 0 6.147 4.267 11.298 10 12.652M24 37c7.18 0 13-5.82 13-13 0-6.147-4.267-11.298-10-12.652"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M22 9l2 2-2 2m3.997 22.004L24 37l2 2"
  }), props.children);
});
var Renew =
/*#__PURE__*/
React.forwardRef(function Renew(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M36 9v6h-6M18 33h-6v6m24-24a14.977 14.977 0 0 0-12-6C15.716 9 9 15.716 9 24m3 9c2.737 3.643 7.093 6 12 6 8.284 0 15-6.716 15-15"
  }), props.children);
});
var Repeat =
/*#__PURE__*/
React.forwardRef(function Repeat(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M35 9l4 4-4 4m4-4H11c-1.1 0-2 .9-2 2v9m4 7l-4 4 4 4m-4-4h28c1.1 0 2-.9 2-2v-9"
  }), props.children);
});
var Report =
/*#__PURE__*/
React.forwardRef(function Report(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M39 39H9V9h30v30zM9 33l9-9 7 7 14-14M9 17h30"
  }), props.children);
});
var ResetHybridCloud =
/*#__PURE__*/
React.forwardRef(function ResetHybridCloud(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M37 35.232H24c-7.18 0-13-5.82-13-13s5.82-13 13-13 13 5.82 13 13m-3.536 16.536L37 35.232l-3.536-3.536M22 29.98a8 8 0 0 1 2-15.748v4l3 2-6 4 3 2v4a8 8 0 0 0 2-15.748"
  }), props.children);
});
var ResetSettings =
/*#__PURE__*/
React.forwardRef(function ResetSettings(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M37 35.232H24c-7.18 0-13-5.82-13-13s5.82-13 13-13 13 5.82 13 13m-3.536 16.536L37 35.232l-3.536-3.536M31.5 23.979v-2.957h-1.942l-.578-1.41 1.369-1.369-2.091-2.091-1.373 1.373-1.406-.588V15h-2.957v1.942l-1.41.578-1.369-1.369-2.091 2.091 1.373 1.373-.588 1.406H16.5v2.957h1.942l.578 1.41-1.369 1.369 2.091 2.091 1.373-1.373 1.406.588V30h2.957v-1.942l1.41-.578 1.369 1.369 2.091-2.091-1.373-1.373.588-1.406H31.5z"
  }), props.children);
});
var Reset =
/*#__PURE__*/
React.forwardRef(function Reset(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M36 9v6h-6m6.001-.001A14.978 14.978 0 0 0 24 9C15.716 9 9 15.716 9 24s6.716 15 15 15 15-6.716 15-15"
  }), props.children);
});
var RetrieveAndRank =
/*#__PURE__*/
React.forwardRef(function RetrieveAndRank(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M21 15h-6v-3h6v3zm6.55-3h-3.078v3H29.8m0 10.001h-5.328v3h3.077M20 18.5h-8v3h8v-3zm10.882 0H23v3h7.883M21 25.001h-6v3h6v-3zm18-5.002h-8m8 3h-8.414m8.414-9h-9.779m9.779 3h-8.414M20 9C13.925 9 9 13.925 9 20s4.925 11 11 11 11-4.925 11-11S26.075 9 20 9zm7.785 18.784L39 39"
  }), props.children);
});
var RichTextFormat =
/*#__PURE__*/
React.forwardRef(function RichTextFormat(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M24 31H9V16h15v15zm-5.5-13a1.5 1.5 0 1 0 .001 3.001A1.5 1.5 0 0 0 18.5 18zM24 28l-4-4-2 2-5-5-4 4m6 6v8h24V15l-6-6H15v7m18-7v6h6m-15 4h11m-11 4h11m-11 4h11m-11 4h11m-16 4h12"
  }), props.children);
});
var Robot =
/*#__PURE__*/
React.forwardRef(function Robot(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M25 39a2 2 0 1 1 4 0h-4zM20 9v5h8V9h-8zm4 5v3m5 0H19v13h10V17zm-18 7.17l.828.243a1.165 1.165 0 0 0 1.442-.787h0a1.165 1.165 0 0 0-.787-1.442L11.856 22h-.002l-.854.5m7.5-10v-2m11 2v-2m-3.5 1h0a1 1 0 0 0-1-1h-2a1 1 0 0 0-1 1v0a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1zM18.999 18h-1a2 2 0 1 0 0 4h1m10 0h1a2 2 0 1 0 0-4h-1m-15.683 5.333L16.203 25h-.008l.866-3.233M37 22.5l-.825-.5h-.002l-.627.184c-.613.18-.967.829-.787 1.442v0c.18.613.829.967 1.442.787L37 24.17m-6.033-2.403L31.834 25h-.008l2.887-1.667M27 30v7"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M21 30v7m2 2a2 2 0 1 0-4 0h4z"
  }), props.children);
});
var Robotics =
/*#__PURE__*/
React.forwardRef(function Robotics(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M28.224 30l-2.876-4.99c-.493-.854-.435-1.917.005-2.676.228-.394.557-.736.977-.978h0a2.685 2.685 0 0 1 3.654.981L34.401 30M37 30H24v5h13v-5zm-21.193-4.858l1.501-2.58a2.82 2.82 0 0 0-.955-3.86h0a2.82 2.82 0 0 0-3.86.955l-1.597 2.65 4.911 2.835zm-4.956 4.615l1.563-.463.002-.002.521-.96a1.95 1.95 0 0 0-.782-2.634h0a1.95 1.95 0 0 0-2.634.782L9 27.44l.463 1.563m3.9-5.264l-1.151 1.993M9 38.993L11.305 35H39v4H9v-.007zM34 9a4 4 0 1 0 0 8 4 4 0 0 0 0-8zm-14 1a3 3 0 1 0 0 6 3 3 0 0 0 0-6zm7 11.021l3.506-6.073M30.374 23l3.466-6.003m-18.407 1.352l2.102-3.64m-.369 4.736l2.049-3.549M22.827 12h7.301m-7.301 2h7.301"
  }), React.createElement("path", {
    d: "M20.5 13a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0zm13.5-.5a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1zm-6.5 11a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1z"
  }), props.children);
});
var Rome =
/*#__PURE__*/
React.forwardRef(function Rome(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M39 36H9"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M12 21h0c0-.55.45-1 1-1h0c.55 0 1 .45 1 1v0m-2 0v3m2-3v3m2-3h0c0-.55.45-1 1-1h0c.55 0 1 .45 1 1v0m-2 0v3m2-3v3m-6 3h0c0-.55.45-1 1-1h0c.55 0 1 .45 1 1v0m-2 0v3m2-3v3m2-3h0c0-.55.45-1 1-1h0c.55 0 1 .45 1 1v0m-2 0v3m2-3v3m2-3h0c0-.55.45-1 1-1h0c.55 0 1 .45 1 1v0m-2 0v3m2-3v3m2-3h0c0-.55.45-1 1-1h0c.55 0 1 .45 1 1v0m-2 0v3m2-3v3m-14 3h0c0-.55.45-1 1-1h0c.55 0 1 .45 1 1h0m-2 0v3m2-3v3m2-3h0c0-.55.45-1 1-1h0c.55 0 1 .45 1 1h0m-2 0v3m2-3v3m2-3h0c0-.55.45-1 1-1h0c.55 0 1 .45 1 1h0m-2 0v3m2-3v3m2-3h0c0-.55.45-1 1-1h0c.55 0 1 .45 1 1h0m-2 0v3m2-3v3m2-3h0c0-.55.45-1 1-1h0c.55 0 1 .45 1 1h0m-2 0v3m2-3v3m4 0v-3h0c0-.55.45-1 1-1h0c.55 0 1 .45 1 1h0m0 0v3m-2-9h0c0-.55.45-1 1-1h0c.55 0 1 .45 1 1v0m0 0v3h-2v-3m-4 0h0c0-.55.45-1 1-1h0c.55 0 1 .45 1 1v0m0 0v3h-2v-3"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M10 36V12h5l2 6"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M13 16v-2m-4 4h10l2 6M9 24h18l2 6m2-8v-2m-4 2v-2m8 2v-2"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M38 36V18H24v6"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M9 30h23l2 6"
  }), props.children);
});
var SaasEnablement =
/*#__PURE__*/
React.forwardRef(function SaasEnablement(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M14 11.5a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0zm-2.5 10a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5zM36.5 9a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5zm0 12.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5zM24 9a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5zM11.5 34a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5zm25 0a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5zM24 34a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5zm6-16H18v12h12V18zm-12 4h12m-10 4h8"
  }), React.createElement("circle", {
    cx: "28",
    cy: "20",
    r: ".5"
  }), props.children);
});
var SanFranciscoFog =
/*#__PURE__*/
React.forwardRef(function SanFranciscoFog(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M20 14h2v2h-2zm2 0h2v2h-2zm2 0h2v2h-2zm2 0h2v2h-2zm-6 8h2v2h-2zm2 0h2v2h-2zm2 0h2v2h-2zm2 0h2v2h-2zm-6 8h2v2h-2zm2 0h2v2h-2zm2 0h2v2h-2zm2 0h2v2h-2z"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M19 9v3m10-3v3"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M18 15v17.256M18 15v-3h2v21.082M30 15v-3h-2v22.555M30 15v15.725M18 15s-.006 9.406-7.125 15.567M30 15s.003 7.181 4.75 13.104"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M18 32.256a7.99 7.99 0 0 0-4.338.093c-.781-.783-1.737-1.378-2.788-1.782M20 33.082a7.943 7.943 0 0 0-2-.826m21-3.662A7.902 7.902 0 0 0 36 28c-.426 0-.842.04-1.25.104M30 30.725a7.98 7.98 0 0 0-1.873 3.898c-.04-.026-.085-.044-.127-.069m0 .001A3.945 3.945 0 0 0 26 34a3.99 3.99 0 0 0-3.263 1.698A8.061 8.061 0 0 0 20 33.082m-9.125-2.515c-.598-.23-1.218-.416-1.875-.498m25.75-1.965A7.96 7.96 0 0 0 30 30.726"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M16 32c-.697 0-1.392.098-2.069.279a7.92 7.92 0 0 0-1.927.8"
  }), props.children);
});
var SanFrancisco =
/*#__PURE__*/
React.forwardRef(function SanFrancisco(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M28 39V9m-8 30V9M9 28h30M9 30h30M20.028 14h8m-8-2h8m-8 10h8m-8-2h8m-8 14h8m-8 2h8m4-15.057V28m4-4.684V28m-20-7.057V28m-4-4.684V28M22 12v2m2-2v2m2-2v2m-4 6v2m2-2v2m2-2v2m-4 12v2m2-2v2m2-2v2"
  }), React.createElement("path", {
    d: "M36.12 22.977A11.655 11.655 0 0 1 28.36 12h-.72a12.38 12.38 0 0 0 8.24 11.656 12.33 12.33 0 0 0 3.12.662v-.721a11.588 11.588 0 0 1-2.88-.62zM19.64 12a11.655 11.655 0 0 1-7.76 10.977c-.931.329-1.896.537-2.88.62v.721a12.33 12.33 0 0 0 3.12-.662A12.38 12.38 0 0 0 20.36 12h-.72z"
  }), props.children);
});
var SaoPauloExpandedBase =
/*#__PURE__*/
React.forwardRef(function SaoPauloExpandedBase(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M22 9l2 7 2-7"
  }), React.createElement("path", {
    d: "M28.353 39c0-.031.003-.062-.006-.093l-4-15c-.084-.314-.611-.314-.695 0l-4 15c-.008.031-.006.062-.006.093h.726L24 25.397 27.628 39h.725z"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M36 32l-9-19m5 19l-6-15M12 32l9-19m2 7L20 9 9 32h30L28 9l-3 11M15 32l7-15"
  }), React.createElement("path", {
    d: "M30.354 39c0-.03.003-.061-.005-.092l-5-19a.364.364 0 0 0-.44-.257.36.36 0 0 0-.256.44L29.628 39h.726zm-7.262-19.349a.359.359 0 0 0-.44.257l-5 19c-.008.031-.005.062-.005.092h.726l4.976-18.908a.362.362 0 0 0-.257-.441z"
  }), props.children);
});
var SaoPaulo =
/*#__PURE__*/
React.forwardRef(function SaoPaulo(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M22 9l2 7 2-7"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M20 39l4-15 4 15"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M36 32l-9-19m5 19l-6-15M12 32l9-19"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M18 39l5-19-3-11L9 32h30L28 9l-3 11 5 19"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M15 32l7-15"
  }), props.children);
});
var SatelliteDish =
/*#__PURE__*/
React.forwardRef(function SatelliteDish(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M24 12.591a9.38 9.38 0 0 1 6.653 2.756A9.38 9.38 0 0 1 33.409 22m-3.426 0a5.963 5.963 0 0 0-1.752-4.23 5.963 5.963 0 0 0-4.23-1.752M37 22c0-3.332-1.271-6.663-3.813-9.205C30.639 10.247 27.738 9 24 9m-7.371 7.629a9 9 0 0 0 0 12.728 9 9 0 0 0 12.728 0L16.629 16.629zm9.932 2.81a1.5 1.5 0 1 0-2.121 2.12 1.5 1.5 0 0 0 2.121-2.12zm-3.569 3.554l1.414-1.414M11 39h16m-5 0a3 3 0 1 0-6 0"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M19 36v-3"
  }), props.children);
});
var Satellite =
/*#__PURE__*/
React.forwardRef(function Satellite(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M35.683 13.592l-5.134 2.961-.581 1.976 2.002.485 5.134-2.961-1.421-2.461zm-1.213.75l-3.075-5.343-2.461 1.421 3.075 5.343m-2.041 2.766a2.174 2.174 0 0 0-2.97-.796l2.174 3.766c1.04-.6 1.396-1.93.796-2.97zm-1.908 1.048l-1.059.611m6.459-1.975l3.074 5.315L39 22.107l-3.079-5.315M31 38c3.784-2.193 5.999-5.921 6-10"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M18.289 20.003l1.404 2.433a.776.776 0 0 1-.142.956l-2.398 2.212a.777.777 0 0 0-.143.955l3.648 6.335a.776.776 0 0 1-.14.953l-4.947 4.694m-1.82-.811l1.677-2.901a.776.776 0 0 0 0-.777l-.911-1.578a.776.776 0 0 1 .141-.954l1.379-1.297a.778.778 0 0 0 .141-.955l-1.029-1.782a.777.777 0 0 0-.673-.388h-2.505a.776.776 0 0 1-.672-.387l-1.081-1.862m15.66-1.273l-1.953 3.402a.775.775 0 0 0 0 .774l1.516 2.636a.776.776 0 0 0 .673.389h1.784M18.5 20C13.253 20 9 24.253 9 29.5s4.253 9.5 9.5 9.5 9.5-4.253 9.5-9.5-4.253-9.5-9.5-9.5zM17.293 9.293l1.414 1.414m-1.414 0l1.414-1.414m-9.414 6l1.414 1.414m-1.414 0l1.414-1.414"
  }), props.children);
});
var Scale =
/*#__PURE__*/
React.forwardRef(function Scale(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M19.066 22.093l-5.692-5.692C16.094 13.682 19.85 12 23.999 12s7.906 1.682 10.625 4.401l-5.692 5.692c-1.262-1.262-3.006-2.043-4.933-2.043s-3.67.781-4.933 2.043zM39 9H9v30h30V9zM24 20.056v-4M24 14v-2m5.501 3.208l1-1.732M18.5 15.212l-1-1.732"
  }), props.children);
});
var Seattle =
/*#__PURE__*/
React.forwardRef(function Seattle(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M24 9v5"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M22 30v9m2-9v9m2-9v9m2-9v9m-8-9v9"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M30 20l-2-2v-2h-8v2l-2 2"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M9 24h30"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M12 22h24v4H12zm11-8h2v2h-2z"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M18 26v2m2-2v2m2-2v2m2-2v2m2-2v2m2-2v2m2-2v2m-12-8v2"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M32 22v-2H16v2"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M20 20v2m2-2v2m2-2v2m2-2v2m2-2v2m2-2v2"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M16 26v2h16v-2m-14 2v2h12v-2"
  }), props.children);
});
var SecureData =
/*#__PURE__*/
React.forwardRef(function SecureData(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M24 14h14m-14 5h14m-14 5h14m-.59 5.001H24m10.7 5H24M10 9v16c0 7.7 6.3 14 14 14s14-6.3 14-14V9H10zm14 0v30"
  }), props.children);
});
var SecureProfile =
/*#__PURE__*/
React.forwardRef(function SecureProfile(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M31.5 30.499v2.916"
  }), React.createElement("circle", {
    cx: "31.5",
    cy: "30.5",
    r: "1"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M24 27v12h15V24H9V9h15v12.013M34.999 24L35 19.5a3.51 3.51 0 0 0-3.5-3.5h-.001A3.51 3.51 0 0 0 28 19.5V24m-7 0v-2.999c0-2.059-1.409-3.787-3.304-4.317a2.49 2.49 0 0 0 1.307-2.184 2.5 2.5 0 1 0-5 0 2.49 2.49 0 0 0 1.305 2.183C13.41 17.212 12 18.941 12 21.001V24"
  }), props.children);
});
var SecurityShield =
/*#__PURE__*/
React.forwardRef(function SecurityShield(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("defs", null), React.createElement("clipPath", {
    id: "b"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M23 14.457L35 21m-12-.586l12 6.543m-12-.5l11 5.998M23 32.5l7.611 4.149",
    clipPath: "url(#b)"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M24 9l-11 6v13c0 6 5 11 11 11s11-5 11-11V15L24 9z"
  }), props.children);
});
var Security =
/*#__PURE__*/
React.forwardRef(function Security(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M24 9l-11 6v13c0 6 5 11 11 11s11-5 11-11V15L24 9z"
  }), props.children);
});
var ServerRack =
/*#__PURE__*/
React.forwardRef(function ServerRack(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M35 39H13v-5h22v5zm-8-3h6m-18 0h1m1 0h1m1 0h1m15-7H13v5h22v-5zm-8 2h6m-18 0h1m1 0h1m1 0h1m15-7H13v5h22v-5zm-8 2h6m-18 0h1m1 0h1m1 0h1m15-7H13v5h22v-5zm-8 2h6m-18 0h1m1 0h1m1 0h1m15-7H13v5h22v-5zm-8 2h6m-18 0h1m1 0h1m1 0h1m15-7H13v5h22V9zm-8 2h6m-18 0h1m1 0h1m1 0h1"
  }), props.children);
});
var Servers =
/*#__PURE__*/
React.forwardRef(function Servers(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M31 39H17V9h14v30zM20 12h8m-8 3h8m-8 3h8m3 17h8V13h-8m0 3h4m-4 3h4m-4 3h4m-18-9H9v22h8m0-19h-4m4 3h-4m4 3h-4"
  }), props.children);
});
var Shop =
/*#__PURE__*/
React.forwardRef(function Shop(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M39 39H9"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M37 27v12M11 27v12m8-12h-5v12h5V27zm-4.986 6H19m15 3v-9H24v9h10zM9 9v10h30V9H9zm28 15V14H11v10"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M18 22a2 2 0 1 1-4 0m8 0a2 2 0 1 1-4 0m8 0a2 2 0 1 1-4 0m8 0a2 2 0 1 1-4 0m8 0a2 2 0 1 1-4 0m-16 0a2 2 0 0 1-2 2m24 0a2 2 0 0 1-2-2m-23 2h1m24 0h1"
  }), props.children);
});
var ShoppingCart =
/*#__PURE__*/
React.forwardRef(function ShoppingCart(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M17 14h22l-1.632 11.287C37.083 27 36.187 28 34.588 28H19.089c-1.809 0-2.795-1.424-3.368-3.685L12 9H9m4.719 7.018l3.214 13.438C17.5 32 18.434 33 20.319 33H37m-16.5 2a2 2 0 1 0-.001 3.999A2 2 0 0 0 20.5 35zM34 35a2 2 0 1 0-.001 3.999A2 2 0 0 0 34 35z"
  }), props.children);
});
var Shower =
/*#__PURE__*/
React.forwardRef(function Shower(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M39 24H23v-2h16v2zm-7-8h-2.001L23 22h16l-7-6zm0 0v-5a2 2 0 0 0-2-2H13a2 2 0 0 0-2 2v21m18.999-16L30 12a1 1 0 0 0-1-1H14a1 1 0 0 0-1 1v20m4 2H8m3 2v3m2-3v3"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M25 29v-3m0 6v-1m6-2v-3m0 6v-1m-3-4v-1m0 6v-3m0 6v-1m9-5v-3m0 6v-1m-3-4v-1m0 6v-3m0 6v-1"
  }), props.children);
});
var Singapore =
/*#__PURE__*/
React.forwardRef(function Singapore(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M33 24h2m-2 2h2m-2 2h2m-2 2h2m-2 2h2m2 4a2 2 0 0 1-2-2V24a4 4 0 0 1 4-4H29a4 4 0 0 1 4 4v10a2 2 0 0 1-2 2M13 24h2m-2 2h2m-2 2h2m-2 2h2m-2 2h2m2 4a2 2 0 0 1-2-2V24a4 4 0 0 1 4-4H9a4 4 0 0 1 4 4v10a2 2 0 0 1-2 2m3-27h20m-8 6v20m-2-23v27m-2-24v20m4-20a6 6 0 0 1 6-6M16 9a6 6 0 0 1 6 6m2-2a4 4 0 0 1 4-4m-4 4a4 4 0 0 0-4-4m6 7a2 2 0 1 1-4 0m4 4a2 2 0 1 1-4 0m4 4a2 2 0 1 1-4 0m4 4a2 2 0 1 1-4 0m4 4a2 2 0 1 1-4 0m0 3a4 4 0 0 1-4 4m8-4a4 4 0 0 0 4 4"
  }), props.children);
});
var SingleSignOn =
/*#__PURE__*/
React.forwardRef(function SingleSignOn(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("font", {
    horizAdvX: "1000"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M39 39H9M39 9H9v23h30V9z"
  }), React.createElement("text", {
    fontFamily: "IBMPlexSans",
    fontSize: "14",
    transform: "translate(13.304 23.996)"
  }), props.children);
});
var Slider =
/*#__PURE__*/
React.forwardRef(function Slider(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M18 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0zm15 9a3 3 0 1 0 0 6 3 3 0 0 0 0-6zm-9 12a3 3 0 1 0 0 6 3 3 0 0 0 0-6zM9 12h3m6 0h21m-3 12h3m-9 0H9m18 12h12m-18 0H9"
  }), props.children);
});
var Sneaker =
/*#__PURE__*/
React.forwardRef(function Sneaker(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M9 33.205h30m-12.692-8.456l-1.485 2.449m2.016 1.117l1.47-2.424m2 1.142l-1.455 2.399M16 21a3 3 0 1 0 0 6 3 3 0 0 0 0-6zM9 35h28.501v-.002c.831-.009 1.499-.83 1.499-1.844 0-.646-.27-1.213-.683-1.543l.001-.004L22 22.29V13.5L11 20l-2 7v8z"
  }), props.children);
});
var Snow =
/*#__PURE__*/
React.forwardRef(function Snow(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M18 32h2m-1-1v2m3-1h2m-1-1v2m3-1h2m-1-1v2m3-1h2m-1-1v2m-15 3h2m-1-1v2m3-1h2m-1-1v2m3-1h2m-1-1v2m3-1h2m-1-1v2m4.426-21c-.627 0-1.458.108-2.02.299C30.24 13.304 27.335 11 23.927 11c-4.177 0-7.606 3.537-7.992 7.613A4.639 4.639 0 0 0 13.631 18C11.058 18 9 20.086 9 22.658c0 2.573 2.058 4.309 4.631 4.342h19.795C36.504 26.967 39 24.652 39 21.574S36.504 16 33.426 16z"
  }), props.children);
});
var SoftIceCream =
/*#__PURE__*/
React.forwardRef(function SoftIceCream(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M28 16c1.875 0 3.125 1.113 3.125 2.5 0 1.25-.531 2.041-1.825 2.5M23 16h-3.25M20 32l1 7h6l1-7h-8zm-2-4l1 4h10l1-4M25 9c-3.562 1-5 2.5-5 4.5 0 .688.367 2.013 1 2.5m7 0a2.53 2.53 0 0 0 1-2c0-1.46-1.266-1.785-2.5-2.18-1-.32-1.5-1.157-1.5-2.82m-5 12h-.994C16.79 21 15 22.194 15 24.41S16.79 28 19.006 28h10.082C31.281 28 33 26.49 33 24.41c0-1.72-1.25-3.41-3.868-3.41h-3.913M19.5 16a2.5 2.5 0 1 0 0 5"
  }), props.children);
});
var SoftlayerEnablement =
/*#__PURE__*/
React.forwardRef(function SoftlayerEnablement(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M39 15H9V9h30v6zm0 6H9v6h30v-6zm0 12H9v6h30v-6z"
  }), props.children);
});
var Solve =
/*#__PURE__*/
React.forwardRef(function Solve(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("circle", {
    cx: "35.495",
    cy: "35.495",
    r: "3.5",
    fill: "none",
    stroke: "#000",
    strokeDasharray: "0.0198,1.9765",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: ".72"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M27.5 16h-7V9h7v7zM16 32H9v7h7v-7zm23-11.5h-7v7h7v-7zm-15 0a3.5 3.5 0 1 0 0 7 3.5 3.5 0 0 0 0-7zM12.5 9a3.5 3.5 0 1 0 0 7 3.5 3.5 0 0 0 0-7zM24 33l-3.5 6h7L24 33zM12.5 21L9 27h7l-3.5-6zm23-12L32 15h7l-3.5-6z"
  }), props.children);
});
var Spaceship =
/*#__PURE__*/
React.forwardRef(function Spaceship(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M30.208 22.044A2.834 2.834 0 1 1 25.3 19.21a2.834 2.834 0 0 1 4.908 2.834zm-3.227 16.06l4.01-2.312-2.662-4.61 3.571-4.978a16.52 16.52 0 0 0 3.1-9.632v-6.306a1.263 1.263 0 0 0-1.895-1.095l-5.463 3.154a16.524 16.524 0 0 0-6.792 7.498l-2.525 5.582H13v4.64"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M18.799 39c1.025-.518 2.341-1.241 2.782-2.004l.045-.078a2.815 2.815 0 0 0-4.875-2.815l-.045.078c-.44.763-.408 2.263-.344 3.41"
  }), props.children);
});
var SpeechAlphabetAExpanded =
/*#__PURE__*/
React.forwardRef(function SpeechAlphabetAExpanded(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    d: "M18.004 19.001l.774-.001-2.437-6.133h-.669l-2.439 6.134h.775l.653-1.641h2.691l.652 1.641zm-3.057-2.361l1.06-2.666 1.059 2.666h-2.119z"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M29.006 12h6m-3-1.502V12m-3 5c4.709 0 4.351-5 4.351-5m-2.933 1.5c.32 1.487 1.943 3.5 4.582 3.5m-1.012 22c0-4.625-3.145-8.505-7.409-9.648a5.501 5.501 0 1 0-5.182 0c-4.265 1.143-7.409 5.023-7.409 9.648M23 17v-4a2 2 0 0 0-2-2H11a2 2 0 0 0-2 2v7a2 2 0 0 0 2 2h3l2 4m16-2l2-4h3c1.1 0 2-.9 2-2v-7c0-1.1-.9-2-2-2H27c-1.1 0-2 .9-2 2v4"
  }), props.children);
});
var SpeechToText =
/*#__PURE__*/
React.forwardRef(function SpeechToText(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M24 20h12m-12-6h12M24 26h12m-15-3H11c-1.1 0-2 .9-2 2v8c0 1.1.9 2 2 2h4l2 4m-.001-4h6c1.1 0 2-.9 2-2v-2m-6.985-16.998h-4.015a2 2 0 0 0-2 2v4.5m3.187-3.672l2.828-2.828-2.828-2.828M39 9H21v22h18V9z"
  }), React.createElement("path", {
    d: "M18 29a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm-5-1a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm7.639.073A.995.995 0 0 0 20 29c0 .424.266.782.639.927v-1.854z"
  }), props.children);
});
var Speech =
/*#__PURE__*/
React.forwardRef(function Speech(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M29.006 12h6m-3-1.502V12m-3 5c4.709 0 4.351-5 4.351-5m-2.933 1.5c.32 1.487 1.943 3.5 4.582 3.5m-1.012 22c0-4.625-3.145-8.505-7.409-9.648a5.501 5.501 0 1 0-5.182 0c-4.265 1.143-7.409 5.023-7.409 9.648m4.397-20l-2.385-6-2.385 6m.739-2h3.271M23 17v-4a2 2 0 0 0-2-2H11a2 2 0 0 0-2 2v7a2 2 0 0 0 2 2h3l2 4m16-2l2-4h3c1.1 0 2-.9 2-2v-7c0-1.1-.9-2-2-2H27c-1.1 0-2 .9-2 2v4"
  }), props.children);
});
var Speedometer =
/*#__PURE__*/
React.forwardRef(function Speedometer(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M24 12v5m-7.5-2.99l2.5 4.33M15.34 22l-4.33-2.5M9 27h5m-2.99 7.5l4.33-2.5m17.32 0l4.33 2.5M39 27h-5m3-7.5L24 27m7.5-12.99L29 18.34"
  }), props.children);
});
var StairsPlanView =
/*#__PURE__*/
React.forwardRef(function StairsPlanView(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M24 10v28m0-26H10v20h28m-14 4h14V16H10m28 4H10m28 4H10m28 4H10"
  }), props.children);
});
var StationaryBicycle =
/*#__PURE__*/
React.forwardRef(function StationaryBicycle(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M20.464 33L17 27"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M8 39h32m-10 0v-3m-12 0v3m4.655-19.704A8.951 8.951 0 0 0 18 18c-4.971 0-9 4.029-9 9s4.029 9 9 9m-1-12a3 3 0 1 0 0 6 3 3 0 0 0 0-6zm1 9h5m-7-14.944L13.658 14m14.311 8.718L33.58 13M29 13h6c2.2 0 4-1.8 4-4v0m-1.999 19.536l-14.346-9.24M18 36h17m0 0a4 4 0 0 0 2.001-7.464M11 12h7m0 2h-7m0-2a1 1 0 0 0 0 2m7 0a1 1 0 0 0 0-2"
  }), props.children);
});
var Steel =
/*#__PURE__*/
React.forwardRef(function Steel(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M39 39H9v-2h30v2zm0-6H9v2h30v-2zm-1 2H10v2h28v-2zm-5-2l-9-9-9 9m9-24v10a3 3 0 1 0 3 3"
  }), props.children);
});
var SteeringWheel =
/*#__PURE__*/
React.forwardRef(function SteeringWheel(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M39 24c0 8.284-6.716 15-15 15S9 32.284 9 24 15.716 9 24 9s15 6.716 15 15zM24 12c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm0 8a4 4 0 1 0 0 8 4 4 0 0 0 0-8zm12 4h-8m-8 0h-8m12 4v8"
  }), props.children);
});
var Stethoscope =
/*#__PURE__*/
React.forwardRef(function Stethoscope(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("circle", {
    cx: "13",
    cy: "24",
    r: ".5"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M15 24a2 2 0 1 1-3.999.001A2 2 0 0 1 15 24zm-2 2v5a8 8 0 0 0 16 0v-3M24 9h-3v11a8 8 0 0 0 16 0V9h-3"
  }), props.children);
});
var StrategyDirect =
/*#__PURE__*/
React.forwardRef(function StrategyDirect(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M35 39H13v-6h22v6zM29 9v2h-3V9h-4v2h-3V9h-4v8h18V9h-4zm2 8l1 16M17 17l-1 16m8-9h7.5M27 20h4m-2 8h3m-16 2h4"
  }), props.children);
});
var StrategyMove =
/*#__PURE__*/
React.forwardRef(function StrategyMove(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M32 19h-3m3 4h-3m3 4h-3m0 6l3-4v-9.432c0-4.06-1.744-5.877-3.369-7.502L24 9l-.001 3.75h-2.5l-7.5 6.25 1.25 2.5L24 20l-6 9 2 4m-.75 0A4.25 4.25 0 0 0 15 37.25V39h19v-1.75A4.25 4.25 0 0 0 29.75 33h-10.5z"
  }), props.children);
});
var StrategyPlay =
/*#__PURE__*/
React.forwardRef(function StrategyPlay(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M36.998 29a2 2 0 1 1-3.999.001A2 2 0 0 1 36.998 29zm-9-2a2 2 0 1 0-.001 3.999A2 2 0 0 0 27.998 27zm0 7a2 2 0 1 0-.001 3.999A2 2 0 0 0 27.998 34zm-7-7a2 2 0 1 0-.001 3.999A2 2 0 0 0 20.998 27zm4.888-7l4.112 4m-4 0l4-4M18.886 10l4.112 4m-4 0l4-4m9.888 7l4.112 4m-4 0l4-4m-24-4v18c0 5 4.997 5.005 4.997 5.005H24M14.998 15l-2-2-1.996 1.996M33.998 12l-2-2-1.996 1.996M31.986 10v3c0 3-2.988 3-2.988 3h-4c-4 0-4 4-4 4v5"
  }), props.children);
});
var Strategy =
/*#__PURE__*/
React.forwardRef(function Strategy(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M11 19h8M9 31h12m-9-10v5l-3 8 1 2h4.941-.023H20l1-2-3-8v-5m-8 15v3m10-3v3m-7-28h4V9h-4v2zm0 2h4m1 4v-2l1-2-1-2h-6l-1 2 1 2v2m13.999 6H28m-2.001 3H28m-2.001 3H28m7 5.126l1-3.128L32 24l6 1 1-2-6-5h-2v-3l-2.905 2.453c-1.3 1.3-2.095 2.754-2.095 6.002v7.548l1 3.123M8 39h32m-2 0v-1.001c0-2.2-1.8-4-4-4h-6c-2.2 0-4 1.8-4 4V39"
  }), props.children);
});
var Streamline =
/*#__PURE__*/
React.forwardRef(function Streamline(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M39 24h-7.5a2.5 2.5 0 0 0-2.5 2.5v1a2.5 2.5 0 1 1-5 0v-7a2.5 2.5 0 1 0-5 0v11a2.5 2.5 0 1 1-5 0v-15a2.5 2.5 0 1 0-5 0V19m27 8l3-3-3-3"
  }), props.children);
});
var SunnyHazy =
/*#__PURE__*/
React.forwardRef(function SunnyHazy(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M18 28h15m-10-4h15m-15 8h15m-17 4h12m-23-4h7m7-12a4 4 0 1 0-4 4"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M20 14v-2m-4.243 3.757l-1.414-1.414M14 20h-2m14 0h2m-3.757-4.243l1.414-1.414"
  }), props.children);
});
var Sunny =
/*#__PURE__*/
React.forwardRef(function Sunny(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M31 24a7 7 0 1 1-14 0 7 7 0 0 1 14 0zm-7-10v-3m-7.071 5.929l-2.121-2.121M11 24h3m2.929 7.071l-2.121 2.121M24 34v3m7.071-5.929l2.121 2.121M34 24h3m-5.929-7.071l2.121-2.121"
  }), props.children);
});
var SupportServices =
/*#__PURE__*/
React.forwardRef(function SupportServices(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M27 27h-6v-6h6v6zM17 17v-.501c0-1.827-1.232-3.35-2.905-3.829.544-.357.905-.971.905-1.67a2 2 0 1 0-3.096 1.671C10.232 13.149 9 14.673 9 16.499V17m20 7h4.5a5.5 5.5 0 1 0 0-11H19m0 11h-4.5a5.5 5.5 0 1 0 0 11H29m10 4v-.501c0-1.827-1.232-3.35-2.905-3.829.544-.357.905-.971.905-1.67a2 2 0 1 0-3.096 1.671C32.232 35.149 31 36.673 31 38.499V39"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M26 38l3-3.01L26 32"
  }), props.children);
});
var SwipeLeft =
/*#__PURE__*/
React.forwardRef(function SwipeLeft(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M20 15H9m3-3l-3 3 3 3"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M24 15c0-1.186.821-2 2-2h-.003c1.179 0 2.003.814 2.003 2v8h6.913C37.163 23 39 24.541 39 26.776v4.01C39 35.478 37.706 39 30.769 39c-4.829 0-7.104-2.056-10.134-5.48a414.73 414.73 0 0 0-3.439-3.765c-.831-.936-2.196-2.34-2.196-2.77 0-1.299 3.219-2.011 4.792-.803C21.008 27.116 24 30.5 24 30.5V15zm6.006 4.46c1.23-1.09 2-2.69 2-4.46 0-3.31-2.69-6-6-6s-6 2.69-6 6c0 1.77.77 3.37 2 4.46"
  }), props.children);
});
var SwipeRight =
/*#__PURE__*/
React.forwardRef(function SwipeRight(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M38 15H27m8 3l3-3-3-3"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M19 15c0-1.186.821-2 2-2h-.003c1.179 0 2.003.814 2.003 2v8h6.913C32.162 23 34 24.541 34 26.776v4.01C34 35.478 32.706 39 25.769 39c-4.829 0-7.104-2.056-10.134-5.48a414.73 414.73 0 0 0-3.439-3.765c-.831-.936-2.196-2.34-2.196-2.77 0-1.299 3.219-2.011 4.792-.803C16.008 27.116 19 30.5 19 30.5V15zm5.994 4.46c1.23-1.09 2-2.69 2-4.46 0-3.31-2.69-6-6-6s-6 2.69-6 6c0 1.77.77 3.37 2 4.46"
  }), props.children);
});
var Tags =
/*#__PURE__*/
React.forwardRef(function Tags(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M33.285 25.131L22.285 36 9 22.872v-7.248L12.666 12H20l13.285 13.131zm-8.182 8.087L27.921 36 39 25.131 25.636 12H20m-3.685 4.849a1.719 1.719 0 0 0-2.409 0 1.67 1.67 0 0 0 0 2.381 1.719 1.719 0 0 0 2.409 0 1.672 1.672 0 0 0 0-2.381z"
  }), props.children);
});
var TargetArea =
/*#__PURE__*/
React.forwardRef(function TargetArea(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("ellipse", {
    cx: "24",
    cy: "24",
    rx: "1",
    ry: "1",
    transform: "translate(-.026 .026)"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M14 24c0-5.523 4.477-10 10-10s10 4.477 10 10-4.477 10-10 10-10-4.477-10-10zm10 5a5 5 0 1 0-.001-10.001A5 5 0 0 0 24 29zm15 10V9H14M9 9v30h25"
  }), props.children);
});
var Target =
/*#__PURE__*/
React.forwardRef(function Target(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M9 24c0-8.284 6.716-15 15-15 8.284 0 15 6.716 15 15 0 8.284-6.716 15-15 15-8.285 0-15-6.716-15-15zm15 10c5.523 0 10-4.477 10-10s-4.477-10-10-10-10 4.477-10 10 4.477 10 10 10zm0-5a5 5 0 1 0-.001-10.001A5 5 0 0 0 24 29z"
  }), React.createElement("ellipse", {
    cx: "24",
    cy: "24",
    rx: "1",
    ry: "1",
    transform: "translate(-.026 .026)"
  }), props.children);
});
var TelAviv =
/*#__PURE__*/
React.forwardRef(function TelAviv(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M25 20v8m2-8v8m2-8v8m2-8v8m2-8v8m2-8v8m2-8v8m2-8v8m-16-8v8m-2-8v8m-2-8v8m-2-8v8m-2-8v8m-2-8v8m-2-8v8m-2-8v8m15 1v5m2-5v5m2-5v5m2-5v5m2-5v5m2-5v5m2-5v5m-14-5v5m-2-5v5m-2-5v5m-2-5v5m-2-5v5m-2-5v5m12-20v5m2-5v5m2-5v5m2-5v5m2-5v5m2-5v5m2-5v5m-14-5v5m-2-5v5m-2-5v5m-2-5v5m-2-5v5m-2-5v5m15 16v3m2-3v3m2-3v3m-6-3v3m-2-3v3m-2-3v3m-2-3v3m-2-3v3m10-28v3m2-3v3m2-3v3m-6-3v3m-2-3v3m-2-3v3m-2-3v3m-2-3v3"
  }), props.children);
});
var Telecom =
/*#__PURE__*/
React.forwardRef(function Telecom(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M26 18a2 2 0 1 1-3.999.001A2 2 0 0 1 26 18zm-6.243-4.243A5.985 5.985 0 0 0 18 18c0 1.657.672 3.157 1.757 4.243m8.486 0A5.985 5.985 0 0 0 30 18a5.985 5.985 0 0 0-1.757-4.243m-10.607-2.121A8.972 8.972 0 0 0 15 18a8.972 8.972 0 0 0 2.636 6.364m12.728 0A8.972 8.972 0 0 0 33 18a8.972 8.972 0 0 0-2.636-6.364M15.515 9.515A11.959 11.959 0 0 0 12 18a11.96 11.96 0 0 0 3.53 8.5m16.955-.015A11.959 11.959 0 0 0 36 18c0-3.314-1.343-6.314-3.515-8.485M11 39h26M23.062 19.769L17.91 39m12.18 0l-5.153-19.233M20.324 30h7.358m-8.7 5H29.02m-7.358-10h4.678"
  }), props.children);
});
var Telephone =
/*#__PURE__*/
React.forwardRef(function Telephone(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M20 15h19v24H9V15h3m24 3H23v10h13V18zM20 35V13c0-1.1-.9-2-2-2h-4c-1.1 0-2 .9-2 2v22c0 1.1.9 2 2 2h4c1.1 0 2-.9 2-2zm10-4h6m1-16V9"
  }), props.children);
});
var Television =
/*#__PURE__*/
React.forwardRef(function Television(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M39 39H9V17h30v22zm-6-20H11v18h22V19zm3 0a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm0 4a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm-13-6l-7-4m7 4l7-7"
  }), props.children);
});
var TemperatureHigh =
/*#__PURE__*/
React.forwardRef(function TemperatureHigh(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M26 11h8m-8 3h4m-4 3h8m-8 3h4m-4 3h8m-8 3h4m-8 1.349V9h-4v18.349A5.997 5.997 0 0 0 20 39a5.996 5.996 0 1 0 2-11.651zM18 14h4"
  }), props.children);
});
var TemperatureLow =
/*#__PURE__*/
React.forwardRef(function TemperatureLow(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M30 11h8m-8 3h4m-4 3h8m-8 3h4m-4 3h8m-8 3h4m-12-6h4m0 7.349V9h-4v18.349A5.997 5.997 0 0 0 24 39a5.996 5.996 0 1 0 2-11.651z"
  }), props.children);
});
var Tennis =
/*#__PURE__*/
React.forwardRef(function Tennis(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M25.998 14.498l-7.59 7.59m9.59-5.59l-3.747 3.747"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M30.245 23.768c.005 2.538-.092 4.996 2.109 7.197l6.022 6.022c.22.22.168.628-.116.913l-.847.847c-.284.284-.693.336-.913.116l-6.022-6.022-.001-.001c-2.201-2.201-4.659-2.104-7.197-2.109m9.109.27l-1.876 1.876m-6.001-21.415c-4.074-2.316-9.098-1.944-12.29 1.247-3.905 3.905-3.589 10.553.707 14.849s10.944 4.612 14.849.707c2.441-2.441 3.232-5.953 2.434-9.293m-1.833-9.093a3 3 0 1 0 4.241 4.243 3 3 0 0 0-4.241-4.243zm1.955-.874c-.045.822.246 1.66.874 2.288a2.99 2.99 0 0 0 2.285.874m-2.842 2.829a2.992 2.992 0 0 0-.875-2.272 2.992 2.992 0 0 0-2.272-.875"
  }), props.children);
});
var TestTubes =
/*#__PURE__*/
React.forwardRef(function TestTubes(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M24 39h0c-1.65 0-3-1.35-3-3V9h6v27c0 1.65-1.35 3-3 3zm-7-3V9h-6v27c0 1.65 1.35 3 3 3h0c1.65 0 3-1.35 3-3zm20 0V9h-6v27c0 1.65 1.35 3 3 3h0c1.65 0 3-1.35 3-3zM10 9h8m-7 16h6m4 6h6m4-10h6M20 9h8M9 14h30m-9-5h8"
  }), props.children);
});
var TextToSpeech =
/*#__PURE__*/
React.forwardRef(function TextToSpeech(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    d: "M20 25.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm3-1a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm-8 0a1 1 0 1 0 0 2 1 1 0 0 0 0-2z"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M29 16h8m-8-3h8m0 6.003L29 19m-8 14h6c1.1 0 2-.9 2-2V20c0-1.1-.9-2-2-2H11c-1.1 0-2 .9-2 2v11c0 1.1.9 2 2 2h6l4 6m8-16h10V9H27v9m4 15h4.001A2 2 0 0 0 37 31v-4m-3.172 3.171L31 33l2.828 2.828"
  }), props.children);
});
var TimeLapse =
/*#__PURE__*/
React.forwardRef(function TimeLapse(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M17.072 28L24 24V13"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M39 36h-6v-6m.001 6.001A14.978 14.978 0 0 0 39 24c0-8.284-6.716-15-15-15S9 15.716 9 24s6.716 15 15 15"
  }), props.children);
});
var Time =
/*#__PURE__*/
React.forwardRef(function Time(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M39 24c0 8.284-6.716 15-15 15S9 32.284 9 24 15.716 9 24 9s15 6.716 15 15zM24 12V9M12 24H9m15 15v-3m12-12h3M24 14v10l6.928 4"
  }), props.children);
});
var Toggle =
/*#__PURE__*/
React.forwardRef(function Toggle(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M33 21H15c-3.3 0-6-2.7-6-6v0c0-3.3 2.7-6 6-6h18c3.3 0 6 2.7 6 6v0c0 3.3-2.7 6-6 6zm6 12h0c0-3.3-2.7-6-6-6H15c-3.3 0-6 2.7-6 6v0c0 3.3 2.7 6 6 6h18c3.3 0 6-2.7 6-6zM15 12a3 3 0 1 0 0 6 3 3 0 0 0 0-6zm18 18a3 3 0 1 0 0 6 3 3 0 0 0 0-6z"
  }), props.children);
});
var TokyoCherryBlossom =
/*#__PURE__*/
React.forwardRef(function TokyoCherryBlossom(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M24 17.406v7.405m0 0l-7.043-2.288m2.69 8.28L24 24.811m0 0l4.353 5.992m2.69-8.28L24 24.811m0 4.232v-4.232m0 0l-4.025 1.308m1.538-4.731L24 24.811m0 0l2.487-3.423m1.538 4.731L24 24.811"
  }), React.createElement("circle", {
    cx: "24",
    cy: "30.101",
    r: "1.058",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72"
  }), React.createElement("circle", {
    cx: "20.891",
    cy: "20.532",
    r: "1.058",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72"
  }), React.createElement("circle", {
    cx: "29.031",
    cy: "26.446",
    r: "1.058",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72"
  }), React.createElement("circle", {
    cx: "18.969",
    cy: "26.446",
    r: "1.058",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72"
  }), React.createElement("circle", {
    cx: "27.109",
    cy: "20.532",
    r: "1.058",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M38.086 20.234a6.315 6.315 0 0 0-2.321-3.177 6.352 6.352 0 0 0-3.739-1.208 6.365 6.365 0 0 0-1.698.252 6.387 6.387 0 0 0-.3-1.737 6.356 6.356 0 0 0-2.312-3.156 6.322 6.322 0 0 0-7.432.001 6.356 6.356 0 0 0-2.312 3.156 6.35 6.35 0 0 0-.3 1.737 6.352 6.352 0 0 0-1.745-.251 6.36 6.36 0 0 0-3.716 1.223 6.316 6.316 0 0 0-2.297 7.067 6.354 6.354 0 0 0 2.287 3.174c.466.341.993.613 1.56.822a6.352 6.352 0 0 0-.778 1.582 6.36 6.36 0 0 0 .015 3.912 6.316 6.316 0 0 0 6.013 4.368 6.349 6.349 0 0 0 3.725-1.195c.469-.338.89-.755 1.264-1.229.364.461.772.87 1.226 1.203a6.347 6.347 0 0 0 3.735 1.22 6.313 6.313 0 0 0 6.05-4.396 6.355 6.355 0 0 0-.006-3.929 6.358 6.358 0 0 0-.765-1.537 6.394 6.394 0 0 0 1.522-.794 6.362 6.362 0 0 0 2.315-3.175 6.314 6.314 0 0 0 .009-3.933z"
  }), React.createElement("circle", {
    cx: "24",
    cy: "16.348",
    r: "1.058",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72"
  }), React.createElement("circle", {
    cx: "15.951",
    cy: "22.196",
    r: "1.058",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72"
  }), React.createElement("circle", {
    cx: "19.025",
    cy: "31.658",
    r: "1.058",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72"
  }), React.createElement("circle", {
    cx: "28.975",
    cy: "31.658",
    r: "1.058",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72"
  }), React.createElement("circle", {
    cx: "32.049",
    cy: "22.196",
    r: "1.058",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M24 10v2.116M9.914 20.234l2.012.654m3.368 15.906l1.244-1.712m16.168 1.712l-1.244-1.712m6.624-14.848l-2.012.654"
  }), props.children);
});
var TokyoGates =
/*#__PURE__*/
React.forwardRef(function TokyoGates(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M14 20h20m-20-2h20"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M12 12l2 4h20l2-4"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M9 10l7 4h16l7-4"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M24 20v-4m-6 8v-8m12 8v-8"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M12 38h24m-24-2h4V26l-2-2h6v12h8V24h6l-2 2v10h4"
  }), props.children);
});
var TokyoTemple =
/*#__PURE__*/
React.forwardRef(function TokyoTemple(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M24 9v3"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M20 19h8m2-4H18l6-3zm-14 6a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2m2 6a2 2 0 0 1-2 2H16a2 2 0 0 1-2-2"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M9 39h30m-9-26v2a2 2 0 0 1-2 2h-8a2 2 0 0 1-2-2v-2"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M24 19v2m2-2v2m2-4v4m-6-2v2m-2-4v4m-2 4h12m-6 0v2m2-2v2m2-2v2m2-4v4m-8-2v2m-2-2v2m-2-4v4m-2 4h16m-10 0v2m2-2v2m2-2v2m2-2v2m2-2v2m2-4v4m-12-2v2m-2-2v2m-2-4v4m6 4v2m2-2v2m2-2v2m2-2v2m2-2v2"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M14 39v-2h20v2"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M32 35v4m-12-2v2m-2-2v2m-2-4v4"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M14 26v1h20v-1m-22 6v1h24v-1M16 20v1h16v-1"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M36 33a2 2 0 0 1-2 2H14a2 2 0 0 1-2-2"
  }), props.children);
});
var TokyoVolcano =
/*#__PURE__*/
React.forwardRef(function TokyoVolcano(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M16 37h5.667m4.666 0H32m-11-4h5.667M14 35h20"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M30 24l-2 1-2-1-2 1-2-1-2 1-2-1"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M18 33h-8l11.317-12.58c.222-.266.55-.42.896-.42h3.574c.346 0 .675.154.896.42L38 33h-9"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M16.423 25.859A9 9 0 0 1 24 12a9 9 0 0 1 7.577 13.859"
  }), props.children);
});
var ToneAnalyzer =
/*#__PURE__*/
React.forwardRef(function ToneAnalyzer(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    d: "M22.5 23.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0zM15 23a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1zm19-10.5a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1zm-6 0a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1z"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M19 39l-4-6h-4c-1.1 0-2-.9-2-2V21c0-1.1.9-2 2-2h15c1.1 0 2 .9 2 2v10c0 1.1-.9 2-2 2h-7m13-8l2-4h3c1.1 0 2-.9 2-2v-8c0-1.1-.9-2-2-2H25c-1.1 0-2 .9-2 2v7.999M31 21h-3.009M15 25.5a3.5 3.5 0 1 0 7 0M34 18a3 3 0 1 0-6 0"
  }), props.children);
});
var Tools =
/*#__PURE__*/
React.forwardRef(function Tools(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M25.732 18.889l9.311-9.311a2.386 2.386 0 0 1 3.375 0h0a2.386 2.386 0 0 1 0 3.375l-9.311 9.311m-1.688-1.688l9.282-9.282M13.069 34.926l7.731-7.731M9.115 37.137l1.743 1.743 3.228-2.936-2.035-2.035-2.936 3.228zm18.38-6.106a6.002 6.002 0 0 0 8.213 7.506h0l-4.001-4.001a2.005 2.005 0 0 1 0-2.828h0a2.005 2.005 0 0 1 2.828 0l4.001 4.001h0a6.004 6.004 0 0 0-7.506-8.213L20.505 16.971a6.004 6.004 0 0 0-8.213-7.507h0l4.001 4.001a2.005 2.005 0 0 1 0 2.828h0a2.005 2.005 0 0 1-2.828 0l-4.001-4.001h0a6.004 6.004 0 0 0 7.504 8.214l10.527 10.525z"
  }), props.children);
});
var Tornado =
/*#__PURE__*/
React.forwardRef(function Tornado(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M14.5 10h20m-23 4h20m-15 4h17m-14 4h17m-19 4h12m-8 4h12m-10 4h8m-10 4h4"
  }), props.children);
});
var Toronto =
/*#__PURE__*/
React.forwardRef(function Toronto(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M34 38c-.724 0-1.448-.333-2-1-.552.667-1.276 1-2 1s-1.448-.333-2-1c-.552.667-1.276 1-2 1s-1.448-.333-2-1c-.552.667-1.276 1-2 1s-1.448-.333-2-1c-.552.667-1.276 1-2 1s-1.448-.333-2-1c-.552.667-1.276 1-2 1m7-18h6l-1-2h-4zm0 0h6l-1 2h-4zm1 18l1-14m2 0l1 14m0-16a1 1 0 0 1 0 2h-4a1 1 0 0 1 0-2m1-8h2v4h-2zm1-4v4m-5.5-1.5l1 1m0-1l-1 1M13 18l1 1m0-1l-1 1m21-1l1 1m0-1l-1 1"
  }), props.children);
});
var TouchGesture =
/*#__PURE__*/
React.forwardRef(function TouchGesture(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M25 36V24.5a1.5 1.5 0 0 1 3 0V35m0-3.5a1.5 1.5 0 0 1 3 0V35m0-3a1.5 1.5 0 0 1 3 0v3"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M20 33H9V10h30v20m-5 3a1.5 1.5 0 0 1 3 0v5m-15 0v-2.5a1.5 1.5 0 0 1 3 0V38"
  }), props.children);
});
var TouchId =
/*#__PURE__*/
React.forwardRef(function TouchId(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M13.259 13.519C16.091 10.621 19.867 8.986 24.132 9c4.049.014 7.858 1.725 10.641 4.568m.442 4.637a13.446 13.446 0 0 0-11.247-6.064c-6.242 0-9.831 3.838-12.237 7.491m23.334 13.793c-1.964-.854-2.46-2.007-2.46-4.1 0-2.648.649-2.517.649-5.828 0-3.84-3.382-8.33-9.286-8.33-4.345 0-6.425 2.169-8.167 4.341-1.064 1.327-2.698 3.926-4.802 4.778m22.174 11.573c-2.725-1.071-3.744-3.228-3.744-5.611 0-1.811.786-3.416.786-5.951 0-2.774-2.357-6.091-6.246-6.091-3.018 0-5.132 2.045-6.376 4.15-1.45 2.454-3.801 5.025-6.593 6.056m5.515 8.597c2.979-1.976 5.252-3.817 7.454-5.924 1.808-1.73 3.342-3.98 3.342-6.269 0-1.708-1.196-3.553-3.342-3.553-2.859 0-4.486 4.567-6.487 6.523-1.841 1.799-3.74 2.872-5.937 4.029m2.278 3.21c3.95-2.431 7.973-5.819 10.166-9.936M25.304 39c-.126-1.404-1.04-2.807-2.674-2.807-1.469 0-2.336.828-3.196 2.102m7.193-6.753c-.241.607-.342 1.336-.342 1.883 0 1.611.97 3.422 2.943 4.63m6.247-7.632C36.509 29.01 37 26.703 37 24.628c0-1.332-.13-2.682-.835-4.185"
  }), props.children);
});
var TouchScreen =
/*#__PURE__*/
React.forwardRef(function TouchScreen(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M15 29H9V10h25v19h-7m7-3h-7m-12 0H9m21 3v8h9V21h-5m-4 13h9m-18.002-6.379c0-.573-.447-1.037-.998-1.037s-.998.464-.998 1.037v2.378l-.005-6.962c0-.573-.447-1.037-.998-1.037S17 22.464 17 23.037v10.806C17 36.139 18.792 38 21.002 38S25 36.121 25 33.842v-5.04c0-.573-.447-1.037-.998-1.037s-.998.464-.998 1.037v1.196l-.005-1.935c0-.573-.447-1.037-.998-1.037s-1.002.464-1.002 1.037l.004 1.935-.005-2.377z"
  }), props.children);
});
var TouchSwipe =
/*#__PURE__*/
React.forwardRef(function TouchSwipe(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M11 21h4m-2-2l-2 2 2 2m12-2h-4m2 2l2-2-2-2"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M15 29H9V10h25v19h-7m7-3h-7m-12 0H9m21 3v8h9V21h-5m-4 13h9m-18.002-6.379c0-.573-.447-1.037-.998-1.037s-.998.464-.998 1.037v2.378l-.005-6.962c0-.573-.447-1.037-.998-1.037S17 22.464 17 23.037v10.806C17 36.139 18.792 38 21.002 38S25 36.121 25 33.842v-5.04c0-.573-.447-1.037-.998-1.037s-.998.464-.998 1.037v1.196l-.005-1.935c0-.573-.447-1.037-.998-1.037s-1.002.464-1.002 1.037l.004 1.935-.005-2.377z"
  }), props.children);
});
var Touch =
/*#__PURE__*/
React.forwardRef(function Touch(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M21 15c0-1.186.821-2 2-2h-.003c1.179 0 2.003.814 2.003 2v8h6.913C34.162 23 36 24.541 36 26.776v4.01C36 35.478 34.706 39 27.769 39c-4.829 0-7.104-2.056-10.134-5.48a414.73 414.73 0 0 0-3.439-3.765c-.831-.936-2.196-2.34-2.196-2.77 0-1.299 3.219-2.011 4.792-.803C18.008 27.116 21 30.5 21 30.5V15zm5.994 4.46c1.23-1.09 2-2.69 2-4.46 0-3.31-2.69-6-6-6s-6 2.69-6 6c0 1.77.77 3.37 2 4.46"
  }), props.children);
});
var Tractor =
/*#__PURE__*/
React.forwardRef(function Tractor(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M19 34a5 5 0 1 1-10.001-.001A5 5 0 0 1 19 34zm2 0a7 7 0 0 0-12-4.899M14 31a3 3 0 1 0 0 6 3 3 0 0 0 0-6zm18-4a5 5 0 1 0 .001 10.001A5 5 0 0 0 32 27zm0-2a7 7 0 1 0 0 14 7 7 0 0 0 0-14zm5 2.103V22H11v5.675M19 34h6.291M21 34V22m16-10H21v2h16v-2zM21 22l2.144-8M37 22l-.889-8m-2 0L35 22m-6 3.676V14m-4-2V9M13 22v-4h-2"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M13 24h6m4 0h2"
  }), props.children);
});
var TradeoffAnalytics =
/*#__PURE__*/
React.forwardRef(function TradeoffAnalytics(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M8 24h32M19 38h10m-5-14v14m9-26a5 5 0 1 0 .001 10.001A5 5 0 0 0 33 12zm-21 6a2 2 0 1 0-.001 3.999A2 2 0 0 0 12 18zm8 0a2 2 0 1 0-.001 3.999A2 2 0 0 0 20 18zm-4-6a2 2 0 1 0-.001 3.999A2 2 0 0 0 16 12z"
  }), props.children);
});
var Train =
/*#__PURE__*/
React.forwardRef(function Train(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M34 31H14V17a6 6 0 0 1 6-6h8a6 6 0 0 1 6 6v14zm-2-14a4 4 0 0 0-4-4h-8a4 4 0 0 0-4 4v6h16v-6zm-14.5 8a1.5 1.5 0 1 0 .001 3.001A1.5 1.5 0 0 0 17.5 25zm13 0a1.5 1.5 0 1 0 .001 3.001A1.5 1.5 0 0 0 30.5 25zM19 9h10M14 39l3.423-6M34 39l-3.423-6"
  }), props.children);
});
var Transform =
/*#__PURE__*/
React.forwardRef(function Transform(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M28 13l-6 4V9l6 4zM13 31a4 4 0 1 0 0 8 4 4 0 0 0 0-8zm26-6h-8v14h8V25zM17 35h11m7-10V13h-4m-9 0h-9v15.5"
  }), props.children);
});
var Trash =
/*#__PURE__*/
React.forwardRef(function Trash(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M34 39H14V13h20v26zM10 13h28m-9-4H19v4h10V9z"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M24 35V17m5 18V17M19 35V17"
  }), props.children);
});
var University =
/*#__PURE__*/
React.forwardRef(function University(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M39 39H9v-3h30v3zM9 18h30L24 9 9 18zm28 15H11v3h26v-3zm-11-9h-4v6h4v-6zm9 0h-4v6h4v-6zm-18 0h-4v6h4v-6zm-6-3h26m-13-9.5a2 2 0 1 0-.001 3.999A2 2 0 0 0 24 11.5z"
  }), props.children);
});
var UnlockAlt =
/*#__PURE__*/
React.forwardRef(function UnlockAlt(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("circle", {
    cx: "24",
    cy: "29.5",
    r: "1.5"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M24 29.5V33"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".711",
    d: "M14 21h20v18H14z"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M29 14a5 5 0 0 0-10 0v7"
  }), props.children);
});
var Unlock =
/*#__PURE__*/
React.forwardRef(function Unlock(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M29 14a5 5 0 0 0-10 0v6.338"
  }), React.createElement("circle", {
    cx: "24",
    cy: "28.5",
    r: "1.5"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M34 29c0 5.523-4.477 10-10 10s-10-4.477-10-10 4.477-10 10-10 10 4.477 10 10zm-10-.5V32"
  }), props.children);
});
var UploadAlt =
/*#__PURE__*/
React.forwardRef(function UploadAlt(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M17 28H9V9h30v19h-8"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M18 21l6-6 6 6m-6 18V15"
  }), props.children);
});
var Upload =
/*#__PURE__*/
React.forwardRef(function Upload(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M9 17V9h30v8"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M18 23l6-6 6 6m-6 16V17"
  }), props.children);
});
var UserAnalytics =
/*#__PURE__*/
React.forwardRef(function UserAnalytics(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M18 32v5h21V11H18v3m9 9c0 4.971-4.029 9-9 9s-9-4.029-9-9 4.029-9 9-9 9 4.029 9 9zm3-8h6m-6 3h6m-6 3h6m0 16V24h-4v13m-2 0v-6h-4v6m-1.313-8a7.617 7.617 0 0 0-5.293-3.852c1.624-.582 2.793-2.119 2.793-3.943a4.204 4.204 0 1 0-8.408 0 4.19 4.19 0 0 0 2.793 3.943A7.554 7.554 0 0 0 11.314 29"
  }), props.children);
});
var UserInsights =
/*#__PURE__*/
React.forwardRef(function UserInsights(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M18.538 24.05a3.229 3.229 0 0 1 0-4.599 3.254 3.254 0 0 1 4.601 0l.861.851.86-.851a3.256 3.256 0 0 1 4.602 0 3.23 3.23 0 0 1 0 4.599L24 29.502l-5.462-5.452zM36 15V9m-3 3h6M12 39v-6m-3 3h6m15-24H14c-1.1 0-2 .9-2 2v16m6 6h16c1.1 0 2-.9 2-2V18"
  }), props.children);
});
var UserSearch =
/*#__PURE__*/
React.forwardRef(function UserSearch(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M26.999 13.609c5.739 3.313 7.705 10.651 4.392 16.39s-10.651 7.705-16.39 4.392-7.705-10.651-4.392-16.39 10.651-7.705 16.39-4.392zM39 34.391L31.394 30M28 33.752v-1.289c0-3.3-2.287-6.06-5.36-6.799a4.013 4.013 0 0 0 2.378-3.662 4.02 4.02 0 0 0-8.038 0c0 1.634.979 3.033 2.379 3.662-3.073.739-5.359 3.499-5.359 6.799v1.283"
  }), props.children);
});
var Vancouver =
/*#__PURE__*/
React.forwardRef(function Vancouver(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M20 26.006a2 2 0 0 1-2-2h20a2 2 0 0 1-2 2H20z"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M28 16.006l4 8m-7-2l-1 2"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M36 15.006v6"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M24 18.006h-8L14 15h-3l2 5.006 11 2h10v-2l2-2"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M32 18.006h5m-13 0c2.209-2.667 5.791-2.667 8 0v2h-7l-1-2m-9 19c-1.105 1.333-2.895 1.333-4 0m8 0c-1.105 1.333-2.895 1.333-4 0m8 0c-1.105 1.333-2.895 1.333-4 0m8 0c-1.105 1.333-2.895 1.333-4 0m8 0c-1.105 1.333-2.895 1.333-4 0m8 0c-1.105 1.333-2.895 1.333-4 0m8 0c-1.105 1.333-2.895 1.333-4 0m-24 0c-.552.667-1.276 1-2 1m2-8a2 2 0 1 1 4 0m-4 2a1 1 0 0 1 0-2"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M15 30.006a1 1 0 0 1 2 0"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M18 30.006a1 1 0 0 1 0 2m0-2h-1m1 2h-7"
  }), props.children);
});
var VideoAlt =
/*#__PURE__*/
React.forwardRef(function VideoAlt(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M39 39H9m30-29H9v22h30V10zm-18.995 5.799v10.392l9-5.196-9-5.196z"
  }), props.children);
});
var VideoChat =
/*#__PURE__*/
React.forwardRef(function VideoChat(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    d: "M37 10.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0zm-2.5-.5a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1zm-2 0a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1z"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M39 39H9V9h30v30zM9 12h30m-4 27v-1c0-5.038-3.837-9.259-8.534-10.372A6.076 6.076 0 0 0 24 16a6.074 6.074 0 1 0-2.466 11.628C16.835 28.741 13 32.962 13 38v1"
  }), props.children);
});
var VideoPlay =
/*#__PURE__*/
React.forwardRef(function VideoPlay(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M26 24l-9 5.181V18.789L26 24zm5-4v-7H9v22h22v-7l8 4.676v-17.32L31 20z"
  }), props.children);
});
var Video =
/*#__PURE__*/
React.forwardRef(function Video(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M31 35H9V13h22v7l8-4.645v17.321L31 28v7z"
  }), props.children);
});
var Virus =
/*#__PURE__*/
React.forwardRef(function Virus(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M29.578 15.552a4 4 0 1 1 4 6.928M22.918 24a4 4 0 1 0-6.927 3.999A4 4 0 0 0 22.918 24zm10.392-6a2 2 0 1 0-3.464 2.002A2 2 0 0 0 33.31 18zm.268 4.48c-1.732 1-3.714 1.567-4.58 2.067-.866.5-2.408 1.879-2.802 3.35m10.579-11.881l-1.732 1m-15.589 0v2m2.829-1.668l.466 1.945m1.749-2.54l1 1.732m2.183-1.658l-1.356-1.47M28.376 27.9l-1.451-1.376m2.073-1.977l1 1.732m2.123-.884l-.596-1.909m-16.571-5.264l1 1.732m-2.562 2.562l-1.732-1m-1.206 4.5h2m-.794 4.5l1.732-1m1.562 4.294l1-1.732m3.5 2.938v-2m4.5.794l-1-1.732m4.294-1.562l-1.732-1m9.062-15.696l-1 1.732m-2-2.536v2m-3-1.196l1 1.732m5 8.66l-1-1.732m3.197-.464l-1.732-1m2.535-2h-2m-14.391.218a7 7 0 1 0 5.01 8.662m-5-8.659c1.471.394 3.436-.251 4.302-.751.866-.5 2.348-1.933 4.08-2.933"
  }), props.children);
});
var Vision =
/*#__PURE__*/
React.forwardRef(function Vision(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M14.121 33.879l4.242-4.242m11.272-11.271l4.515-4.515M11.999 9a3 3 0 1 0 0 6 3 3 0 0 0 0-6zm0 24a3 3 0 1 0 0 6 3 3 0 0 0 0-6zm24 0a3 3 0 1 0 0 6 3 3 0 0 0 0-6zm-24 2.001a1 1 0 1 0 0 2 1 1 0 0 0 0-2zM35.999 9a3 3 0 1 0 0 6 3 3 0 0 0 0-6zm0 2.001a1 1 0 1 0 0 2 1 1 0 0 0 0-2zM24 19a5 5 0 1 0 .001 10.001A5 5 0 0 0 24 19zm0 2.001a3 3 0 1 0 0 6 3 3 0 0 0 0-6zm-11 3.001s3 7 11 7 11-7 11-7-3-7-11-7-11 6.999-11 7z"
  }), props.children);
});
var VisualInsights =
/*#__PURE__*/
React.forwardRef(function VisualInsights(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M39.464 15h-6.928L36 9l3.464 6zM39 33h-6v6h6v-6zm-3-12a3 3 0 1 0 0 6 3 3 0 0 0 0-6zm-11 2.992h8m1.268-12H29v24h4m-8.044-6.988L21.011 25l-1.906 1.993-5.101-4.996L9 27.002M25 16H9v16h16V16zm-5.5 2.999A1.5 1.5 0 1 0 19.501 22a1.5 1.5 0 0 0-.001-3z"
  }), props.children);
});
var VisualRecognition =
/*#__PURE__*/
React.forwardRef(function VisualRecognition(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M25 17a8 8 0 1 1-16 0 8 8 0 0 1 16 0zm-1.073-4H18v3.24h6.963M24.746 19H14v3h9.244M16 24.937V39h23V16H24.936M33 20a2 2 0 1 0-.001 3.999A2 2 0 0 0 33 20zm6 15l-5-5-3 3-7-7-8 8"
  }), props.children);
});
var WarningAlt =
/*#__PURE__*/
React.forwardRef(function WarningAlt(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M16.511 37C12.021 34.408 9 29.557 9 24c0-8.284 6.716-15 15-15s15 6.716 15 15c0 5.557-3.022 10.408-7.512 13M24 32V14"
  }), React.createElement("circle", {
    cx: "24",
    cy: "37.5",
    r: "1"
  }), props.children);
});
var Warning =
/*#__PURE__*/
React.forwardRef(function Warning(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M39 37H9l15-26 15 26zm-15-9V18"
  }), React.createElement("circle", {
    cx: "24",
    cy: "32",
    r: "1"
  }), props.children);
});
var Washer =
/*#__PURE__*/
React.forwardRef(function Washer(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M37 39H11V9h26v30zM24 18a7 7 0 1 0 0 14 7 7 0 0 0 0-14zm4-6h6M17.291 27H30.71"
  }), props.children);
});
var WashingtonDcCapitol =
/*#__PURE__*/
React.forwardRef(function WashingtonDcCapitol(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M18 34h12m-14 2h16m7-14H9"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M39 25H9m27 6v-2m0-1v-2m2 5v-2m0-1v-2m-2-2v-1m-4 1v-1m-8-8v-1m2 1v-1m-4 1v-1m4 4v-1m2 1v-1m-4 1v-1m-2 1v-1m-2 1v-1m-4 7v-1m-4 1v-1m22 8v-2m0-1v-2m-2 5v-2m0-1v-2m-8 6v-4m-6 4v-7m4 7v-7m4 7v-7m2 7v-7m2 7v-7m-16 6v-2m0-1v-2m2 5v-2m0-1v-2m-4 5v-2m0-1v-2m-2 5v-2m0-1v-2"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M18 25l6-3 6 3m0-6H18m11-3H19"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M30 19v3m-2-3v3m-2-3v3m3-6v3m-10-3v3m5 0v3m-2-3v3m-2-3v3m-2-3v3m2-6a4 4 0 0 1 8 0"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M24 9v3"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M9 32h30m-21 0h12m-10.083 0v-7"
  }), React.createElement("circle", {
    cx: "14",
    cy: "23.499",
    r: ".5"
  }), React.createElement("circle", {
    cx: "10",
    cy: "23.499",
    r: ".5"
  }), React.createElement("circle", {
    cx: "34",
    cy: "23.499",
    r: ".5"
  }), React.createElement("circle", {
    cx: "38",
    cy: "23.499",
    r: ".5"
  }), props.children);
});
var WashingtonDcMonument =
/*#__PURE__*/
React.forwardRef(function WashingtonDcMonument(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M22 38V13l2-4 2 4v25"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M18 30v8m14-8v8m-18-8v8m22-8v8m-8-8v8"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M9 38h30"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M18 30h2v2h-2zm-4 0h2v2h-2z"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M10 30v8"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M10 30h2v2h-2zm18 0h2v2h-2zm4 0h2v2h-2zm4 0h2v2h-2z"
  }), props.children);
});
var WashingtonDc =
/*#__PURE__*/
React.forwardRef(function WashingtonDc(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M29 22H19"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M28 20h-8m8 0v4m-2-2v2m-2-2v2m-2-2v2m-2 0v-4m0 0a4 4 0 0 1 8 0m-4-6v2"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M9 24h30"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M32 24V12l1-2 1 2v12"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M30 30a4 4 0 0 1 8 0m-18 0a4 4 0 0 1 8 0m-18 0a4 4 0 0 1 8 0m-4 5c-1.105 1.333-2.895 1.333-4 0m8 0c-1.105 1.333-2.895 1.333-4 0m8 0c-1.105 1.333-2.895 1.333-4 0m8 0c-1.105 1.333-2.895 1.333-4 0m8 0c-1.105 1.333-2.895 1.333-4 0m8 0c-1.105 1.333-2.895 1.333-4 0m8 0c-1.105 1.333-2.895 1.333-4 0m-18-3c-1.105 1.333-2.895 1.333-4 0m8 0c-1.105 1.333-2.895 1.333-4 0m8 0c-1.105 1.333-2.895 1.333-4 0m8 0c-1.105 1.333-2.895 1.333-4 0m8 0c-1.105 1.333-2.895 1.333-4 0m8 0c-1.105 1.333-2.895 1.333-4 0"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M14 18v6"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M14 18h2v2h-2z"
  }), props.children);
});
var WatsonAvatar =
/*#__PURE__*/
React.forwardRef(function WatsonAvatar(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M9.001 18.664l2.973 1.716m5.083-5.083l-1.716-2.973M24 10.004v3.432m8.66-1.111l-1.716 2.973m5.082 5.082l2.973-1.716M18.568 36.581c5.045 2.913 11.495 1.184 14.408-3.861 2.913-5.045 1.184-11.495-3.861-14.408m0 0a10.516 10.516 0 0 0-7.961-1.065m-7.57 12.656a10.517 10.517 0 0 0 4.984 6.678m10.546-18.267c-2.249-1.299-6.433 1.737-9.345 6.781s-3.449 10.185-1.2 11.484m2.244-16.844c-2.753-.182-5.081.668-6.149 2.518-1.839 3.185.759 8.128 5.802 11.04s10.623 2.69 12.462-.495"
  }), props.children);
});
var Weather =
/*#__PURE__*/
React.forwardRef(function Weather(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M20.698 38l2.309-4h-2.309l2.309-4"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M12.698 34l2.309-4m1.691 4l2.309-4m.414-17.329c-.58-.22-1.093-.25-1.75-.25a5.25 5.25 0 0 0-5.25 5.25m5.25-7.126V9m-3.563 2.5l-.773-1.338m-3.173 3.173l1.338.773m9.733-2.608l.773-1.338m-11.461 7.509H9m30 5.087A5.242 5.242 0 0 1 33.758 28H15.356C12.936 28 11 26.038 11 23.619c0-2.42 1.936-4.381 4.356-4.381.789 0 1.527.211 2.166.576A7.536 7.536 0 0 1 25.039 13a7.531 7.531 0 0 1 7.034 4.797 5.214 5.214 0 0 1 1.684-.282A5.244 5.244 0 0 1 39 22.758zm-9.699 7.535l1.414 1.414m-1.414 0l1.414-1.414m1.586 4l1.414 1.414m-1.414 0l1.414-1.414m-6.414 0l1.414 1.414m-1.414 0l1.414-1.414m6.992-2.578l-1.414-1.414m1.414 0l-1.414 1.414"
  }), props.children);
});
var WebDeveloper =
/*#__PURE__*/
React.forwardRef(function WebDeveloper(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    d: "M27.49 11a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0zm-2.5-.5a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1zm-2 0a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1z"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M24 28H9V9h20v11M9 13h20m-18.011 3h8m-7.999 3h8m-8 3h8M39 40c0-4.625-3.156-8.495-7.42-9.638a5.499 5.499 0 0 0 2.91-4.852c0-3.038-2.463-5.511-5.501-5.511s-5.501 2.473-5.501 5.511a5.5 5.5 0 0 0 2.91 4.852C22.133 31.505 19 35.375 19 40"
  }), props.children);
});
var Webcast =
/*#__PURE__*/
React.forwardRef(function Webcast(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M39 39H9m30-29H9v22h30V10zm-6 22v-1h0c0-4.123-3.138-7.574-6.982-8.485A4.972 4.972 0 0 0 24 13a4.971 4.971 0 1 0-2.019 9.515C18.137 23.426 15 26.877 15 31h0v1"
  }), props.children);
});
var Wheat =
/*#__PURE__*/
React.forwardRef(function Wheat(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M22 11v20a5 5 0 0 1-10 0V11m5-2v30m-5-9.887L17 32l5-2.887m-10-4.92l5 2.887 5-2.887m-10-5.08L17 22l5-2.887m-10-4.974l5 2.887 5-2.887M14.5 10v5.583m5-5.583v5.583M36 11v20a5 5 0 0 1-10 0V11m5-2v30m-5-9.887L31 32l5-2.887m-10-4.92l5 2.887 5-2.887m-10-5.08L31 22l5-2.887m-10-4.974l5 2.887 5-2.887M28.5 10v5.583m5-5.583v5.583"
  }), props.children);
});
var Wifi =
/*#__PURE__*/
React.forwardRef(function Wifi(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M9 18.324A22.142 22.142 0 0 1 23.998 12.5 22.144 22.144 0 0 1 39 18.328m-3.934 3.934a16.606 16.606 0 0 0-11.07-4.207 16.605 16.605 0 0 0-11.064 4.202M31.128 26.2a11.067 11.067 0 0 0-7.13-2.589c-2.711 0-5.196.971-7.125 2.585m7.127 3.3a3.002 3.002 0 1 0 0 6.004 3.002 3.002 0 0 0 0-6.004z"
  }), props.children);
});
var WindPower =
/*#__PURE__*/
React.forwardRef(function WindPower(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M25.932 21.483a1.999 1.999 0 1 1-3.863 1.035 1.999 1.999 0 1 1 3.863-1.035zM20.635 9.444l2.847 10.625m-8.674 11.124l7.778-7.778m13.971 1.95l-10.625-2.847M24 26v11m2 2a2 2 0 1 0-4 0h4z"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M9 39h30M15.055 23A8.966 8.966 0 0 0 16 26.128m14.708 1.873A8.99 8.99 0 0 0 32 26.127m-5.004-12.616A8.98 8.98 0 0 0 24 13m7 18.748a12.048 12.048 0 0 0 4-4.945m-5-15.197a11.95 11.95 0 0 0-7-1.564M12.041 21c-.027.33-.041.664-.041 1.001a11.944 11.944 0 0 0 2 6.636"
  }), props.children);
});
var Windows =
/*#__PURE__*/
React.forwardRef(function Windows(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M13 20V9h26v19h-4M13 12h26m-4 8H9v19h26V20zM9 23h26"
  }), React.createElement("path", {
    d: "M37 10.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0zm-2.5-.5a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1zm-2 0a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1zm0 11a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1zm-2 0a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1zm-2 0a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1z"
  }), props.children);
});
var Windy =
/*#__PURE__*/
React.forwardRef(function Windy(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M25 16a4 4 0 1 1 4 4H14m4 12a4 4 0 1 0 4-4H11m20 0a4 4 0 1 0 4-4H9"
  }), props.children);
});
var Wine =
/*#__PURE__*/
React.forwardRef(function Wine(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M13 25h6v10h-6m14-14l-1 6.485c0 2.495 2.005 4.518 4.5 4.518S35 29.98 35 27.485L34 21h-7zm3.5 11.002V39m3.5 0h-7m-.95-12h8.9M19 15.528V9h-3v6.528c0 2.375-3 2.6-3 6.911v15.233c0 .734.675 1.328 1.508 1.328h5.985c.833 0 1.508-.594 1.508-1.327V22.439c0-4.311-3.001-4.535-3.001-6.911z"
  }), props.children);
});
var WirelessHome =
/*#__PURE__*/
React.forwardRef(function WirelessHome(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M9 24L24 9h0l15 15m-2-2v-5M11 27v12m26-12v12M9 39h30m-6.365-11.639a12.757 12.757 0 0 0-8.636-3.351 12.757 12.757 0 0 0-8.634 3.349m15.16 2.121A9.791 9.791 0 0 0 23.998 27a9.79 9.79 0 0 0-6.523 2.477M28.4 31.598A6.834 6.834 0 0 0 23.999 30a6.83 6.83 0 0 0-4.398 1.596"
  }), props.children);
});
var WirelessModem =
/*#__PURE__*/
React.forwardRef(function WirelessModem(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    d: "M14 33a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm3-1a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm4 0a1 1 0 1 0 0 2 1 1 0 0 0 0-2z"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M31 18v9m7.925-14.924A11.702 11.702 0 0 0 30.999 9a11.711 11.711 0 0 0-7.924 3.073M36.8 14.205A8.701 8.701 0 0 0 30.998 12a8.7 8.7 0 0 0-5.798 2.202m9.475 2.133A5.707 5.707 0 0 0 30.999 15a5.708 5.708 0 0 0-3.674 1.333M39 27H9v12h30V27z"
  }), props.children);
});
var WreckingBall =
/*#__PURE__*/
React.forwardRef(function WreckingBall(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M18 20.986V17h-2.001"
  }), React.createElement("path", {
    d: "M13 36a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm3-1a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm4 0a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm4 0a1 1 0 1 0 0 2 1 1 0 0 0 0-2z"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M12 33v-2H9V21h10v8h5v4m11.001-5l-.002-13m-18 8H11v4h5.998v-4zM15 17c-1.055 0-2-.688-2-2v-2c0-1.055-.548-1.994-1.86-1.994L11 11c-1.055 0-2-.688-2-2m6 5v-2.458C15 10.486 14.5 9 13 9m-3.5 4v1.11c0 1.055.188 1.89 1.5 1.89m16 20h0c0-1.65-1.35-3-3-3H12c-1.65 0-3 1.35-3 3v0c0 1.65 1.35 3 3 3h12c1.65 0 3-1.35 3-3zm8-8a4 4 0 1 0 0 8 4 4 0 0 0 0-8zm2.254 2.916a2.516 2.516 0 0 0-1.28-1.22M24 31h1.762L35 15M21.389 29l10.899-15.565m-7.876 6.118L29 13m-7.588 6.553L26 13m8.999 2l-2.711-1.565m-2.647 3.78l3.06 1.767m-2.232 3.866l-3.371-1.946m-2.886 4.066l3.775 2.179"
  }), props.children);
});
var Yoga_01 =
/*#__PURE__*/
React.forwardRef(function Yoga_01(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M27.936 18.998l-1.521.001c-.573-.004-1.55-1.074-2.406-1.074h-.016c-.856 0-1.833 1.07-2.406 1.074l-1.521-.001"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M8 39h32M20.002 21.999v2l-3.615 3.396a1.62 1.62 0 0 0 .178 2.277l4.25 3.941c.675.577 2.224.497 2.8-.178a1.62 1.62 0 0 0-.178-2.277l-2.572-2.551s2.03-1.931 2.136-2.037l.996.429v10m4.005-15v15m-4-15h6.881-.04c.689 0 1.247-1.084 1.247-1.773 0-.332-.13-.634-.342-.858 0 0-1.119-1.288-2.196-2.404-1.11-1.184-2.681-1.957-4.297-2.224v.003a3 3 0 0 0 1.783-2.742C27.038 10.343 25.657 9 24 9s-3.036 1.343-3.036 3.001c0 1.224.733 2.274 1.783 2.742v-.003c-1.627.269-3.151 1.035-4.297 2.224-1.076 1.117-2.196 2.404-2.196 2.404a1.243 1.243 0 0 0-.342.858c0 .689.558 1.773 1.247 1.773h-.04 6.883m-.001 0v-4.074M24.002 37a2 2 0 1 0 4 0"
  }), props.children);
});
var Yoga_02 =
/*#__PURE__*/
React.forwardRef(function Yoga_02(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M18 19h-6.5a1.5 1.5 0 0 1 0-3H19m17.5 3a1.5 1.5 0 0 0 0-3h0-11.255c1.082-.482 1.837-1.646 1.837-2.907a3.092 3.092 0 1 0-6.184 0c0 1.261.755 2.425 1.837 2.907h0c-1.59.335-2.735 1.642-2.735 3.27V26v-.001l-9.202 9.202a1.616 1.616 0 0 0-.134 2.272c.588.662 1.61.722 2.271.134L22 29h8v7.5a1.5 1.5 0 0 0 3 0v-8.891c0-.885-.724-1.609-1.609-1.609H27v-7h9.5zM8 38h32"
  }), props.children);
});
var Yoga_03 =
/*#__PURE__*/
React.forwardRef(function Yoga_03(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M22.365 13.123a2.853 2.853 0 0 1 3.01 4.565 2.852 2.852 0 0 1-2.973.902h0c1.501.356 2.593 1.801 2.593 3.412v6.227c-.006.736.305 1.368 1.086 1.989L36.374 36.2"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M8 39h32M21 19v-8.5a1.5 1.5 0 0 0-3 0v14.714c0 4.562 3.739 6.501 3.739 6.501l13.136 7.084a1.5 1.5 0 0 0 1.5-2.598M17 27h-3c-1 0-2 1-2 2v8.5a1.5 1.5 0 0 0 3 0V30h3"
  }), props.children);
});
var Yoga_04 =
/*#__PURE__*/
React.forwardRef(function Yoga_04(props, ref) {
  return React.createElement(Pictogram, _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref
  }, props), React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: ".72",
    d: "M8 39h32M20.5 18v5.961l-7.533 12.563c-.456.773-.197 1.778.576 2.234s1.778.197 2.234-.576l6.259-10.044C22.5 27.5 23 27 23.999 27c1.001 0 1.501.5 1.953 1.135l6.163 10.064a1.636 1.636 0 0 0 2.234.576 1.636 1.636 0 0 0 .576-2.234l-7.424-12.563L27.499 18H35.5a1.5 1.5 0 0 0 0-3h-9.841a3 3 0 1 0-3.317 0H12.5a1.5 1.5 0 0 0 0 3h8z"
  }), props.children);
});

export { ActiveServer, Advocate, Agriculture, AirConditioner, Airplane, Alarm, AlchemyDataNews, AlchemyLanguage, AlchemyLanguageAlphabetAExpanded, AlchemyVision, Americas, AmsterdamCanal, AmsterdamFarm, AmsterdamWindmill, Analyze, AnalyzesData, Apartment, Api, AppDeveloper, Apple, Application, Archive, AsiaAustralia, AugmentedReality, Austin, AutomateModularManagement, Automobile, Bag, Bangalore, Bee, BeijingMunicipal, BeijingTower, BerlinBrandenburg, BerlinCathedral, BerlinTower, Bicycle, Blockchain, Build, Building, Bulldozer, Bus, Cafe, Calendar, CalendarDate, CalendarEvent, Camera, Capitol, Care, Cell, ChartBar, ChartBubbleLine, ChartLine, ChartScatterplot, Cherries, ChipCircuit, ChipCredit, ChipDebit, CloudAnalytics, CloudAssets, CloudBuilderProfessionalServices, CloudComputing, CloudDataServices, CloudDownload, CloudEcosystem, CloudGuidelines, CloudManagedServices, CloudOracle, CloudPartners, CloudPlanning, CloudSap, CloudServices, CloudServicesPricing, CloudStorage, CloudStrategy, CloudTutorials, CloudUpload, CloudVmware, Cloudy, CloudyDewy, CloudyHazy, CloudyHumid, CloudyPartial, CloudyWindy, CoatHanger, CognosAnalytics, College, ConceptExpansion, ConceptInsights, Connect, Console, ConsoleWireless, Construct, Conversation, CopenhagenPlanetarium, CopenhagenSnekkja, CreditCard, Crop, CustomerService, DataBackup, DataInsights, DataProcessing, DataStorage, Delete, DeliverInsights, DeliveryTruck, DesignAndDevelopment_01, DesignAndDevelopment_02, Desktop, Devops, Dialogue, Digital, Dining, Dna, DoNot, Docker, Doctor, DocumentConversion, DoorHandle, Download, DownloadAlt, DubaiPalmIslands, DubaiSkyscraper, DublinBrewery, DublinCastle, DuplicateFile, Education, Electric, ElectricCharge, Elevator, Embed, Engine, EnterpriseDesignThinking, EnterpriseDesignThinkingAlt, Envelope, ErlenmeyerFlask, EscalatorDown, EscalatorUp, EuropeAfrica, ExpandHorz, ExpandUser, ExpandVert, Export, ExportAlt, Eye, FaceDissatisfied, FaceNeutral, FaceSatisfied, FaceVeryDissatisfied, FaceVerySatisfied, Factory, Farm, Faucet, Feedback, FileBackup, FileTransfer, FinancialConsultant, FinancialGain, FinancialNews, FireAlarm, FireExtinguisher, Firewall, FlowChart, FlowChartDetail, Fog, Folder, Forklift, FreeTrial, Fuel, Gear, GlobalBusinessServices, GlobalFinanceEuro, GlobalFinanceSterling, GlobalNetwork, GlobalTechnologyServices, Globe, GlobeLocations, Group, Hail, HailHeavy, HailMixed, Handicap, HandicapActive, HardDrive, HardDriveNetwork, HardIceCream, Hazy, Headphones, Heart, HeartHealth, HeatMap, HighFive, HomeFront, HomeGarage, HomeProfile, Hospital, Humid, Hurricane, HybridCloud, HybridCloudServices, IbmIx, IbmZ, Idea, Ideate, Innovate, Integration, Intelligence, Intercom, IotMunich, Java, Javascript, Justice, KeyUsers, KnowsDarkData, Language, LanguageTranslation, LanguageTranslationAlphabetAExpanded, Language_01, Language_02, Language_03, Language_04, Launch, Lightning, ListBullet, ListCheckbox, Location, Lock, LockAlt, LockedNetwork, LockedNetworkAlt, London, LondonBigBen, LondonExpandedBase, Lungs, MachineLearning_01, MachineLearning_02, MachineLearning_03, MachineLearning_04, MachineLearning_05, MachineLearning_06, MadridCathedral, MadridSkyscrapers, MadridStatue, Magnify, Marketplace, Mas, Maximize, Medical, MedicalCharts, MedicalStaff, Melbourne, Meter, Microorganisms, Microscope, Minimize, MobileAdd, MobileChat, MobileDevices, MobilePhone, MortarAndPestle, Moscow, Mqa, Multitask, Munich, NaturalLanguageClassifier, Network, NetworkServices, Networking_01, Networking_02, Networking_03, Networking_04, Networking_05, Nice, NightClear, NycBrooklyn, NycManhattan, NycManhattanAlt, Office, OilPump, OilRig, Overcast, PaperClip, Parliament, PartnerRelationship, Path, Pattern, Perfume, Person_01, Person_02, Person_03, Person_04, Person_05, Person_06, Person_07, Person_08, Person_09, PersonalityInsights, PetriCulture, Pictogram, PillBottle_01, Pills, Podcast, Police, Power, Presentation, Presenter, Price, Printer, PrivateNetwork, PrivateNetworkAlt, PrivateNetworkAlt_01, PrivateNetwork_01, Progress, Puzzle, Question, QuestionAndAnswer, Rainy, RainyHeavy, Rank, Receipt, Recycle, Refinery, Refresh, RelationshipExtraction, Renew, RenewTeam, Repeat, Report, Reset, ResetHybridCloud, ResetSettings, RetrieveAndRank, RichTextFormat, Robot, Robotics, Rome, SaasEnablement, SanFrancisco, SanFranciscoFog, SaoPaulo, SaoPauloExpandedBase, Satellite, SatelliteDish, Scale, Seattle, SecureData, SecureProfile, Security, SecurityShield, ServerRack, Servers, Shop, ShoppingCart, Shower, Singapore, SingleSignOn, Slider, Sneaker, Snow, SoftIceCream, SoftlayerEnablement, Solve, Spaceship, Speech, SpeechAlphabetAExpanded, SpeechToText, Speedometer, StairsPlanView, StationaryBicycle, Steel, SteeringWheel, Stethoscope, Strategy, StrategyDirect, StrategyMove, StrategyPlay, Streamline, Sunny, SunnyHazy, SupportServices, SwipeLeft, SwipeRight, Tags, Target, TargetArea, TelAviv, Telecom, Telephone, Television, TemperatureHigh, TemperatureLow, Tennis, TestTubes, TextToSpeech, Time, TimeLapse, Toggle, TokyoCherryBlossom, TokyoGates, TokyoTemple, TokyoVolcano, ToneAnalyzer, Tools, Tornado, Toronto, Touch, TouchGesture, TouchId, TouchScreen, TouchSwipe, Tractor, TradeoffAnalytics, Train, Transform, Trash, University, Unlock, UnlockAlt, Upload, UploadAlt, UserAnalytics, UserInsights, UserSearch, Vancouver, Video, VideoAlt, VideoChat, VideoPlay, Virus, Vision, VisualInsights, VisualRecognition, Warning, WarningAlt, Washer, WashingtonDc, WashingtonDcCapitol, WashingtonDcMonument, WatsonAvatar, Weather, WebDeveloper, Webcast, Wheat, Wifi, WindPower, Windows, Windy, Wine, WirelessHome, WirelessModem, WreckingBall, Yoga_01, Yoga_02, Yoga_03, Yoga_04 };
